import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AccountNumberInput = {
  /** User account number/wallet */
  account: Scalars['String'];
  /** Confirmation checkbox */
  accountConfirmationBox: Scalars['Int'];
  /** User account type, what to update */
  accountType: ValidAccountNumberTypes;
  /** Address info used by some account types */
  address1?: InputMaybe<Scalars['String']>;
  /** Additional address info used by some account types */
  address2?: InputMaybe<Scalars['String']>;
  /** Additional address info used by some account types */
  city?: InputMaybe<Scalars['String']>;
  /** country used by some account types */
  countryId?: InputMaybe<Scalars['ID']>;
  /** County info used by some account types */
  county?: InputMaybe<Scalars['String']>;
  /** Date of birth used by some account types */
  dateOfBirth?: InputMaybe<Scalars['String']>;
  /** email used by some account types */
  email?: InputMaybe<Scalars['String']>;
  /** first name used by some account types */
  firstName?: InputMaybe<Scalars['String']>;
  /** last name used by some account types */
  lastName?: InputMaybe<Scalars['String']>;
  /** postcode used by some account types */
  postcode?: InputMaybe<Scalars['String']>;
  /** User secret password for validation */
  secretPassword: Scalars['String'];
};

export type AccountNumberResult = {
  __typename?: 'AccountNumberResult';
  /** Validation result */
  result: ValidationResult;
  /** Was updated success */
  success: Scalars['Boolean'];
};

export type ActivatePackageResult = {
  __typename?: 'ActivatePackageResult';
  /** Result */
  result: ValidationResult;
  /** Was package activation success */
  success: Scalars['Boolean'];
};

export type ActivateStarterKitPackageResult = QueryResultInterface & {
  __typename?: 'ActivateStarterKitPackageResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type ActiveRanksResult = QueryResultInterface & {
  __typename?: 'ActiveRanksResult';
  data?: Maybe<Array<Maybe<UserRank>>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type ActiveTeam = TeamInterface & {
  __typename?: 'ActiveTeam';
  blockedMembers: Array<TeamBlockedMember>;
  createdDate: Scalars['String'];
  details: Array<TeamDetails>;
  draftDetails: Array<TeamDetails>;
  id: Scalars['ID'];
  members: TeamMembersResult;
  membersCount: Scalars['Int'];
  membersJoinedThisWeek: Scalars['Int'];
  news: TeamNewsResult;
  owner: TeamMember;
  presidentsClubMembers: Array<TeamMember>;
  resources: Array<TeamResource>;
  role: TeamMemberRole;
  status: TeamStatus;
};


export type ActiveTeamMembersArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  type?: InputMaybe<TeamMemberRole>;
};


export type ActiveTeamNewsArgs = {
  lastId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
};


export type ActiveTeamResourcesArgs = {
  statuses: Array<TeamResourceStatus>;
};

export type AffiliateAgreementResult = {
  __typename?: 'AffiliateAgreementResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

/** Affiliate Result */
export type AffiliateResult = {
  __typename?: 'AffiliateResult';
  /** Validation result */
  result: ValidationResult;
  /** User if affiliate was found */
  user?: Maybe<User>;
};

/** Allow cash account in purchase */
export enum AllowCashAccountPurchase {
  NO = 'NO',
  YES = 'YES'
}

export enum ApprovedTypes {
  /** Document is approved */
  APPROVED = 'Approved',
  /** Document is denied */
  DENIED = 'Denied',
  /** Document is still pending */
  PENDING = 'Pending'
}

export type AssignTicketInput = {
  receiverUsername: Scalars['String'];
  secretPassword: Scalars['String'];
  ticketId: Scalars['Int'];
};

/** Authentication status result */
export type AuthenticationStatusResult = {
  __typename?: 'AuthenticationStatusResult';
  /** Is JWT expired (native app) */
  isJwtExpired?: Maybe<Scalars['Boolean']>;
  /** Is the user currently logged in */
  isLoggedIn: Scalars['Boolean'];
  /** Is session expired */
  isSessionExpired: Scalars['Boolean'];
  /** Time left in seconds when session will be expired */
  sessionTimeout?: Maybe<Scalars['Int']>;
};

export type BulkPackageInput = {
  Advanced?: InputMaybe<Scalars['Int']>;
  Basic?: InputMaybe<Scalars['Int']>;
  Beginner?: InputMaybe<Scalars['Int']>;
  Booster?: InputMaybe<Scalars['Int']>;
  Builder?: InputMaybe<Scalars['Int']>;
  Expert?: InputMaybe<Scalars['Int']>;
  Explorer?: InputMaybe<Scalars['Int']>;
  Master?: InputMaybe<Scalars['Int']>;
  Mentor?: InputMaybe<Scalars['Int']>;
  Premium?: InputMaybe<Scalars['Int']>;
  Pro?: InputMaybe<Scalars['Int']>;
  Promo200?: InputMaybe<Scalars['Int']>;
  Promo350?: InputMaybe<Scalars['Int']>;
  Promo850?: InputMaybe<Scalars['Int']>;
  Promo1250?: InputMaybe<Scalars['Int']>;
  Rookie?: InputMaybe<Scalars['Int']>;
  Specialist?: InputMaybe<Scalars['Int']>;
};

export type BulkStarterKitPackageInput = {
  GIFTCARD?: InputMaybe<GiftCardInputObject>;
  STARTER7?: InputMaybe<StarterKitInputObject>;
};

export type BurnedDags = {
  __typename?: 'BurnedDags';
  createdAt: Scalars['String'];
  dags: Scalars['String'];
  id: Scalars['String'];
  ownerId: Scalars['String'];
  scr: Scalars['String'];
};

export type BurnedDagsD2T = {
  __typename?: 'BurnedDagsD2T';
  createdAt: Scalars['String'];
  dags: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isSent: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['String'];
  scr: Scalars['String'];
};

export enum BusinessFeeUpgradeMethods {
  ACTIVATION_CODE = 'ACTIVATION_CODE',
  CASH = 'CASH',
  FREE = 'FREE'
}

export type BuyStarterKitInput = {
  activationCode?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
};

export type BuyStarterKitResult = {
  __typename?: 'BuyStarterKitResult';
  id?: Maybe<Scalars['Int']>;
  initializePayment: Scalars['Boolean'];
  stripeSessionId?: Maybe<Scalars['String']>;
};

export type CanUserClaimCoinsResult = {
  __typename?: 'CanUserClaimCoinsResult';
  course: UserCoursesMap;
  /** Validation result */
  result: ValidationResult;
  /** Was company update query success */
  success: Scalars['Boolean'];
};

export type CancelExchangeOrderInput = {
  /** Exchange order unique identifier */
  id: Scalars['Int'];
  /** User secret password for validation */
  secretPassword: Scalars['String'];
};

export type Cart = {
  __typename?: 'Cart';
  cartItems: Array<CartItems>;
  createdDate: Scalars['String'];
  id: Scalars['Int'];
  ownerId?: Maybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  shippingCountryId?: Maybe<Scalars['Int']>;
  shippingInformation?: Maybe<Scalars['String']>;
  shippingPrice: Scalars['Float'];
  shippingStatus: CartShippingStatus;
  status: CartStatus;
  totalPrice: Scalars['Float'];
  totalQuantity: Scalars['Int'];
  updatedDate: Scalars['String'];
};

export type CartInfoInput = {
  serviceCode: Scalars['String'];
  servicePeriod: Scalars['String'];
};

export type CartItems = {
  __typename?: 'CartItems';
  cartId: Scalars['Int'];
  color?: Maybe<ProductColor>;
  createdDate: Scalars['String'];
  id: Scalars['Int'];
  images: Array<FileType>;
  neckline?: Maybe<ProductNecklines>;
  price: Scalars['Float'];
  productId: Scalars['Int'];
  productName: Scalars['String'];
  quantity: Scalars['Int'];
  size?: Maybe<ProductSize>;
  updatedDate: Scalars['String'];
};

export enum CartShippingStatus {
  PENDING = 'PENDING',
  SENT = 'SENT',
  UNSENT = 'UNSENT'
}

export enum CartStatus {
  FAILED = 'FAILED',
  NEW = 'NEW',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export type CashAccountFields = {
  __typename?: 'CashAccountFields';
  latest?: Maybe<LatestCashAccountResult>;
  transactions?: Maybe<CashAccountResult>;
};


export type CashAccountFieldsLatestArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type CashAccountFieldsTransactionsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type CashAccountMutation = {
  __typename?: 'CashAccountMutation';
  convertToUSDS?: Maybe<CashAccountTransactionResult>;
  transferToTradingAccount?: Maybe<CashAccountTransactionResult>;
  transferToUser?: Maybe<CashAccountTransactionResult>;
  withdraw?: Maybe<CashAccountTransactionResult>;
};


export type CashAccountMutationConvertToUsdsArgs = {
  amount: Scalars['Float'];
  secretPassword: Scalars['String'];
};


export type CashAccountMutationTransferToTradingAccountArgs = {
  amount: Scalars['Float'];
  secretPassword: Scalars['String'];
};


export type CashAccountMutationTransferToUserArgs = {
  amount: Scalars['Float'];
  secretPassword: Scalars['String'];
  username: Scalars['String'];
};


export type CashAccountMutationWithdrawArgs = {
  amount: Scalars['Float'];
  method: ValidUserAccountTypes;
  secretPassword: Scalars['String'];
};

export type CashAccountResult = QueryResultInterface & {
  __typename?: 'CashAccountResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
  transactions?: Maybe<Array<CashAccountTransaction>>;
};

export type CashAccountTransaction = {
  __typename?: 'CashAccountTransaction';
  amount: Scalars['Float'];
  currencyCode: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  transactionDate: Scalars['String'];
  transactionStatus: CashAccountTransactionStatus;
  transactionType: CashAccountTransactionType;
};

export type CashAccountTransactionResult = QueryResultInterface & {
  __typename?: 'CashAccountTransactionResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export enum CashAccountTransactionStatus {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SUCCESS = 'SUCCESS'
}

export enum CashAccountTransactionType {
  CONSISTENCY_BONUS = 'CONSISTENCY_BONUS',
  CONVERT_TO_USDS = 'CONVERT_TO_USDS',
  CREDIT = 'CREDIT',
  DEPOSIT = 'DEPOSIT',
  FROM_LINKED_ACCOUNT = 'FROM_LINKED_ACCOUNT',
  KICKSTART_BONUS = 'KICKSTART_BONUS',
  MEMBER_TO_MEMBER = 'MEMBER_TO_MEMBER',
  PURCHASE_OF_ACTIVATION_CODE = 'PURCHASE_OF_ACTIVATION_CODE',
  PURCHASE_OF_COINS = 'PURCHASE_OF_COINS',
  PURCHASE_OF_EVENT_TICKET = 'PURCHASE_OF_EVENT_TICKET',
  PURCHASE_OF_FOUNDER_PACKAGE = 'PURCHASE_OF_FOUNDER_PACKAGE',
  PURCHASE_OF_GIFT_CARD = 'PURCHASE_OF_GIFT_CARD',
  PURCHASE_OF_MOVIL_TOKEN = 'PURCHASE_OF_MOVIL_TOKEN',
  PURCHASE_OF_STARTER_KIT = 'PURCHASE_OF_STARTER_KIT',
  PURCHASE_OF_STARTER_KIT_CODE = 'PURCHASE_OF_STARTER_KIT_CODE',
  SALE_OF_COINS = 'SALE_OF_COINS',
  SPECIAL_BONUS = 'SPECIAL_BONUS',
  TO_LINKED_ACCOUNT = 'TO_LINKED_ACCOUNT',
  TRANSFER_TO_SWIPEX = 'TRANSFER_TO_SWIPEX',
  TRANSFER_TO_TRADING_ACCOUNT = 'TRANSFER_TO_TRADING_ACCOUNT',
  WEEKLY_COMMISSION = 'WEEKLY_COMMISSION',
  WITHDRAWAL = 'WITHDRAWAL'
}

export enum CategoriesContentType {
  EVENTS = 'EVENTS',
  NEWS_FEED = 'NEWS_FEED'
}

export type Category = {
  __typename?: 'Category';
  contentId?: Maybe<Scalars['Int']>;
  contentNodes?: Maybe<Array<Maybe<File>>>;
  contentTitle?: Maybe<Scalars['String']>;
  contentType: CategoriesContentType;
  createdDate?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  status: CategoryStatus;
  title: Scalars['String'];
};

export type CategoryListResult = {
  __typename?: 'CategoryListResult';
  data?: Maybe<Array<Category>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export enum CategoryStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

export type CategoryType = {
  __typename?: 'CategoryType';
  contentId?: Maybe<Scalars['Int']>;
  contentNodes?: Maybe<Array<Maybe<FileType>>>;
  contentTitle?: Maybe<Scalars['String']>;
  contentType: CategoriesContentType;
  createdDate?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  status: CategoryStatus;
  title: Scalars['String'];
};

export type ChatMessages = {
  __typename?: 'ChatMessages';
  createdDate: Scalars['String'];
  fromUser: Scalars['String'];
  fromUserId: Scalars['Int'];
  fromUserRankId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  message: Scalars['String'];
  notificationViewed?: Maybe<Scalars['String']>;
  readDate?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  toUser: Scalars['String'];
  toUserId: Scalars['Int'];
  toUserRankId?: Maybe<Scalars['Int']>;
};

/** Link hash results */
export type CheckLinkHashResult = {
  __typename?: 'CheckLinkHashResult';
  isCorrectLinkHash: Scalars['Boolean'];
};

export type ChildrenResult = QueryResultInterface & {
  __typename?: 'ChildrenResult';
  children?: Maybe<Array<UserChildren>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type ClaimMerchantRewardResult = {
  __typename?: 'ClaimMerchantRewardResult';
  /** Validation result */
  result: ValidationResult;
  /** Was query successful */
  success: Scalars['Boolean'];
};

/** Circle Of Champions member */
export type CocMember = {
  __typename?: 'CocMember';
  country?: Maybe<Country>;
  id: Scalars['ID'];
  name: Scalars['String'];
  photoFileId?: Maybe<Scalars['String']>;
  rank?: Maybe<Rank>;
  title?: Maybe<Scalars['String']>;
};

export type CodeBreakerAccess = {
  __typename?: 'CodeBreakerAccess';
  bankBasicUrl?: Maybe<Scalars['String']>;
  bankFullUrl?: Maybe<Scalars['String']>;
  eBookUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kickStarterUrl?: Maybe<Scalars['String']>;
};

export enum CodebreakerPackage {
  BANKPASS = 'BANKPASS',
  BANKVAULT = 'BANKVAULT',
  EBOOK = 'EBOOK'
}

export type CodebreakerPackagePurchase = {
  __typename?: 'CodebreakerPackagePurchase';
  codebreakerContactId?: Maybe<Scalars['String']>;
  codebreakerLoginLink?: Maybe<Scalars['String']>;
  codebreakerUserKey?: Maybe<Scalars['String']>;
  createdDate: Scalars['String'];
  id: Scalars['Int'];
  lastPaid?: Maybe<Scalars['String']>;
  ownerEmail: Scalars['String'];
  ownerId: Scalars['Int'];
  packageName: CodebreakerPackage;
  paymentExpireDate?: Maybe<Scalars['String']>;
  paymentId: Scalars['String'];
  status: CodebreakerPackagePurchaseStatus;
  updatedDate: Scalars['String'];
};

export enum CodebreakerPackagePurchaseStatus {
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  NOT_PAID = 'NOT_PAID',
  PAID = 'PAID',
  PENDING = 'PENDING',
  RECURRING_PAYMENT_FAILED = 'RECURRING_PAYMENT_FAILED'
}

export type CoinAccountFields = {
  __typename?: 'CoinAccountFields';
  transactions?: Maybe<CoinAccountResult>;
};


export type CoinAccountFieldsTransactionsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type CoinAccountMutation = {
  __typename?: 'CoinAccountMutation';
  defi?: Maybe<CoinAccountTransactionResult>;
  escrow?: Maybe<CoinAccountTransactionResult>;
  withdraw?: Maybe<CoinAccountTransactionResult>;
};


export type CoinAccountMutationDefiArgs = {
  amount: Scalars['Float'];
  secretPassword: Scalars['String'];
};


export type CoinAccountMutationEscrowArgs = {
  amount: Scalars['Float'];
  escrowPeriod: Scalars['Int'];
  secretPassword: Scalars['String'];
};


export type CoinAccountMutationWithdrawArgs = {
  amount: Scalars['Float'];
  secretPassword: Scalars['String'];
};

export type CoinAccountResult = QueryResultInterface & {
  __typename?: 'CoinAccountResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
  transactions?: Maybe<Array<CoinAccountTransaction>>;
};

export type CoinAccountTransaction = {
  __typename?: 'CoinAccountTransaction';
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  escrowUntil?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  transactionDate: Scalars['String'];
  transactionStatus: CoinAccountTransactionStatus;
  transactionType: CoinAccountTransactionType;
};

export type CoinAccountTransactionResult = QueryResultInterface & {
  __typename?: 'CoinAccountTransactionResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export enum CoinAccountTransactionStatus {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SUCCESS = 'SUCCESS'
}

export enum CoinAccountTransactionType {
  DEFI_PROJECT = 'DEFI_PROJECT',
  ESCROW = 'ESCROW',
  FROM_LINKED_ACCOUNT = 'FROM_LINKED_ACCOUNT',
  INTERNAL_PAYMENT = 'INTERNAL_PAYMENT',
  MONTHLY_REWARD = 'MONTHLY_REWARD',
  PURCHASE_OF_COINS = 'PURCHASE_OF_COINS',
  REWARDED_COINS = 'REWARDED_COINS',
  SALE_OF_COINS = 'SALE_OF_COINS',
  TO_LINKED_ACCOUNT = 'TO_LINKED_ACCOUNT',
  TRANSFER_COINS_TO_GROW = 'TRANSFER_COINS_TO_GROW',
  TRANSFER_ESCROW_TO_GROW = 'TRANSFER_ESCROW_TO_GROW',
  TRANSFER_FROM_EXCHANGE = 'TRANSFER_FROM_EXCHANGE',
  TRANSFER_FROM_TRADING_ACCOUNT = 'TRANSFER_FROM_TRADING_ACCOUNT',
  TRANSFER_TO_EXCHANGE = 'TRANSFER_TO_EXCHANGE',
  TRANSFER_TO_SWIPEX = 'TRANSFER_TO_SWIPEX',
  WEEKLY_REWARD = 'WEEKLY_REWARD',
  WITHDRAWAL_TO_DAGWALLET = 'WITHDRAWAL_TO_DAGWALLET'
}

export type Commission = {
  __typename?: 'Commission';
  commissionWeek: Scalars['Int'];
  commissionYear: Scalars['Int'];
  currencyCode: Scalars['String'];
  currencyRate: Scalars['Float'];
  customerBonus: Scalars['Float'];
  date: Scalars['String'];
  directCashBonus: Scalars['Float'];
  directCustomerCashBonus: Scalars['Float'];
  directSalesBonus: Scalars['Int'];
  directVolumeCashBonus: Scalars['Float'];
  id: Scalars['Int'];
  leadershipBonus: Scalars['Float'];
  volumeBonus: Scalars['Int'];
  yearweek: Scalars['String'];
};

export type CommissionDetails = {
  __typename?: 'CommissionDetails';
  commission?: Maybe<Commission>;
  customerBonus?: Maybe<Array<UserCustomerBonus>>;
  directSalesBonus?: Maybe<Array<UserDirectSales>>;
  leadershipBonus?: Maybe<Array<LeadershipBonus>>;
  volumeBonus?: Maybe<VolumeBonus>;
};

export type CommissionsData = {
  __typename?: 'CommissionsData';
  customerBonus: Scalars['Float'];
  directCashBonus: Scalars['Float'];
  directCustomerCashBonus: Scalars['Float'];
  directSalesBonus: Scalars['Int'];
  directVolumeCashBonus: Scalars['Float'];
  id: Scalars['Int'];
  leadershipBonus: Scalars['Float'];
  total: Scalars['Float'];
  volumeBonus: Scalars['Int'];
  yearweek: Scalars['String'];
};

export type CommissionsDetailsResult = QueryResultInterface & {
  __typename?: 'CommissionsDetailsResult';
  data: CommissionDetails;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type CommissionsDirectSalesResult = {
  __typename?: 'CommissionsDirectSalesResult';
  totalRows: Scalars['Int'];
  transactions?: Maybe<Array<UserDirectSales>>;
};

export type CommissionsFields = {
  __typename?: 'CommissionsFields';
  details?: Maybe<CommissionsDetailsResult>;
  directSalesBonus: CommissionsDirectSalesResult;
  history?: Maybe<CommissionsResult>;
  list?: Maybe<CommissionsResult>;
};


export type CommissionsFieldsDetailsArgs = {
  id: Scalars['Int'];
};


export type CommissionsFieldsDirectSalesBonusArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type CommissionsFieldsHistoryArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type CommissionsFieldsListArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type CommissionsResult = QueryResultInterface & {
  __typename?: 'CommissionsResult';
  data?: Maybe<Array<Commission>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export type CommissionsStatsResult = {
  __typename?: 'CommissionsStatsResult';
  data: Array<Maybe<Commissionsdata>>;
  error?: Maybe<Scalars['String']>;
  lastWeek: Scalars['Float'];
  total: Scalars['Float'];
};

export type Commissionsdata = {
  __typename?: 'Commissionsdata';
  customerBonus: Scalars['Float'];
  directCashBonus: Scalars['Float'];
  directCustomerCashBonus: Scalars['Float'];
  directSalesBonus: Scalars['Int'];
  directVolumeCashBonus: Scalars['Float'];
  id: Scalars['Int'];
  leadershipBonus: Scalars['Float'];
  total: Scalars['Float'];
  volumeBonus: Scalars['Int'];
  yearweek: Scalars['String'];
};

export type Company = {
  __typename?: 'Company';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['Int']>;
  dateOfIncorporation?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type CompanyInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['Int']>;
  dateOfIncorporation?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  representACompany?: InputMaybe<Scalars['Int']>;
  secretPassword: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

export type CompanyMutation = {
  __typename?: 'CompanyMutation';
  updateCompany: UpdateCompanyResult;
};


export type CompanyMutationUpdateCompanyArgs = {
  data: CompanyInput;
};

export type CompanyQuery = {
  __typename?: 'CompanyQuery';
  data: CompanyResult;
};

export type CompanyResult = QueryResultInterface & {
  __typename?: 'CompanyResult';
  company?: Maybe<Company>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']>;
  codeLong?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type CountryResult = QueryResultInterface & {
  __typename?: 'CountryResult';
  countries?: Maybe<Array<Country>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type Course = {
  __typename?: 'Course';
  activeSlideId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  packageId: Scalars['ID'];
  previewHash: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  totalSlides: Scalars['Int'];
};

export type CourseSlide = {
  __typename?: 'CourseSlide';
  content?: Maybe<Scalars['String']>;
  courseId: Scalars['ID'];
  id: Scalars['ID'];
  status?: Maybe<CourseSlideStatus>;
  template: CourseSlideTemplate;
  title: Scalars['String'];
};

export type CourseSlideListResult = {
  __typename?: 'CourseSlideListResult';
  canView: Scalars['Boolean'];
  items: Array<Maybe<CourseSlide>>;
};

export enum CourseSlideStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum CourseSlideTemplate {
  CONTENT = 'CONTENT',
  COVER = 'COVER',
  FULL_RED = 'FULL_RED',
  SUMMARY = 'SUMMARY',
  TITLE = 'TITLE'
}

export type CreateBulkPackageResult = {
  __typename?: 'CreateBulkPackageResult';
  /** Result */
  result: ValidationResult;
  /** Was package creation success */
  success: Scalars['Boolean'];
};

export type CreateBulkStarterKitPackageResult = {
  __typename?: 'CreateBulkStarterKitPackageResult';
  /** Result */
  result: ValidationResult;
  /** Was package creation success */
  success: Scalars['Boolean'];
};

export type CreateEventTicketsResult = QueryResultInterface & {
  __typename?: 'CreateEventTicketsResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type CreateExchangeInput = {
  /** Amount of coins */
  amount: Scalars['Float'];
  /** Exchange order type */
  orderType: ExchangeOrderType;
  /** One coin price */
  price: Scalars['Float'];
  /** For secret password confirmation */
  secretPassword: Scalars['String'];
};

export type CreateMovilTokenResult = QueryResultInterface & {
  __typename?: 'CreateMovilTokenResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type CreateStarterKitPackageResult = {
  __typename?: 'CreateStarterKitPackageResult';
  /** error */
  error?: Maybe<Scalars['String']>;
  /** created package id */
  id?: Maybe<Scalars['Int']>;
  /** Was package creation success */
  success: Scalars['Boolean'];
};

export type CreateSupportMessageResult = {
  __typename?: 'CreateSupportMessageResult';
  insertId?: Maybe<Scalars['Int']>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type CreateUserFounderPackagesResult = {
  __typename?: 'CreateUserFounderPackagesResult';
  /** Result */
  result: ValidationResult;
  /** Was package creation success */
  success: Scalars['Boolean'];
};

/** Login credentials */
export type CredentialsInput = {
  isForex?: InputMaybe<Scalars['Boolean']>;
  /** Password */
  password: Scalars['String'];
  /** Recaptcha text */
  recaptcha?: InputMaybe<Scalars['String']>;
  /** Username */
  username: Scalars['String'];
};

export type Currency = {
  __typename?: 'Currency';
  code: CurrencyCode;
  exponent: Scalars['Int'];
  sign: Scalars['String'];
};

export enum CurrencyCode {
  DAG = 'DAG',
  EUR = 'EUR',
  USD = 'USD'
}

export type DagPackageEscrowType = {
  __typename?: 'DagPackageEscrowType';
  one: Scalars['Float'];
  three: Scalars['Float'];
  two: Scalars['Float'];
};

export type DagpayCommission = {
  __typename?: 'DagpayCommission';
  commissionWeek: Scalars['Int'];
  commissionYear: Scalars['Int'];
  date: Scalars['String'];
  directCustomerBonus: Scalars['Float'];
  directSalesBonus: Scalars['Float'];
  id: Scalars['Int'];
  leadershipBonus: Scalars['Float'];
  volumeBonus: Scalars['Float'];
  yearweek: Scalars['String'];
};

export type DagpayCommissionDetails = {
  __typename?: 'DagpayCommissionDetails';
  commission?: Maybe<DagpayCommission>;
  directSalesBonus?: Maybe<Array<DagpayUserDirectSales>>;
  leadershipBonus?: Maybe<Array<DagpayLeadershipBonus>>;
  volumeBonus?: Maybe<DagpayVolumeBonus>;
};

export type DagpayCommissionsDetailsResult = QueryResultInterface & {
  __typename?: 'DagpayCommissionsDetailsResult';
  data: DagpayCommissionDetails;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type DagpayCommissionsFields = {
  __typename?: 'DagpayCommissionsFields';
  details?: Maybe<DagpayCommissionsDetailsResult>;
  list?: Maybe<DagpayCommissionsResult>;
};


export type DagpayCommissionsFieldsDetailsArgs = {
  id: Scalars['Int'];
};


export type DagpayCommissionsFieldsListArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type DagpayCommissionsResult = {
  __typename?: 'DagpayCommissionsResult';
  data?: Maybe<Array<DagpayCommission>>;
  totalRows: Scalars['Int'];
};

export type DagpayLeadershipBonus = {
  __typename?: 'DagpayLeadershipBonus';
  cashBonus: Scalars['Float'];
  generationId: Scalars['Int'];
  username: Scalars['String'];
};

export type DagpayUserDirectSales = {
  __typename?: 'DagpayUserDirectSales';
  amount: Scalars['Float'];
  date: Scalars['String'];
  id: Scalars['Int'];
  joinWeek: Scalars['Int'];
  joinYear: Scalars['Int'];
  ownerId: Scalars['Int'];
  packageId: Scalars['Int'];
  team: Scalars['String'];
  userId: Scalars['Int'];
  username: Scalars['String'];
  yearweek?: Maybe<Scalars['String']>;
};

export type DagpayUserVolumeGroup = {
  __typename?: 'DagpayUserVolumeGroup';
  currentWeekLeftTeam?: Maybe<Scalars['Float']>;
  currentWeekRightTeam?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  lastWeekLeftTeam?: Maybe<Scalars['Float']>;
  lastWeekRightTeam?: Maybe<Scalars['Float']>;
  ownerId?: Maybe<Scalars['Int']>;
  volumeWeek?: Maybe<Scalars['Int']>;
  volumeYear?: Maybe<Scalars['Int']>;
  yearweek?: Maybe<Scalars['String']>;
};

export type DagpayUserVolumeGroupResult = {
  __typename?: 'DagpayUserVolumeGroupResult';
  data?: Maybe<Array<Maybe<DagpayUserVolumeGroup>>>;
  totalRows: Scalars['Int'];
};

export type DagpayVolumeBonus = {
  __typename?: 'DagpayVolumeBonus';
  totalVolumeBonus: Scalars['Int'];
  weekEndBalanceLeft: Scalars['Int'];
  weekEndBalanceRight: Scalars['Int'];
};

export type DefaultEventTicketResult = QueryResultInterface & {
  __typename?: 'DefaultEventTicketResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type DigitalProduct = {
  __typename?: 'DigitalProduct';
  accessUrl?: Maybe<Scalars['String']>;
  activeUrl?: Maybe<Scalars['String']>;
  discountPrice?: Maybe<Scalars['Float']>;
  inactiveUrl: Scalars['String'];
  isExternal: Scalars['Boolean'];
  label: Scalars['String'];
  price: Scalars['Int'];
  productId?: Maybe<Scalars['Int']>;
  purchaseType: DigitalProductPurchaseType;
  site?: Maybe<Scalars['String']>;
  status: DigitalProductStatus;
  type: DigitalProductsType;
};

export enum DigitalProductPurchaseType {
  ANNUAL = 'ANNUAL',
  FREE = 'FREE',
  MONTHLY = 'MONTHLY',
  ONE_TIME = 'ONE_TIME'
}

export enum DigitalProductStatus {
  ACTIVE = 'ACTIVE',
  NOT_ACTIVE = 'NOT_ACTIVE'
}

export enum DigitalProductsType {
  BANK_CODE_PASS = 'BANK_CODE_PASS',
  BANK_CODE_VAULT = 'BANK_CODE_VAULT',
  BANK_FOREX = 'BANK_FOREX',
  DAGPAY = 'DAGPAY',
  FOREX = 'FOREX',
  SF_TRAINING = 'SF_TRAINING'
}

export type DirectMembers = QueryResultInterface & {
  __typename?: 'DirectMembers';
  members?: Maybe<Array<User>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

/** Represents user direct sale in system */
export type DirectSale = {
  __typename?: 'DirectSale';
  /** amount */
  amount: Scalars['String'];
  /** sale date */
  date?: Maybe<Scalars['String']>;
  /** Unique system identifier */
  id: Scalars['Int'];
  /** sponsor id */
  ownerId?: Maybe<Scalars['Int']>;
  /** user selected package id */
  packageId: Scalars['String'];
  /** what team was user added */
  team?: Maybe<Scalars['String']>;
  /** added user id */
  userId?: Maybe<Scalars['String']>;
  yearweek?: Maybe<Scalars['String']>;
};

export type DirectSaleStat = {
  __typename?: 'DirectSaleStat';
  joinWeek: Scalars['Int'];
  joinYear: Scalars['Int'];
  leftDirectSales: Scalars['String'];
  rightDirectSales: Scalars['String'];
  yearweek: Scalars['String'];
};

export type DirectSalesResult = {
  __typename?: 'DirectSalesResult';
  /** all user sales */
  items?: Maybe<Array<Maybe<DirectSale>>>;
  /** total members */
  totalRows: Scalars['Int'];
};

export type DirectSalesStatsResult = {
  __typename?: 'DirectSalesStatsResult';
  directSales?: Maybe<Array<Maybe<DirectSaleStat>>>;
  error?: Maybe<Scalars['String']>;
};

/**
 * extend type Query {
 * 	# Lookup users direct sales
 * 	# directSales: DirectSalesResult
 * }
 */
export type Download = {
  __typename?: 'Download';
  category?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Maybe<DownloadFile>>>;
  name?: Maybe<Scalars['String']>;
};

export type DownloadCompensationPlan = {
  __typename?: 'DownloadCompensationPlan';
  category?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['String']>;
  isCompensationPlan?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type DownloadFile = {
  __typename?: 'DownloadFile';
  files?: Maybe<Array<Maybe<File>>>;
  name?: Maybe<Scalars['String']>;
};

export type EcapablePrizes = {
  __typename?: 'EcapablePrizes';
  canRequest: Scalars['Boolean'];
  hasNoAward: Scalars['Boolean'];
  inPending: Scalars['Boolean'];
  isClaimed: Scalars['Boolean'];
  isInFuture: Scalars['Boolean'];
  rankId: Scalars['Int'];
  userNotVerified: Scalars['Boolean'];
};

export type EventByIdResult = {
  __typename?: 'EventByIdResult';
  /** Event item */
  event?: Maybe<EventItem>;
  /** Validation result */
  result: ValidationResult;
  /** Was exchange query success */
  success: Scalars['Boolean'];
};

export enum EventDateShownOptions {
  FULL_DATE = 'FULL_DATE',
  MONTH_YEAR = 'MONTH_YEAR',
  ONLY_YEAR = 'ONLY_YEAR',
  UNDEFINED = 'UNDEFINED'
}

export type EventItem = {
  __typename?: 'EventItem';
  content?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  dateShownOption?: Maybe<EventDateShownOptions>;
  eventType: Scalars['String'];
  exclusiveTenPackPrice?: Maybe<Scalars['Int']>;
  exclusiveTicketLimit?: Maybe<Scalars['Int']>;
  exclusiveTicketPrice?: Maybe<Scalars['Int']>;
  exclusiveTicketsSold: Scalars['Int'];
  fileId?: Maybe<Scalars['ID']>;
  goldTenPackPrice?: Maybe<Scalars['Int']>;
  goldTicketLimit?: Maybe<Scalars['Int']>;
  goldTicketPrice?: Maybe<Scalars['Int']>;
  goldTicketsSold: Scalars['Int'];
  hasCountdown?: Maybe<Scalars['Boolean']>;
  hasTickets: Scalars['Boolean'];
  id: Scalars['ID'];
  isPromoted: Scalars['Boolean'];
  languages?: Maybe<Scalars['String']>;
  registerEnd?: Maybe<Scalars['String']>;
  registerStart?: Maybe<Scalars['String']>;
  silverTenPackPrice?: Maybe<Scalars['Int']>;
  silverTicketLimit?: Maybe<Scalars['Int']>;
  silverTicketPrice?: Maybe<Scalars['Int']>;
  silverTicketsSold: Scalars['Int'];
  standardTenPackPrice?: Maybe<Scalars['Int']>;
  standardTicketLimit?: Maybe<Scalars['Int']>;
  standardTicketPrice?: Maybe<Scalars['Int']>;
  standardTicketsSold: Scalars['Int'];
  status?: Maybe<EventStatus>;
  title?: Maybe<Scalars['String']>;
  vipTenPackPrice?: Maybe<Scalars['Int']>;
  vipTicketLimit?: Maybe<Scalars['Int']>;
  vipTicketPrice?: Maybe<Scalars['Int']>;
  vipTicketsSold: Scalars['Int'];
};

export type EventResult = {
  __typename?: 'EventResult';
  /** Event item */
  events?: Maybe<Array<Maybe<EventItem>>>;
  /** Validation result */
  result: ValidationResult;
  /** Was exchange query success */
  success: Scalars['Boolean'];
};

export enum EventStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

export type EventTicketResult = QueryResultInterface & {
  __typename?: 'EventTicketResult';
  pdf?: Maybe<Scalars['String']>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

/** Exchange history item */
export type ExchangeHistoryItem = {
  __typename?: 'ExchangeHistoryItem';
  /** Exchange item total amount */
  amount: Scalars['Float'];
  /** Exchange created date */
  createdDate?: Maybe<Scalars['String']>;
  /** Exchange log unique identifier */
  exchangeId?: Maybe<Scalars['Int']>;
  /** Exchange item unique identifier */
  id?: Maybe<Scalars['Int']>;
  /** Exchange order type */
  orderType?: Maybe<ExchangeOrderType>;
  /** Exchange owner id */
  ownerId?: Maybe<Scalars['Int']>;
  /** Exchange item price */
  price: Scalars['Float'];
  /** Exchange seller/buyer id */
  userId?: Maybe<Scalars['Int']>;
};

export type ExchangeHistoryResult = {
  __typename?: 'ExchangeHistoryResult';
  /** Exchange buying and selling data */
  data?: Maybe<Array<ExchangeHistoryItem>>;
  /** Validation result */
  result: ValidationResult;
  /** Was exchange query success */
  success: Scalars['Boolean'];
  /** Exchange total rows */
  totalRows: Scalars['Int'];
};

/** Exchange item */
export type ExchangeItem = {
  __typename?: 'ExchangeItem';
  /** Exchange item total amount */
  amount: Scalars['Float'];
  /** Exchange created date */
  createdDate?: Maybe<Scalars['String']>;
  /** Exchange item unique identifier */
  id?: Maybe<Scalars['Int']>;
  /** Exchange order type */
  orderType?: Maybe<ExchangeOrderType>;
  /** Exchange owner id */
  ownerId?: Maybe<Scalars['Int']>;
  /** Exchange item price */
  price: Scalars['Float'];
  /** Exchange item status */
  status?: Maybe<ExchangeStatus>;
};

/** Order asc or desc */
export enum ExchangeOrderBy {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ExchangeOrderResult = {
  __typename?: 'ExchangeOrderResult';
  /** Validation result */
  result: ValidationResult;
  /** Was exchange order success */
  success: Scalars['Boolean'];
};

/** Possible exchange order type */
export enum ExchangeOrderType {
  BUY = 'BUY',
  SELL = 'SELL',
  USER = 'USER'
}

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  createdDate: Scalars['String'];
  fromCurrency: Scalars['String'];
  id: Scalars['Int'];
  maxRate: Scalars['String'];
  minRate: Scalars['String'];
  toCurrency: Scalars['String'];
};

export type ExchangeResult = {
  __typename?: 'ExchangeResult';
  /** Exchange buying and selling data */
  data?: Maybe<Array<ExchangeItem>>;
  /** Validation result */
  result: ValidationResult;
  /** Was exchange query success */
  success: Scalars['Boolean'];
  /** Exchange total rows */
  totalRows: Scalars['Int'];
};

/** Possible sorting fields */
export enum ExchangeSortingBy {
  AMOUNT = 'AMOUNT',
  ID = 'ID',
  PRICE = 'PRICE'
}

/** Possible exchange status */
export enum ExchangeStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

/**
 * generateDirectSales(userId: Int!): FakeRegistrationResult
 * }
 */
export type FaqItem = {
  __typename?: 'FaqItem';
  content?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: FaqStatus;
  title?: Maybe<Scalars['String']>;
};

export type FaqResult = {
  __typename?: 'FaqResult';
  /** Faq item */
  faqs?: Maybe<Array<Maybe<FaqItem>>>;
  /** Validation result */
  result: ValidationResult;
  /** Was exchange query success */
  success: Scalars['Boolean'];
};

export enum FaqStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

export enum FeatureCodeEnum {
  CRYPTOMUS = 'CRYPTOMUS',
  DAGPAY = 'DAGPAY',
  HOODPAY = 'HOODPAY',
  INTERCASH = 'INTERCASH',
  NOWPAYMENTS = 'NOWPAYMENTS',
  SCR = 'SCR',
  SHOP_CREDIT = 'SHOP_CREDIT',
  USDT = 'USDT'
}

export type File = {
  __typename?: 'File';
  categoryId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  /** fileId can be removed? */
  fileId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  /** lang can be removed? */
  lang?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  type: Scalars['String'];
  visibility?: Maybe<FileVisibility>;
};

export type FileType = {
  __typename?: 'FileType';
  categoryId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  type: Scalars['String'];
  visibility?: Maybe<FilesVisibility>;
};

export enum FileVisibility {
  HIDDEN = 'HIDDEN',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export enum FilesVisibility {
  HIDDEN = 'HIDDEN',
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export type ForexGettingStarted = {
  __typename?: 'ForexGettingStarted';
  completedList: Scalars['String'];
  isHidden: Scalars['Int'];
};

export type ForexIdeaLotSize = {
  __typename?: 'ForexIdeaLotSize';
  lotSize: Scalars['String'];
};

export type ForexNews = {
  __typename?: 'ForexNews';
  content: Scalars['String'];
  id: Scalars['Int'];
  imageId?: Maybe<Scalars['Int']>;
  publishedDate?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status: ForexNewsStatus;
  title: Scalars['String'];
};

export enum ForexNewsStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

export enum ForexPeriod {
  ALL_TIME = 'ALL_TIME',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY'
}

export type ForexReport = {
  __typename?: 'ForexReport';
  createdDate: Scalars['String'];
  id: Scalars['Int'];
  period: ForexPeriod;
  periodEndMonth: Scalars['Int'];
  periodStartMonth: Scalars['Int'];
  periodTotalActiveStopLoss: Scalars['Float'];
  periodTotalActiveTakeProfitFive: Scalars['Float'];
  periodTotalActiveTakeProfitFour: Scalars['Float'];
  periodTotalActiveTakeProfitOne: Scalars['Float'];
  periodTotalActiveTakeProfitThree: Scalars['Float'];
  periodTotalActiveTakeProfitTwo: Scalars['Float'];
  periodTotalPassiveStopLoss: Scalars['Float'];
  periodTotalPassiveTakeProfitFive: Scalars['Float'];
  periodTotalPassiveTakeProfitFour: Scalars['Float'];
  periodTotalPassiveTakeProfitOne: Scalars['Float'];
  periodTotalPassiveTakeProfitThree: Scalars['Float'];
  periodTotalPassiveTakeProfitTwo: Scalars['Float'];
  reportBeginning: Scalars['String'];
  reportEnd: Scalars['String'];
  totalCancelledCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  totalProfitCount?: Maybe<Scalars['Int']>;
  updatedDate: Scalars['String'];
  year: Scalars['Int'];
};

export enum ForexResult {
  EP_ACHIEVED = 'EP_ACHIEVED',
  EP_NOT_ACHIEVED = 'EP_NOT_ACHIEVED',
  PENDING = 'PENDING',
  STOP_LOSS = 'STOP_LOSS',
  TAKE_PROFIT = 'TAKE_PROFIT',
  TAKE_PROFIT_FIVE = 'TAKE_PROFIT_FIVE',
  TAKE_PROFIT_FOUR = 'TAKE_PROFIT_FOUR',
  TAKE_PROFIT_THREE = 'TAKE_PROFIT_THREE',
  TAKE_PROFIT_TWO = 'TAKE_PROFIT_TWO'
}

export enum ForexSide {
  BUY = 'BUY',
  SELL = 'SELL'
}

export type ForexSignals = {
  __typename?: 'ForexSignals';
  comments: Array<ForexSignalsComments>;
  createdDate: Scalars['String'];
  entryPrice: Scalars['Int'];
  graphImageId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  marketSymbol: Scalars['String'];
  marketSymbolDecimalPlaces: Scalars['Int'];
  marketSymbolPipDecimalPoint: Scalars['Int'];
  profit?: Maybe<Scalars['Int']>;
  result?: Maybe<ForexResult>;
  side: ForexSide;
  status: ForexStatus;
  stopLoss: Scalars['Int'];
  takeProfit: Scalars['Int'];
  takeProfitFive: Scalars['Int'];
  takeProfitFour: Scalars['Int'];
  takeProfitThree: Scalars['Int'];
  takeProfitTwo: Scalars['Int'];
  technicalAnalysis: Scalars['String'];
};

export type ForexSignalsComments = {
  __typename?: 'ForexSignalsComments';
  content: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['Int'];
};

export type ForexSignalsNotifications = {
  __typename?: 'ForexSignalsNotifications';
  signalId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ForexSignalsQuery = {
  __typename?: 'ForexSignalsQuery';
  rows: Array<ForexSignals>;
  totalRows: Scalars['Int'];
};

export type ForexStats = {
  __typename?: 'ForexStats';
  lastMonthBestReturnOfInvestment: Scalars['String'];
  lastMonthWinRate: Scalars['String'];
  lastYearBestReturnOfInvestment: Scalars['String'];
  updated: Scalars['String'];
};

export enum ForexStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED'
}

/** Forgotten login email and username */
export type ForgottenLoginInput = {
  /** Email */
  email: Scalars['String'];
  /** Username */
  username: Scalars['String'];
};

export type ForgottenLoginResult = {
  __typename?: 'ForgottenLoginResult';
  /** Validation result */
  result: ValidationResult;
};

export type ForgottenPasswordInput = {
  /** Forgotten password linkhash */
  linkHash: Scalars['String'];
  /** Forgotten password new password */
  newPassword: Scalars['String'];
  /** Forgotten password new password repeat */
  repeatNewPassword: Scalars['String'];
};

export type ForgottenPasswordResult = {
  __typename?: 'ForgottenPasswordResult';
  /** Validation result */
  result: ValidationResult;
  /** Was updated success */
  success: Scalars['Boolean'];
};

export enum FounderPackageNames {
  L = 'L',
  M = 'M',
  S = 'S',
  VIEW_BASIC = 'VIEW_BASIC',
  VIEW_STANDARD = 'VIEW_STANDARD',
  VIEW_SUPER = 'VIEW_SUPER',
  VIEW_ULTRA = 'VIEW_ULTRA',
  VIEW_ULTRA_PLUS = 'VIEW_ULTRA_PLUS',
  XL = 'XL'
}

export enum FounderPackagesType {
  L = 'L',
  M = 'M',
  S = 'S',
  VIEW_BASIC = 'VIEW_BASIC',
  VIEW_STANDARD = 'VIEW_STANDARD',
  VIEW_SUPER = 'VIEW_SUPER',
  VIEW_ULTRA = 'VIEW_ULTRA',
  VIEW_ULTRA_PLUS = 'VIEW_ULTRA_PLUS',
  XL = 'XL'
}

export type Genealogy = {
  __typename?: 'Genealogy';
  error?: Maybe<Scalars['String']>;
  members?: Maybe<Array<User>>;
  totalRows: Scalars['Int'];
};

export type GetAwardResult = QueryResultInterface & {
  __typename?: 'GetAwardResult';
  data?: Maybe<RankPrize>;
  prizes?: Maybe<Array<EcapablePrizes>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type GetCartTotalResult = {
  __typename?: 'GetCartTotalResult';
  price: Scalars['Float'];
  shippingPrice: Scalars['Float'];
  taxPrice: Scalars['Float'];
  totalPrice: Scalars['Float'];
};

export type GetEventTicketsResult = {
  __typename?: 'GetEventTicketsResult';
  tickets: Array<UserEventTickets>;
  totalRows: Scalars['Int'];
};

export type GetLatestSupportMessageResult = {
  __typename?: 'GetLatestSupportMessageResult';
  date?: Maybe<Scalars['String']>;
};

export type GetMemberInfoResult = {
  __typename?: 'GetMemberInfoResult';
  country: Scalars['String'];
  countryCode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leftTeamMonthlyVolume: Scalars['Int'];
  leftTeamRankId: Scalars['Int'];
  leftTeamRankUserId: Scalars['Int'];
  leftTeamVolume: Scalars['Int'];
  leftTeamYearlyVolume: Scalars['Int'];
  maxRankId: Scalars['Int'];
  rankId: Scalars['Int'];
  referralUsersTotal: Scalars['Int'];
  rightTeamMonthlyVolume: Scalars['Int'];
  rightTeamRankId: Scalars['Int'];
  rightTeamRankUserId: Scalars['Int'];
  rightTeamVolume: Scalars['Int'];
  rightTeamYearlyVolume: Scalars['Int'];
  sponsorName: Scalars['String'];
  totalCustomerVolume: Scalars['Int'];
  username: Scalars['String'];
};

export type GetPaymentEntityId = {
  __typename?: 'GetPaymentEntityId';
  entityId?: Maybe<Scalars['ID']>;
};

export type GetPaymentStatusResult = {
  __typename?: 'GetPaymentStatusResult';
  status: PaymentStatus;
};

export type GetReferralCodeResult = {
  __typename?: 'GetReferralCodeResult';
  /** Response */
  referralCode: Scalars['String'];
  /** Validation result */
  result: ValidationResult;
  /** Was query successful */
  success: Scalars['Boolean'];
};

export type GetReferralUsersResult = {
  __typename?: 'GetReferralUsersResult';
  /** Response */
  referralUsers: Array<Maybe<ReferralUser>>;
  /** Validation result */
  result: ValidationResult;
  /** Was query successful */
  success: Scalars['Boolean'];
  /** Total rows */
  totalRows: Scalars['Int'];
};

export type GetUserCustomersResult = {
  __typename?: 'GetUserCustomersResult';
  customers?: Maybe<Array<UserPersonalCustomerType>>;
  totalRows: Scalars['Int'];
};

export type GetUserIncomeCentreConfrimationListResult = {
  __typename?: 'GetUserIncomeCentreConfrimationListResult';
  list?: Maybe<Array<UserIncomeCentreType>>;
  totalRows: Scalars['Int'];
};

export type GetWheelOfSuccessListResult = {
  __typename?: 'GetWheelOfSuccessListResult';
  list: Array<WheelOfSuccessList>;
  totalRows: Scalars['Int'];
};

export type GiftCard = {
  __typename?: 'GiftCard';
  active: Scalars['Boolean'];
  amount: Scalars['String'];
  code: Scalars['String'];
  currency: Currency;
  id: Scalars['ID'];
  type: Scalars['String'];
  usedBy?: Maybe<Scalars['String']>;
};

export type GiftCardInputObject = {
  amount?: InputMaybe<Scalars['Float']>;
};

export type GiftCardLimits = {
  __typename?: 'GiftCardLimits';
  maximum: Monetary;
  minimum: Monetary;
};

export type GroupOfRecognitions = {
  __typename?: 'GroupOfRecognitions';
  rankId: Scalars['Int'];
  team: Scalars['String'];
  total: Scalars['Int'];
};

export type GroupOfRecognitionsResult = {
  __typename?: 'GroupOfRecognitionsResult';
  error?: Maybe<Scalars['String']>;
  ranks?: Maybe<Array<Maybe<GroupOfRecognitions>>>;
};

/** User Grow account info */
export type GrowAccount = {
  __typename?: 'GrowAccount';
  amountTransferred: Scalars['String'];
  hasAccessLink?: Maybe<Scalars['Boolean']>;
  linkedAccount?: Maybe<Scalars['String']>;
};

export type HighestAvailableCourseResult = {
  __typename?: 'HighestAvailableCourseResult';
  course: UserCoursesMap;
  /** Validation result */
  result: ValidationResult;
  /** Was company update query success */
  success: Scalars['Boolean'];
};

export type HunterSystemsAccess = {
  __typename?: 'HunterSystemsAccess';
  accessUrl: Scalars['String'];
  description: Scalars['String'];
  url: Scalars['String'];
};

export type Inbox = {
  __typename?: 'Inbox';
  /** Error message */
  error?: Maybe<Scalars['String']>;
  /** User messages */
  messages?: Maybe<Array<Maybe<Message>>>;
  /** Message count */
  totalRows: Scalars['Int'];
};

export type InitiateCartPaymentResult = {
  __typename?: 'InitiateCartPaymentResult';
  paymentId?: Maybe<Scalars['String']>;
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
};

export type InitiateSubscriptionPaymentResult = {
  __typename?: 'InitiateSubscriptionPaymentResult';
  paymentId?: Maybe<Scalars['String']>;
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
};

/** possible investment order currency codes */
export enum InvestmentOrderCurrencyCode {
  EUR = 'EUR'
}

/** possible investment order processing statuses */
export enum InvestmentOrderProcessingStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING'
}

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['Float'];
  date: Scalars['String'];
  description: Scalars['String'];
  dueDate: Scalars['String'];
  id: Scalars['Int'];
  invoiceNr: Scalars['String'];
  paymentMethod: Scalars['String'];
  transactionType: Scalars['String'];
};

export type InvoiceListResult = QueryResultInterface & {
  __typename?: 'InvoiceListResult';
  data: Array<Invoice>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export type InvoiceMutation = {
  __typename?: 'InvoiceMutation';
  invoice: InvoiceResult;
};


export type InvoiceMutationInvoiceArgs = {
  id: Scalars['Int'];
  type: PaymentMethod;
};

export type InvoiceQuery = {
  __typename?: 'InvoiceQuery';
  invoice: InvoiceResult;
  list: InvoiceListResult;
};


export type InvoiceQueryListArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type InvoiceResult = QueryResultInterface & {
  __typename?: 'InvoiceResult';
  pdf?: Maybe<Scalars['String']>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type KeyValuePair = {
  __typename?: 'KeyValuePair';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type LatestCashAccountResult = {
  __typename?: 'LatestCashAccountResult';
  totalRows: Scalars['Int'];
  transactions?: Maybe<Array<CashAccountTransaction>>;
};

export type LatestMessageResult = {
  __typename?: 'LatestMessageResult';
  message?: Maybe<Message>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  affiliates?: Maybe<Array<LeaderboardResult>>;
  customers?: Maybe<Array<LeaderboardResult>>;
};


export type LeaderboardAffiliatesArgs = {
  period: Scalars['String'];
};


export type LeaderboardCustomersArgs = {
  period: Scalars['String'];
};

export enum LeaderboardPeriods {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export type LeaderboardResult = {
  __typename?: 'LeaderboardResult';
  avatarFileId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  totalMembers: Scalars['Int'];
  totalUsers: Scalars['Int'];
};

export type LeadershipBonus = {
  __typename?: 'LeadershipBonus';
  cashBonus: Scalars['Float'];
  generationId: Scalars['Int'];
  username: Scalars['String'];
};

export type LeadershipBonusInfo = {
  __typename?: 'LeadershipBonusInfo';
  amount?: Maybe<Scalars['String']>;
  yearweek?: Maybe<Scalars['String']>;
};

export type LeadershipBonusStatsResult = {
  __typename?: 'LeadershipBonusStatsResult';
  data?: Maybe<Array<Maybe<LeadershipStat>>>;
};

export type LeadershipRankStats = {
  __typename?: 'LeadershipRankStats';
  leftTeamRankId: Scalars['Int'];
  rightTeamRankId: Scalars['Int'];
};

export type LeadershipRankStatsResult = {
  __typename?: 'LeadershipRankStatsResult';
  error?: Maybe<Scalars['String']>;
  ranks: LeadershipRankStats;
};

export type LeadershipStat = {
  __typename?: 'LeadershipStat';
  amount?: Maybe<Scalars['String']>;
  yearweek?: Maybe<Scalars['String']>;
};

export type ListOfUsersRegisteredForEvent = {
  __typename?: 'ListOfUsersRegisteredForEvent';
  /** rank */
  rankId: Scalars['Int'];
  /** registration date */
  registrationDate: Scalars['String'];
  /** team */
  team: Scalars['String'];
  /** total guest */
  totalGuest: Scalars['Int'];
  /** username */
  username: Scalars['String'];
};

export type ListOfUsersRegisteredForEventResult = {
  __typename?: 'ListOfUsersRegisteredForEventResult';
  /** Result */
  result: ValidationResult;
  /** Was request success */
  success: Scalars['Boolean'];
  /** total rows */
  totalRows: Scalars['Int'];
  /** all user tickets */
  users: Array<ListOfUsersRegisteredForEvent>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  /** Validation result */
  result: ValidationResult;
  /** JWT */
  token?: Maybe<Scalars['String']>;
  /** Logged in user info or null if login failed */
  user?: Maybe<User>;
};

export type LuckyWheel = {
  __typename?: 'LuckyWheel';
  result: Scalars['Int'];
};

export type MarkNewsAsReadResult = {
  __typename?: 'MarkNewsAsReadResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

/** New implementation of viewer */
export type Me = {
  __typename?: 'Me';
  /** Latest ending Business Fee subscription for the main account and it's income centers */
  activeBusinessFeeSubscription?: Maybe<ServiceSubscription>;
  /** Latest ending Marketing Fee subscription for the main account and it's income centers */
  activeMarketingFeeSubscription?: Maybe<ServiceSubscription>;
  /** Latest ending Platform Fee subscription for the main account and it's income centers */
  activePlatofrmFeeSubscription?: Maybe<ServiceSubscription>;
  activeServiceProductCodes: Array<ServiceProductCode>;
  askReCaptcha: Scalars['Boolean'];
  awenturesAccess: Scalars['Boolean'];
  codebreakerAccess?: Maybe<CodeBreakerAccess>;
  consents?: Maybe<Array<UserConsent>>;
  currency: Currency;
  /** Returns user dag info */
  dagsInfo?: Maybe<MeDagsInfo>;
  /** Returns access url for forex insiders if user has active subscription */
  forexInsidersAccess?: Maybe<Scalars['String']>;
  /** Gift card amount limits */
  giftCardLimits: GiftCardLimits;
  growAccount: GrowAccount;
  hunterSystemsAccess?: Maybe<HunterSystemsAccess>;
  info?: Maybe<UserInfo>;
  intercashProfile?: Maybe<UserIntercashProfile>;
  intercomHash?: Maybe<Scalars['String']>;
  isFeatureEnabled: Scalars['Boolean'];
  isLoggedIn?: Maybe<Scalars['Boolean']>;
  /** Returns user d2t info */
  meD2TInfo?: Maybe<MeD2TInfoType>;
  /** Returns access URL for memberships if user has active subscription */
  membershipAccess?: Maybe<Scalars['String']>;
  /** List of available payment methods with monetary limits for viewer currency */
  paymentMethods: Array<PaymentMethodInfo>;
  paymentSources?: Maybe<Array<PaymentSource>>;
  personalServiceOffers: Array<UpSellOfferUnion>;
  productsForDags: Array<ProductForDags>;
  referralsStats: ReferralsStats;
  serviceCart?: Maybe<ServiceCart>;
  serviceOfferRecommendations: Array<ServiceOffer>;
  serviceSubscriptionInvoices: ServiceSubscriptionInvoicesResult;
  serviceSubscriptionUpgrade?: Maybe<ServiceSubscriptionUpgrade>;
  serviceSubscriptions: Array<ServiceSubscription>;
  teams: MeTeams;
  theViewForDags?: Maybe<TheViewForDagsType>;
  theiaAccess?: Maybe<Scalars['String']>;
  tribebaseAccess?: Maybe<Scalars['String']>;
  /** Returns user webwallet addresses */
  webwalletAddresses?: Maybe<Array<MeWebWallets>>;
  xera?: Maybe<Array<UserXeraInfo>>;
  /** Access url for ZenDesk if appropriate */
  zenDeskAccess?: Maybe<Scalars['String']>;
};


/** New implementation of viewer */
export type MeIsFeatureEnabledArgs = {
  code: FeatureCodeEnum;
};


/** New implementation of viewer */
export type MePaymentMethodsArgs = {
  paymentUnit?: InputMaybe<PaymentUnit>;
};


/** New implementation of viewer */
export type MeServiceSubscriptionInvoicesArgs = {
  pagination: OffsetPaginationInput;
};


/** New implementation of viewer */
export type MeServiceSubscriptionUpgradeArgs = {
  upgradeId: Scalars['String'];
};


/** New implementation of viewer */
export type MeServiceSubscriptionsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};

export type MeD2TInfoType = {
  __typename?: 'MeD2TInfoType';
  burned?: Maybe<Array<BurnedDagsD2T>>;
  ratio?: Maybe<Scalars['String']>;
  totalDags?: Maybe<Scalars['String']>;
  totalScr?: Maybe<Scalars['String']>;
  usedDags?: Maybe<Scalars['String']>;
};

export type MeDagsInfo = {
  __typename?: 'MeDagsInfo';
  burned?: Maybe<Array<BurnedDags>>;
  ratio?: Maybe<Scalars['String']>;
  totalDags?: Maybe<Scalars['String']>;
  totalScr?: Maybe<Scalars['String']>;
  usedDags?: Maybe<Scalars['String']>;
};

export type MeTeams = {
  __typename?: 'MeTeams';
  activeTeam?: Maybe<ActiveTeam>;
  canRegisterTeam: Scalars['Boolean'];
  leaderboard?: Maybe<Leaderboard>;
  recommendedTeams: Array<Team>;
  teamLeaderboard?: Maybe<TeamLeaderboard>;
};

export type MeWebWallets = {
  __typename?: 'MeWebWallets';
  address?: Maybe<Scalars['String']>;
  walletType?: Maybe<Scalars['String']>;
};

export type MemberAreaNewsResult = QueryResultInterface & {
  __typename?: 'MemberAreaNewsResult';
  data?: Maybe<Array<NewsItem>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['String'];
};

export type Members = QueryResultInterface & {
  __typename?: 'Members';
  error?: Maybe<Scalars['String']>;
  members?: Maybe<Array<User>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export type MembersCountInPeriodResult = {
  __typename?: 'MembersCountInPeriodResult';
  error?: Maybe<Scalars['String']>;
  members?: Maybe<Array<Maybe<MembersTotal>>>;
};

export type MembersStats = {
  __typename?: 'MembersStats';
  error?: Maybe<Scalars['String']>;
  leftMembersCount: Scalars['Int'];
  leftTeamLeftId: Scalars['Int'];
  leftTeamRightId: Scalars['Int'];
  rightMembersCount: Scalars['Int'];
  rightTeamLeftId: Scalars['Int'];
  rightTeamRightId: Scalars['Int'];
  totalPersonalMembers: Scalars['Int'];
};

export type MembersTotal = {
  __typename?: 'MembersTotal';
  joinedDate: Scalars['String'];
  totalPersonalMembers: Scalars['Int'];
  totalVolumePoints: Scalars['Int'];
  week: Scalars['String'];
  year: Scalars['String'];
};

export type Message = {
  __typename?: 'Message';
  createdDate: Scalars['String'];
  fromUser: Scalars['String'];
  fromUserId: Scalars['Int'];
  fromUserRankId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  message: Scalars['String'];
  notificationViewed?: Maybe<Scalars['String']>;
  readDate?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  toUser: Scalars['String'];
  toUserId: Scalars['Int'];
  toUserRankId?: Maybe<Scalars['Int']>;
};

/** Message input */
export type MessageInput = {
  /** Message */
  message: Scalars['String'];
  /** To user */
  username: Scalars['String'];
};

export type MessageResult = {
  __typename?: 'MessageResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type MessagesMutation = {
  __typename?: 'MessagesMutation';
  markMessageAsRead?: Maybe<MessageResult>;
  /** Send message to user */
  send?: Maybe<MessageResult>;
};


export type MessagesMutationMarkMessageAsReadArgs = {
  id: Scalars['Int'];
};


export type MessagesMutationSendArgs = {
  data?: InputMaybe<MessageInput>;
};

export type MessagesPeopleListResult = {
  __typename?: 'MessagesPeopleListResult';
  data: Array<PeopleMessages>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export type MessagesQuery = {
  __typename?: 'MessagesQuery';
  chat: RecentMessagesResult;
  people: MessagesPeopleListResult;
};


export type MessagesQueryChatArgs = {
  chatId?: InputMaybe<Scalars['Int']>;
};


export type MessagesQueryPeopleArgs = {
  filter?: InputMaybe<Scalars['String']>;
};

export type MomentumBoard = {
  __typename?: 'MomentumBoard';
  category?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['ID']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  publishedDate: Scalars['String'];
};

export type Monetary = {
  __typename?: 'Monetary';
  amount: Scalars['String'];
  currency: Currency;
};

export type MovilTokenCount = {
  __typename?: 'MovilTokenCount';
  total: Scalars['Int'];
  type: Scalars['Int'];
};

export type MovilTokenCountResult = QueryResultInterface & {
  __typename?: 'MovilTokenCountResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
  tokens?: Maybe<Array<MovilTokenCount>>;
};

export type MovilTokenInput = {
  Columbia?: InputMaybe<Scalars['Int']>;
  Honduras?: InputMaybe<Scalars['Int']>;
  Mexico?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Changes user email */
  activateEmailByHash: Scalars['Boolean'];
  /** Activates Subscription product with activation code */
  activateSubscriptionByCode: Scalars['Boolean'];
  /** Adds cart item to cart / creates cart */
  addCartItem: Scalars['Boolean'];
  /** Follow signal id */
  addForexSignalNotification: Scalars['Boolean'];
  /** Register new User */
  addIncomeCentre?: Maybe<RegistrationResult>;
  addServiceCartItem: ServiceCartItem;
  addSwipexTradingCoinsToEscrow: Scalars['String'];
  affiliateAgreement: AffiliateAgreementResult;
  applyServiceCartDiscountCode: ServiceDiscount;
  arrangePaymentSources: Array<PaymentSource>;
  /** Marks user active, checks affiliate agreement */
  becomeAffiliate: Scalars['Boolean'];
  blockTeamMember: Scalars['Boolean'];
  cancelExchangeOrder: ExchangeOrderResult;
  /** Cancels subscription */
  cancelSubscription: Scalars['Boolean'];
  changeConfirmationPassword: ForgottenPasswordResult;
  /** Changes user's displayed income centre */
  changeDisplayedIncomeCentre: Scalars['Boolean'];
  changeForgottenPassword: ForgottenPasswordResult;
  changeLocale: Scalars['Boolean'];
  claimMerchantReward: ClaimMerchantRewardResult;
  clearServiceCartDiscountCode: Scalars['Boolean'];
  /** Creates duplicate of previously closed cart. Can be used to create new cart based on old finalized cart. Cannot be used if active cart exists */
  cloneInactiveServiceCart: ServiceCart;
  /** Confirms user income centre selection */
  confrimUserIncomeCentreSelection: Scalars['Boolean'];
  continueServiceSubscription: Scalars['Boolean'];
  /** Submit tokens for the user */
  convertCommunityDags: Scalars['Boolean'];
  /** Submit tokens for the user */
  convertDags: Scalars['Boolean'];
  /** Submit tokens for the user */
  convertDagsD2T: Scalars['Boolean'];
  /** Creates user email change request */
  createEmailChange: Scalars['Boolean'];
  createExchange: ExchangeOrderResult;
  /** Creates finalized cart from Products for Dags offers */
  createProductsForDagsCart: ServiceCart;
  createStripeSetupIntent: Scalars['String'];
  createSupportMessage?: Maybe<CreateSupportMessageResult>;
  createSupportMessageAttachment?: Maybe<SupportMessageAttachmentResult>;
  createTeamNews: TeamNews;
  /** Creates finalized service cart from The View for Dags offers */
  createTheViewForDagsCart: ServiceCart;
  /** Unfollow signal id */
  deleteForexSignalNotification: Scalars['Boolean'];
  deleteTeamNews: Scalars['Boolean'];
  deleteTeamResource: Scalars['Boolean'];
  discontinueServiceSubscription: Scalars['Boolean'];
  /** Check if email exists already in database */
  doesEmailExist: Scalars['Boolean'];
  /** Check if username exists already in database */
  doesUsernameExist: Scalars['Boolean'];
  /** Download invoice by cart or payment ID */
  downloadInvoice?: Maybe<Scalars['String']>;
  /** Extends subscription with activation code */
  extendSubscriptionByCode: Scalars['Boolean'];
  /** Freezes cart contents to make the cart payable */
  finalizeCart: ServiceCart;
  forgottenConfirmationPassword: ForgottenLoginResult;
  /** Reset forgotten login */
  forgottenLogin: ForgottenLoginResult;
  /** Submit tokens for the user */
  getAwenturesLoginLink: Scalars['String'];
  getLuckyWheelPrize: Scalars['Int'];
  getReferralCode: GetReferralCodeResult;
  growAccountAccessLink: Scalars['String'];
  /** Initiates cart payment based on Stripe payment method ID */
  initiateCartPayment: InitiateCartPaymentResult;
  /** Initiates subscription payment */
  initiateSubscriptionPayment: InitiateSubscriptionPaymentResult;
  invalidateAffiliate: Scalars['Boolean'];
  /** Check if email occurs more than 10 times */
  isEmailLimitReached: Scalars['Boolean'];
  joinTeam: ActiveTeam;
  leaveTeam: Scalars['Boolean'];
  /** Attempts to log the user in by given credentials */
  login: LoginResult;
  /** Logs the user out */
  logout: Scalars['Boolean'];
  markNewsAsRead: MarkNewsAsReadResult;
  payments: PaymentsMutation;
  /** Register new User */
  quickRegister?: Maybe<RegistrationResult>;
  rankPrizes?: Maybe<RankPrizesMutations>;
  redeemGiftCard: GiftCard;
  /** Register invited user */
  registerInvitedUser?: Maybe<Scalars['Int']>;
  /** Register LL user */
  registerLooreUser?: Maybe<Scalars['Int']>;
  registerPushNotificationDevice: RegisterPushNotificationDeviceResult;
  /** Register shop user */
  registerShopUser?: Maybe<Scalars['Int']>;
  registerStripePaymentSource: PaymentSource;
  registerTeam: ActiveTeam;
  /** Register new User */
  registerUser?: Maybe<RegistrationResult>;
  /** Request invite for user */
  registerWebinar: Scalars['Boolean'];
  /** Sets all pending personal offers as rejected by user */
  rejectPersonalOffers: Scalars['Boolean'];
  /** Removed item from cart */
  removeCartItem: Scalars['Boolean'];
  removePaymentSource: Array<PaymentSource>;
  removeServiceCartItem: Scalars['Boolean'];
  removeTeamMember: Scalars['Boolean'];
  /** Removes income centre from user selection */
  removeUserIncomeCentre: Scalars['Boolean'];
  removeVerificationFile: VerificationDeleteResult;
  /** Request invite for user */
  requestInvite: Scalars['Boolean'];
  sandbox: SandboxMutation;
  /** Adds income centre to user selection */
  selectUserIncomeCentre: Scalars['Boolean'];
  sendContactSupportMessage?: Maybe<SupportMessageResult>;
  sendSupportMessage?: Maybe<SupportMessageResult>;
  /** Forex Getting started completed handler */
  setForexGettingStartedCompleted: Scalars['Boolean'];
  /** Forex Getting started hidden handler */
  setForexIsGettingStartedHidden: Scalars['Boolean'];
  setSwipexAccountLinkStatus: Scalars['Boolean'];
  /** SignUp for Skillex */
  signUpForSkillex: SkillexSignUpResult;
  /** Skip for login user income centre selection */
  skipUserIncomeCentreSelection: Scalars['Boolean'];
  storeUserConsent: Scalars['Boolean'];
  swipexInvestmentOrder: Scalars['String'];
  unblockTeamMember: Scalars['Boolean'];
  /** Updates cart item quantity */
  updateCartItem: Scalars['Boolean'];
  /** Updates cart shipping details */
  updateCartShippingDetails: Scalars['Boolean'];
  updateCustomerTreePosition: Scalars['Boolean'];
  updatePushNotificationDeviceInfo: UpdatePushNotificationDeviceResult;
  updateReferralUsers: UpdateReferralUsersResult;
  updateServiceCartItemPeriod: Scalars['Boolean'];
  updateServiceCartItemQuantity: Scalars['Boolean'];
  updateTeamDetails: Scalars['Boolean'];
  updateTeamMemberRole: Scalars['Boolean'];
  updateTeamNews: TeamNews;
  updateTeamStatus: Scalars['Boolean'];
  /** Request invite for user */
  updateUserWallet: Scalars['Boolean'];
  /** Upgraded affiliates business fee */
  upgradeBusinessFee: Scalars['Boolean'];
  upgradeServiceSubscription: ServiceSubscriptionUpgrade;
  user?: Maybe<UserMutation>;
  userVerifications: UserVerificationsMutations;
  validateAffiliate?: Maybe<AffiliateResult>;
  /** Validates activation code and returns package data */
  validateDagPackage?: Maybe<ValidateDagPackagesResult>;
  verifySwipexLinkRequest: Scalars['String'];
  /** Returns logged in user information or null if not logged in */
  viewer?: Maybe<UserMutation>;
};


export type MutationActivateEmailByHashArgs = {
  hash: Scalars['String'];
};


export type MutationActivateSubscriptionByCodeArgs = {
  activationCode: Scalars['String'];
  productId: Scalars['Int'];
};


export type MutationAddCartItemArgs = {
  color?: InputMaybe<ProductColor>;
  neckline?: InputMaybe<ProductNecklines>;
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
  size?: InputMaybe<ProductSize>;
};


export type MutationAddForexSignalNotificationArgs = {
  signalId: Scalars['Int'];
};


export type MutationAddIncomeCentreArgs = {
  mainAccountId: Scalars['Int'];
  parentId: Scalars['Int'];
  team: Scalars['String'];
  username: Scalars['String'];
};


export type MutationAddServiceCartItemArgs = {
  periodCode: ServicePeriodCode;
  productCode: ServiceProductCode;
};


export type MutationAddSwipexTradingCoinsToEscrowArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type MutationApplyServiceCartDiscountCodeArgs = {
  code: Scalars['String'];
};


export type MutationArrangePaymentSourcesArgs = {
  paymentSourcesIds: Array<Scalars['String']>;
};


export type MutationBecomeAffiliateArgs = {
  activationCode?: InputMaybe<Scalars['String']>;
  leftUsername?: InputMaybe<Scalars['String']>;
  rightUsername?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};


export type MutationBlockTeamMemberArgs = {
  teamId: Scalars['ID'];
  username: Scalars['String'];
};


export type MutationCancelExchangeOrderArgs = {
  data: CancelExchangeOrderInput;
};


export type MutationCancelSubscriptionArgs = {
  subscriptionId: Scalars['Int'];
};


export type MutationChangeConfirmationPasswordArgs = {
  data: ForgottenPasswordInput;
};


export type MutationChangeDisplayedIncomeCentreArgs = {
  id: Scalars['ID'];
};


export type MutationChangeForgottenPasswordArgs = {
  data: ForgottenPasswordInput;
};


export type MutationChangeLocaleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


export type MutationClaimMerchantRewardArgs = {
  rewardId: Scalars['Int'];
};


export type MutationCloneInactiveServiceCartArgs = {
  cartId: Scalars['String'];
};


export type MutationConfrimUserIncomeCentreSelectionArgs = {
  note?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};


export type MutationContinueServiceSubscriptionArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationConvertCommunityDagsArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  totalAmount: Scalars['String'];
};


export type MutationConvertDagsArgs = {
  totalAmount: Scalars['String'];
};


export type MutationConvertDagsD2TArgs = {
  email: Scalars['String'];
  name: Scalars['String'];
  totalAmount: Scalars['String'];
};


export type MutationCreateEmailChangeArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  repeatEmail: Scalars['String'];
};


export type MutationCreateExchangeArgs = {
  data: CreateExchangeInput;
};


export type MutationCreateProductsForDagsCartArgs = {
  offerIds: Array<Scalars['String']>;
};


export type MutationCreateSupportMessageArgs = {
  data?: InputMaybe<SupportMessageInput>;
};


export type MutationCreateSupportMessageAttachmentArgs = {
  data?: InputMaybe<SupportMessageAttachmentInput>;
};


export type MutationCreateTeamNewsArgs = {
  content: Scalars['String'];
  teamId: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationCreateTheViewForDagsCartArgs = {
  dagOffersIds: Array<Scalars['String']>;
};


export type MutationDeleteForexSignalNotificationArgs = {
  signalId: Scalars['Int'];
};


export type MutationDeleteTeamNewsArgs = {
  newsId: Scalars['ID'];
  teamId: Scalars['ID'];
};


export type MutationDeleteTeamResourceArgs = {
  resourceId: Scalars['ID'];
  teamId: Scalars['ID'];
};


export type MutationDiscontinueServiceSubscriptionArgs = {
  subscriptionId: Scalars['String'];
};


export type MutationDoesEmailExistArgs = {
  email: Scalars['String'];
};


export type MutationDoesUsernameExistArgs = {
  username: Scalars['String'];
};


export type MutationDownloadInvoiceArgs = {
  cartId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
};


export type MutationExtendSubscriptionByCodeArgs = {
  activationCode: Scalars['String'];
  subscriptionId: Scalars['Int'];
};


export type MutationFinalizeCartArgs = {
  finalizationHash: Scalars['String'];
};


export type MutationForgottenLoginArgs = {
  data: ForgottenLoginInput;
};


export type MutationGetLuckyWheelPrizeArgs = {
  activationCode?: InputMaybe<Scalars['String']>;
};


export type MutationGrowAccountAccessLinkArgs = {
  secretPassword?: InputMaybe<Scalars['String']>;
};


export type MutationInitiateCartPaymentArgs = {
  paymentMethod: Scalars['String'];
};


export type MutationInitiateSubscriptionPaymentArgs = {
  countryId: Scalars['Int'];
  paymentMethod: Scalars['String'];
  period?: SubscriptionPeriod;
  productId: Scalars['Int'];
};


export type MutationIsEmailLimitReachedArgs = {
  email: Scalars['String'];
};


export type MutationJoinTeamArgs = {
  teamId: Scalars['ID'];
};


export type MutationLeaveTeamArgs = {
  teamId: Scalars['ID'];
};


export type MutationLoginArgs = {
  credentials?: InputMaybe<CredentialsInput>;
};


export type MutationMarkNewsAsReadArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationQuickRegisterArgs = {
  data?: InputMaybe<QuickRegistrationInput>;
};


export type MutationRedeemGiftCardArgs = {
  cardCode: Scalars['String'];
};


export type MutationRegisterInvitedUserArgs = {
  activationCode?: InputMaybe<Scalars['String']>;
  affiliateId: Scalars['String'];
  countryId: Scalars['Int'];
  dateOfBirth: Scalars['String'];
  email: Scalars['String'];
  escrowTime?: InputMaybe<Scalars['Int']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  termsAndConditions: Scalars['Boolean'];
  username: Scalars['String'];
};


export type MutationRegisterLooreUserArgs = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryId: Scalars['Int'];
  dateOfBirth: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  postcode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  termsAndConditions: Scalars['Boolean'];
  username: Scalars['String'];
};


export type MutationRegisterPushNotificationDeviceArgs = {
  data: PushNotificationDeviceInfoInput;
};


export type MutationRegisterShopUserArgs = {
  address?: InputMaybe<Scalars['String']>;
  affiliateId: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  countryId: Scalars['Int'];
  dateOfBirth: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  postcode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  termsAndConditions: Scalars['Boolean'];
};


export type MutationRegisterStripePaymentSourceArgs = {
  saveForFutureUse: Scalars['Boolean'];
  setupIntentClientSecret: Scalars['String'];
};


export type MutationRegisterTeamArgs = {
  description: Scalars['String'];
  missionStatement: Scalars['String'];
  name: Scalars['String'];
};


export type MutationRegisterUserArgs = {
  data?: InputMaybe<RegistrationInput>;
};


export type MutationRegisterWebinarArgs = {
  email: Scalars['String'];
};


export type MutationRemoveCartItemArgs = {
  cartItemId: Scalars['Int'];
};


export type MutationRemovePaymentSourceArgs = {
  paymentSourceId: Scalars['String'];
};


export type MutationRemoveServiceCartItemArgs = {
  productCode: ServiceProductCode;
};


export type MutationRemoveTeamMemberArgs = {
  block: Scalars['Boolean'];
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRemoveUserIncomeCentreArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveVerificationFileArgs = {
  id: Scalars['Int'];
};


export type MutationRequestInviteArgs = {
  city?: InputMaybe<Scalars['String']>;
  countryId: Scalars['Int'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


export type MutationSelectUserIncomeCentreArgs = {
  id: Scalars['Int'];
};


export type MutationSendContactSupportMessageArgs = {
  data?: InputMaybe<PublicSupportMessageInput>;
};


export type MutationSendSupportMessageArgs = {
  messageId: Scalars['Int'];
};


export type MutationSetForexGettingStartedCompletedArgs = {
  id: Scalars['Int'];
};


export type MutationSetForexIsGettingStartedHiddenArgs = {
  isHidden: Scalars['Int'];
};


export type MutationSetSwipexAccountLinkStatusArgs = {
  input: SetSwipexAccountLinkStatusInput;
};


export type MutationStoreUserConsentArgs = {
  code: UserConsentCode;
  granted: Scalars['Boolean'];
};


export type MutationSwipexInvestmentOrderArgs = {
  token: Scalars['String'];
};


export type MutationUnblockTeamMemberArgs = {
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUpdateCartItemArgs = {
  cartItemId: Scalars['Int'];
  quantity: Scalars['Int'];
};


export type MutationUpdateCartShippingDetailsArgs = {
  address: Scalars['String'];
  city: Scalars['String'];
  countryId: Scalars['Int'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  postcode: Scalars['String'];
  state: Scalars['String'];
};


export type MutationUpdateCustomerTreePositionArgs = {
  customerSponsorId: Scalars['Int'];
  parentId: Scalars['Int'];
  position: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUpdatePushNotificationDeviceInfoArgs = {
  data: UpdatePushNotificationDeviceInfoInput;
};


export type MutationUpdateServiceCartItemPeriodArgs = {
  periodCode: ServicePeriodCode;
  productCode: ServiceProductCode;
};


export type MutationUpdateServiceCartItemQuantityArgs = {
  productCode: ServiceProductCode;
  quantity: Scalars['Int'];
};


export type MutationUpdateTeamDetailsArgs = {
  description?: InputMaybe<Scalars['String']>;
  missionStatement?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rules?: InputMaybe<Array<Scalars['String']>>;
  teamId: Scalars['ID'];
};


export type MutationUpdateTeamMemberRoleArgs = {
  role: TeamMemberRole;
  teamId: Scalars['ID'];
  username: Scalars['String'];
};


export type MutationUpdateTeamNewsArgs = {
  content: Scalars['String'];
  newsId: Scalars['ID'];
  teamId: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationUpdateTeamStatusArgs = {
  status: UpdateTeamStatusStatus;
  teamId: Scalars['ID'];
};


export type MutationUpdateUserWalletArgs = {
  address: Scalars['String'];
  wallet?: InputMaybe<UserWalletTypesEnum>;
};


export type MutationUpgradeBusinessFeeArgs = {
  activationCode?: InputMaybe<Scalars['String']>;
  method: BusinessFeeUpgradeMethods;
};


export type MutationUpgradeServiceSubscriptionArgs = {
  offerId: Scalars['String'];
  subscriptionId: Scalars['String'];
};


export type MutationValidateAffiliateArgs = {
  affiliateId: Scalars['String'];
};


export type MutationValidateDagPackageArgs = {
  activationCode: Scalars['String'];
};


export type MutationVerifySwipexLinkRequestArgs = {
  input?: InputMaybe<Scalars['String']>;
};

export enum NewsCategory {
  DAGCOIN = 'DAGCOIN',
  SF = 'SF',
  SHOP = 'SHOP',
  SKILLEX = 'SKILLEX'
}

export enum NewsConfirmationType {
  CONFIRM = 'CONFIRM',
  SEEN = 'SEEN'
}

export type NewsFeed = {
  __typename?: 'NewsFeed';
  content?: Maybe<Scalars['String']>;
  files: Array<Maybe<File>>;
  id: Scalars['ID'];
  publishedDate: Scalars['String'];
  title: Scalars['String'];
  videos: Array<Maybe<VideosItem>>;
};

export type NewsFeedsResult = {
  __typename?: 'NewsFeedsResult';
  data?: Maybe<Array<NewsFeed>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export enum NewsFeedsStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

export type NewsItem = {
  __typename?: 'NewsItem';
  category?: Maybe<NewsCategory>;
  confirmationType?: Maybe<NewsConfirmationType>;
  content?: Maybe<Scalars['String']>;
  createdDate: Scalars['String'];
  fileId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isPrivate: NewsPrivateEnum;
  needsConfirmation: NewsPrivateEnum;
  publishedDate: Scalars['String'];
  status: NewsStatusEnum;
  title: Scalars['String'];
};

export enum NewsPrivateEnum {
  NO = 'NO',
  YES = 'YES'
}

export type NewsResult = {
  __typename?: 'NewsResult';
  data?: Maybe<Array<NewsItem>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export enum NewsStatusEnum {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

export type NotificationItem = {
  __typename?: 'NotificationItem';
  content?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCloseable?: Maybe<Scalars['Boolean']>;
  status: NotificationStatus;
  title?: Maybe<Scalars['String']>;
};

export type NotificationResult = {
  __typename?: 'NotificationResult';
  /** Notification item */
  notifications?: Maybe<Array<Maybe<NotificationItem>>>;
  /** Validation result */
  result: ValidationResult;
  /** Was exchange query success */
  success: Scalars['Boolean'];
};

export enum NotificationStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

/** Implement Offset-based pagination result */
export type OffsetPagination = {
  totalRows: Scalars['Int'];
};

/** Input args for offset-based pagination */
export type OffsetPaginationInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

/** Password input */
export type PasswordInput = {
  /** Current password */
  currentPassword: Scalars['String'];
  /** New password */
  newPassword: Scalars['String'];
  /** Repeat new password */
  repeatNewPassword: Scalars['String'];
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float'];
  createdDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  entityContent?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['Int']>;
  entityType: PaymentEntityType;
  id?: Maybe<Scalars['Int']>;
  ownerId?: Maybe<Scalars['Int']>;
  payerAccount?: Maybe<Scalars['String']>;
  paymentId: Scalars['String'];
  paymentMethod: PaymentMethod;
  pdf?: Maybe<Scalars['String']>;
  periodEnd?: Maybe<Scalars['String']>;
  periodStart?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  transactionId?: Maybe<Scalars['String']>;
  unit: PaymentUnit;
};

export enum PaymentEntityType {
  DEPOSIT = 'DEPOSIT',
  PURCHASE_OF_ACTIVATION_CODE = 'PURCHASE_OF_ACTIVATION_CODE',
  PURCHASE_OF_EVENT_TICKET = 'PURCHASE_OF_EVENT_TICKET',
  PURCHASE_OF_GIFT_CARD = 'PURCHASE_OF_GIFT_CARD',
  PURCHASE_OF_GIFT_CARD_SCR = 'PURCHASE_OF_GIFT_CARD_SCR',
  PURCHASE_OF_GOODS = 'PURCHASE_OF_GOODS',
  PURCHASE_OF_SERVICE_PRODUCTS = 'PURCHASE_OF_SERVICE_PRODUCTS',
  PURCHASE_OF_SERVICE_SUBSCRIPTION_RENEWAL = 'PURCHASE_OF_SERVICE_SUBSCRIPTION_RENEWAL',
  PURCHASE_OF_SERVICE_SUBSCRIPTION_UPGRADE = 'PURCHASE_OF_SERVICE_SUBSCRIPTION_UPGRADE',
  PURCHASE_OF_SHOP_CREDIT = 'PURCHASE_OF_SHOP_CREDIT',
  PURCHASE_OF_STARTER_KIT = 'PURCHASE_OF_STARTER_KIT',
  PURCHASE_OF_STARTER_KIT_CODE = 'PURCHASE_OF_STARTER_KIT_CODE',
  PURCHASE_OF_SUBSCRIPTION = 'PURCHASE_OF_SUBSCRIPTION'
}

export type PaymentInitiationFormEntry = {
  __typename?: 'PaymentInitiationFormEntry';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type PaymentInitiationResult = {
  __typename?: 'PaymentInitiationResult';
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  initiationForm?: Maybe<Array<PaymentInitiationFormEntry>>;
  initiationUrl?: Maybe<Scalars['String']>;
  method?: Maybe<PaymentMethod>;
  signature?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PaymentInput = {
  amount: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  entityContent?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<Scalars['Int']>;
  entityType: PaymentEntityType;
  method: PaymentMethod;
  returnUrl?: InputMaybe<Scalars['String']>;
  selectedSourceId?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<PaymentUnit>;
};

export enum PaymentMethod {
  ACTIVATION_CODE = 'ACTIVATION_CODE',
  ADV_CASH = 'ADV_CASH',
  BANK_CARD = 'BANK_CARD',
  BANK_WIRE = 'BANK_WIRE',
  BCH = 'BCH',
  BTC = 'BTC',
  COIN_ACCOUNT = 'COIN_ACCOUNT',
  CRYPTOMUS = 'CRYPTOMUS',
  CRYPTOPAY = 'CRYPTOPAY',
  DAGPAY = 'DAGPAY',
  DAGPAY_EXTERNAL_INVOICE = 'DAGPAY_EXTERNAL_INVOICE',
  ETH = 'ETH',
  HOODPAY = 'HOODPAY',
  IDEAL = 'IDEAL',
  INTERCASH = 'INTERCASH',
  LTC = 'LTC',
  NOWPAYMENTS = 'NOWPAYMENTS',
  PAYCEK = 'PAYCEK',
  PAYPAL = 'PAYPAL',
  PAYZA = 'PAYZA',
  PAY_LATER = 'PAY_LATER',
  PERFECT_MONEY = 'PERFECT_MONEY',
  SCR = 'SCR',
  SELECTED_SOURCE = 'SELECTED_SOURCE',
  SHOP_CREDIT = 'SHOP_CREDIT',
  STRIPE = 'STRIPE',
  SUMUP = 'SUMUP',
  USDC = 'USDC',
  USDT = 'USDT'
}

export type PaymentMethodInfo = {
  __typename?: 'PaymentMethodInfo';
  enabled: Scalars['Boolean'];
  limits?: Maybe<PaymentMethodLimits>;
  method: PaymentMethod;
  name: Scalars['String'];
  sources?: Maybe<Array<PaymentMethodSource>>;
};

export type PaymentMethodLimits = {
  __typename?: 'PaymentMethodLimits';
  maximum: Monetary;
  minimum: Monetary;
};

export type PaymentMethodSource = {
  __typename?: 'PaymentMethodSource';
  priority: Scalars['Int'];
  source: PaymentSource;
};

export type PaymentSource = {
  __typename?: 'PaymentSource';
  hasExpired: Scalars['Boolean'];
  id: Scalars['ID'];
  info?: Maybe<PaymentSourceUnion>;
};

export type PaymentSourceCreditCard = {
  __typename?: 'PaymentSourceCreditCard';
  brand?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  last4?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PaymentSourceScrCredit = {
  __typename?: 'PaymentSourceScrCredit';
  available: Scalars['String'];
  currency: Currency;
};

export type PaymentSourceShopCredit = {
  __typename?: 'PaymentSourceShopCredit';
  available: Scalars['String'];
  currency: Currency;
};

export type PaymentSourceUnion = PaymentSourceCreditCard | PaymentSourceScrCredit | PaymentSourceShopCredit;

export enum PaymentStatus {
  CANCELLED = 'CANCELLED',
  INVALID = 'INVALID',
  NEW = 'NEW',
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  REFUNDED = 'REFUNDED',
  SUCCESS = 'SUCCESS',
  UNRESOLVED = 'UNRESOLVED'
}

export enum PaymentUnit {
  DAG = 'DAG',
  EUR = 'EUR',
  USD = 'USD'
}

export type PaymentsMutation = {
  __typename?: 'PaymentsMutation';
  create: PaymentInitiationResult;
};


export type PaymentsMutationCreateArgs = {
  paymentInfo: PaymentInput;
};

export type PaymentsQueries = {
  __typename?: 'PaymentsQueries';
  fetch?: Maybe<Payment>;
  get: PaymentsResult;
  result: PaymentsResult;
};


export type PaymentsQueriesFetchArgs = {
  paymentId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
};


export type PaymentsQueriesGetArgs = {
  paymentId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type PaymentsResult = {
  __typename?: 'PaymentsResult';
  error?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  success: Scalars['Boolean'];
};

export type PeopleMessages = {
  __typename?: 'PeopleMessages';
  createdDate: Scalars['String'];
  fromUser: Scalars['String'];
  fromUserId: Scalars['Int'];
  fromUserRankId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  message: Scalars['String'];
  notificationViewed?: Maybe<Scalars['String']>;
  readDate?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  toUser: Scalars['String'];
  toUserId: Scalars['Int'];
  toUserRankId?: Maybe<Scalars['Int']>;
};

export type PeriodType = {
  __typename?: 'PeriodType';
  extra: Scalars['Int'];
  name: Scalars['String'];
  period: Scalars['Int'];
  price: Scalars['Float'];
  type: Scalars['String'];
};

/** President's Club member */
export type PresidentsClubMember = {
  __typename?: 'PresidentsClubMember';
  country?: Maybe<Country>;
  id: Scalars['ID'];
  name: Scalars['String'];
  qualifications: Scalars['Int'];
  rank?: Maybe<Rank>;
};

export type PrivateNewsResult = {
  __typename?: 'PrivateNewsResult';
  news?: Maybe<NewsItem>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export enum ProductCategory {
  ACCESSORIES = 'ACCESSORIES',
  BUSINESS = 'BUSINESS',
  EDUCATIONAL = 'EDUCATIONAL',
  FOR_MEN = 'FOR_MEN',
  FOR_WOMEN = 'FOR_WOMEN',
  LEISURE = 'LEISURE',
  MOTIVATIONAL = 'MOTIVATIONAL'
}

export enum ProductColor {
  BLACK = 'BLACK',
  BLUE = 'BLUE',
  GRAY = 'GRAY',
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  WHITE = 'WHITE'
}

export type ProductForDags = {
  __typename?: 'ProductForDags';
  dateEnd: Scalars['String'];
  dateStart: Scalars['String'];
  expiresInSeconds: Scalars['Float'];
  offers: Array<ServiceOffer>;
  product: ServiceProduct;
};

export enum ProductNecklines {
  U = 'U',
  V = 'V'
}

export enum ProductSize {
  L = 'L',
  M = 'M',
  S = 'S',
  XL = 'XL',
  XS = 'XS',
  XXL = 'XXL',
  XXS = 'XXS',
  XXXL = 'XXXL',
  XXXS = 'XXXS'
}

export enum ProductSubProduct {
  BANK_CODE_BANKPASS = 'BANK_CODE_BANKPASS',
  BANK_CODE_BANKVAULT = 'BANK_CODE_BANKVAULT',
  BANK_CODE_BANKVAULT_FOREX = 'BANK_CODE_BANKVAULT_FOREX',
  EVENT_TICKET_EXCLUSIVE = 'EVENT_TICKET_EXCLUSIVE',
  EVENT_TICKET_EXCLUSIVE_TEN = 'EVENT_TICKET_EXCLUSIVE_TEN',
  EVENT_TICKET_GOLD = 'EVENT_TICKET_GOLD',
  EVENT_TICKET_GOLD_TEN = 'EVENT_TICKET_GOLD_TEN',
  EVENT_TICKET_SILVER = 'EVENT_TICKET_SILVER',
  EVENT_TICKET_SILVER_TEN = 'EVENT_TICKET_SILVER_TEN',
  EVENT_TICKET_STANDARD = 'EVENT_TICKET_STANDARD',
  EVENT_TICKET_STANDARD_TEN = 'EVENT_TICKET_STANDARD_TEN',
  EVENT_TICKET_VIP = 'EVENT_TICKET_VIP',
  EVENT_TICKET_VIP_TEN = 'EVENT_TICKET_VIP_TEN',
  FOREX_BASIC = 'FOREX_BASIC',
  STARTER_KIT_EBOOK = 'STARTER_KIT_EBOOK',
  STARTER_KIT_EBOOK_PRO = 'STARTER_KIT_EBOOK_PRO'
}

export enum ProductTypes {
  BANK_CODE = 'BANK_CODE',
  BANK_FOREX = 'BANK_FOREX',
  DAGCOIN = 'DAGCOIN',
  EVENT_TICKET = 'EVENT_TICKET',
  FOREX = 'FOREX',
  GOODS = 'GOODS',
  OTHER = 'OTHER',
  STARTER_KIT = 'STARTER_KIT'
}

export type Products = {
  __typename?: 'Products';
  category?: Maybe<Scalars['String']>;
  colors?: Maybe<Scalars['String']>;
  createdDate: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountPrice?: Maybe<Scalars['Float']>;
  entityId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  images: Array<FileType>;
  isActive: Scalars['Int'];
  isSubscription: Scalars['Int'];
  name: Scalars['String'];
  necklines?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['String']>;
  period?: Maybe<Array<PeriodType>>;
  price: Scalars['Float'];
  shopPath?: Maybe<Scalars['String']>;
  sizes?: Maybe<Scalars['String']>;
  subProduct?: Maybe<ProductSubProduct>;
  subscriptionGracePeriod?: Maybe<Scalars['Int']>;
  subscriptionStatus?: Maybe<SubscriptionStatus>;
  subscriptionType?: Maybe<SubscriptionType>;
  type?: Maybe<ProductTypes>;
  updatedDate: Scalars['String'];
  weight: Scalars['Float'];
};

/** Profile input */
export type ProfileInput = {
  /** Address */
  address?: InputMaybe<Scalars['String']>;
  /** City */
  city?: InputMaybe<Scalars['String']>;
  /** Country name */
  country?: InputMaybe<Scalars['String']>;
  /** Country ID */
  countryId?: InputMaybe<Scalars['Int']>;
  /** Country of birth */
  countryOfBirth?: InputMaybe<Scalars['String']>;
  /** Country of birth id */
  countryOfBirthId?: InputMaybe<Scalars['Int']>;
  /** Date of birth */
  dateOfBirth?: InputMaybe<Scalars['String']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']>;
  /** User language/locale */
  language?: InputMaybe<Scalars['String']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Passport/ID card expiry date */
  passportExpireDate?: InputMaybe<Scalars['String']>;
  /** Passport/Government ID */
  passportNumber?: InputMaybe<Scalars['String']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** Postcode */
  postcode?: InputMaybe<Scalars['String']>;
  /** User secret password for validation */
  secretPassword: Scalars['String'];
  /** State/County */
  state?: InputMaybe<Scalars['String']>;
};

export type PromotionItem = {
  __typename?: 'PromotionItem';
  createdDate?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['String']>;
  fileId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  status?: Maybe<PromotionStatus>;
  title?: Maybe<Scalars['String']>;
};

export enum PromotionStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

export type PromotionsResult = {
  __typename?: 'PromotionsResult';
  /** Event item */
  promotions?: Maybe<Array<Maybe<PromotionItem>>>;
  /** Validation result */
  result: ValidationResult;
  /** Was exchange query success */
  success: Scalars['Boolean'];
};

export type PublicProducts = {
  __typename?: 'PublicProducts';
  products: Array<Products>;
  totalRows: Scalars['Int'];
};

export type PublicSupportMessageInput = {
  email: Scalars['String'];
  message: Scalars['String'];
  subject: Scalars['String'];
};

export type PushNotificationDevice = {
  __typename?: 'PushNotificationDevice';
  /** Native app version */
  appVersion?: Maybe<Scalars['String']>;
  /** Notification channels to register to */
  channels: Array<Maybe<Scalars['String']>>;
  /** Device id */
  id: Scalars['Int'];
  /** locale name to send multilingual messages */
  localeName: Scalars['String'];
  /** Platform */
  platform: PushNotificationPlatformType;
  /** Push notifiaction registration token */
  token: Scalars['String'];
  /** Device owner id */
  userId: Scalars['Int'];
};

export type PushNotificationDeviceInfoInput = {
  /** locale name to send multilingual messages */
  localeName: Scalars['String'];
  /** Platform */
  platform: PushNotificationPlatformType;
  /** Push notifiaction registration token */
  registrationToken: Scalars['String'];
};

/** Support Message Result */
export type PushNotificationDeviceInfoResult = {
  __typename?: 'PushNotificationDeviceInfoResult';
  /** was info updated */
  device?: Maybe<PushNotificationDevice>;
  /** Validation result */
  result: ValidationResult;
};

/** Platform type */
export enum PushNotificationPlatformType {
  /** User device android */
  ANDROID_APP = 'ANDROID_APP',
  /** User on browser // todo web notifications */
  BROWSER = 'BROWSER',
  /** User device ios */
  IOS_APP = 'IOS_APP'
}

export type Query = {
  __typename?: 'Query';
  /** Get list of all active notifications */
  activeNotificationsList: NotificationResult;
  activeRanks: ActiveRanksResult;
  affiliateExists: Scalars['Boolean'];
  /** Authentication status */
  authenticationStatus: AuthenticationStatusResult;
  avatarInfoById?: Maybe<User>;
  canUserClaimCoins: CanUserClaimCoinsResult;
  /** Get list of all categories */
  categoryList: CategoryListResult;
  checkConfirmationPasswordLinkHash: CheckLinkHashResult;
  /** Forgotten Login hash check */
  checkLinkHash: CheckLinkHashResult;
  /** Returns a list of Circle of Champions members */
  cocMembers?: Maybe<Array<CocMember>>;
  /** Returns array of countries */
  country: CountryResult;
  /** Get single course */
  course?: Maybe<Course>;
  /** Get list of package courses sorted by order */
  courseList: Array<Maybe<Course>>;
  /** Get all course slides */
  courseSlideList: CourseSlideListResult;
  downloadsCompensationPlan?: Maybe<DownloadCompensationPlan>;
  downloadsList?: Maybe<Array<Maybe<Download>>>;
  eventById: EventByIdResult;
  /** Get list on ticket sales */
  eventTicketSales: EventResult;
  exchange: ExchangeResult;
  exchangeHistory: ExchangeHistoryResult;
  exchangeUserHistory: ExchangeHistoryResult;
  /** Public stats about forex */
  forexStats: ForexStats;
  getActiveExchangeRate: ExchangeRate;
  /** Get affiliate from session */
  getAffiliate?: Maybe<User>;
  /** Returns array of current items added to cart */
  getCartItems: Array<CartItems>;
  /** Returns total prices calculated based on cart items */
  getCartTotal: GetCartTotalResult;
  /** Returns array of event tickets with payments */
  getEventTickets: GetEventTicketsResult;
  getExchangeRates: Array<ExchangeRate>;
  /** User Forex getting started steps */
  getForexGettingStarted: ForexGettingStarted;
  /** Returns array of completed forex signals */
  getForexHistorySignals: ForexSignalsQuery;
  /** Calculates active forex idea lot size */
  getForexIdeaLotSize: ForexIdeaLotSize;
  /** Returns array of published forex news */
  getForexNews: Array<ForexNews>;
  /** Returns array of forex reports */
  getForexReports: Array<ForexReport>;
  /** Returns array of active forex signals */
  getForexSignals: Array<ForexSignals>;
  /** Returns array of signal ids current user is following */
  getForexSignalsNotifications: Array<ForexSignalsNotifications>;
  /** Returns array of gift cards owned by logged in user */
  getGiftCards: Array<GiftCard>;
  getLatestDate?: Maybe<GetLatestSupportMessageResult>;
  /** Returns structure tree user modal info */
  getMemberInfo: GetMemberInfoResult;
  /** Returns array of member shop products */
  getMemberProducts: Array<Products>;
  /** Returns array of orders with cart items */
  getOrders: Array<Cart>;
  /** Returns payment entity id */
  getPaymentEntityId?: Maybe<GetPaymentEntityId>;
  /** Returns payment status */
  getPaymentStatus?: Maybe<GetPaymentStatusResult>;
  /** Returns product data by id */
  getProduct: Products;
  /** Returns array of public shop products and totalRows */
  getPublicProducts: PublicProducts;
  /** Returns subscription with payments */
  getSubscription: Subscription;
  /** Returns array of subscriptions with payments */
  getSubscriptions: Array<Subscription>;
  getTotalBurned: TotalBurned;
  /** Returns user dashaboard products statistics */
  getUserDashboardProductsStats: Array<UserDashboardProductsStats>;
  /** Returns array of user products */
  getUserDigitalProducts: Array<DigitalProduct>;
  /** Returns array of users income centre confirmation list */
  getUserIncomeCentreConfirmationList: GetUserIncomeCentreConfrimationListResult;
  /** Returns array of users personal customers */
  getUserPersonalCustomers: GetUserCustomersResult;
  getWheelOfSuccessList: GetWheelOfSuccessListResult;
  getWheelOfSuccessPackage: WheelOfSuccessList;
  highestAvailableCourse: HighestAvailableCourseResult;
  /** Returns array of users income centre confirmation list */
  incomeCentres: UsersIncomeCentreListResult;
  /** Returns a list of countries supported by Intercash */
  intercashCountries?: Maybe<Array<Country>>;
  isEnabled: Scalars['Boolean'];
  isExchangeEnabled: Scalars['Boolean'];
  lastMomentumBoardById?: Maybe<MomentumBoard>;
  latestMessage: LatestMessageResult;
  /** Returns array of dagpay commissions */
  listDagpayCommissions: DagpayCommissionsResult;
  /** Returns array of dag points groups */
  listDagpayDagPoints: DagpayUserVolumeGroupResult;
  listOfUsersRegisteredForEvent: ListOfUsersRegisteredForEventResult;
  me: Me;
  memberAreaNews: MemberAreaNewsResult;
  momentumBoardsList?: Maybe<Array<Maybe<MomentumBoard>>>;
  news: NewsResult;
  newsFeeds: NewsFeedsResult;
  /** Get list on past events */
  pastEvents: EventResult;
  payments: PaymentsQueries;
  /** Returns a list of President's Club members */
  presidentsClubMembers?: Maybe<Array<PresidentsClubMember>>;
  privateFaqList: FaqResult;
  privateNews: PrivateNewsResult;
  /** Get list of promoted events */
  promotedEvents: EventResult;
  promotions: PromotionsResult;
  publicFaqList: FaqResult;
  pushNotificationDeviceInfo: PushNotificationDeviceInfoResult;
  rankPrizes: GetAwardResult;
  referralUsers: GetReferralUsersResult;
  /** Get list on ticket sales */
  registrationEvents: EventResult;
  sandbox: SandboxQuery;
  /** Returns service info based on config */
  service?: Maybe<ServiceProduct>;
  /** Returns best available price and related offers based on period and service codes */
  serviceOffer?: Maybe<ServiceOffer>;
  /** Returns info for every service product identifier listed */
  services?: Maybe<Array<ServiceProduct>>;
  /** Get list on upcoming events */
  upcomingEvents: EventResult;
  user?: Maybe<User>;
  userById?: Maybe<User>;
  userByUsername?: Maybe<User>;
  /** Returns list of uploaded verification documents */
  userVerificationDocuments: Array<Maybe<UserVerificationDocument>>;
  videos: VideosResult;
  viewPublicNews: ViewPublicNewsResult;
  /** Returns logged in user information or null if not logged in */
  viewer?: Maybe<User>;
};


export type QueryAffiliateExistsArgs = {
  username: Scalars['String'];
};


export type QueryAvatarInfoByIdArgs = {
  id: Scalars['Int'];
};


export type QueryCategoryListArgs = {
  contentId: Scalars['ID'];
};


export type QueryCheckConfirmationPasswordLinkHashArgs = {
  linkHash: Scalars['String'];
};


export type QueryCheckLinkHashArgs = {
  linkHash: Scalars['String'];
};


export type QueryCourseArgs = {
  id: Scalars['ID'];
  previewHash?: InputMaybe<Scalars['String']>;
};


export type QueryCourseListArgs = {
  packageId?: InputMaybe<Scalars['ID']>;
};


export type QueryCourseSlideListArgs = {
  courseId: Scalars['ID'];
  previewHash?: InputMaybe<Scalars['String']>;
};


export type QueryEventByIdArgs = {
  id: Scalars['Int'];
};


export type QueryExchangeArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  type: ExchangeOrderType;
};


export type QueryExchangeHistoryArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryExchangeUserHistoryArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryGetActiveExchangeRateArgs = {
  fromCurrency: Scalars['String'];
  toCurrency: Scalars['String'];
};


export type QueryGetCartTotalArgs = {
  shippingCountryId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetEventTicketsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryGetExchangeRatesArgs = {
  fromCurrency: Scalars['String'];
  toCurrency: Scalars['String'];
};


export type QueryGetForexHistorySignalsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryGetForexIdeaLotSizeArgs = {
  balance: Scalars['String'];
  baseCurrency: Scalars['String'];
  currencyPair: Scalars['String'];
  pip: Scalars['String'];
  riskLevel: Scalars['String'];
};


export type QueryGetForexReportsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  periodEndMonth?: InputMaybe<Scalars['Int']>;
  periodStartMonth?: InputMaybe<Scalars['Int']>;
  periods?: InputMaybe<Array<ForexPeriod>>;
  year?: InputMaybe<Scalars['Int']>;
};


export type QueryGetMemberInfoArgs = {
  userId: Scalars['Int'];
};


export type QueryGetMemberProductsArgs = {
  type?: InputMaybe<ProductTypes>;
};


export type QueryGetPaymentEntityIdArgs = {
  paymentId?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaymentStatusArgs = {
  paymentId?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductArgs = {
  id: Scalars['Int'];
};


export type QueryGetPublicProductsArgs = {
  category?: InputMaybe<ProductCategory>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryGetSubscriptionArgs = {
  id: Scalars['Int'];
};


export type QueryGetUserDigitalProductsArgs = {
  type?: InputMaybe<ProductTypes>;
};


export type QueryGetUserPersonalCustomersArgs = {
  filter?: InputMaybe<UserPersonalCustomerFilterType>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryGetWheelOfSuccessPackageArgs = {
  activationCode: Scalars['String'];
};


export type QueryIsEnabledArgs = {
  key: Scalars['String'];
};


export type QueryListDagpayCommissionsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryListDagpayDagPointsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryListOfUsersRegisteredForEventArgs = {
  eventId: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryMemberAreaNewsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryNewsArgs = {
  limit?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['String']>;
};


export type QueryPushNotificationDeviceInfoArgs = {
  token: Scalars['String'];
};


export type QueryReferralUsersArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryServiceArgs = {
  productCode: ServiceProductCode;
};


export type QueryServiceOfferArgs = {
  periodCode: ServicePeriodCode;
  productCodes: Array<ServiceProductCode>;
};


export type QueryServicesArgs = {
  productCodes: Array<ServiceProductCode>;
};


export type QueryUserByIdArgs = {
  id: Scalars['Int'];
  token: Scalars['String'];
};


export type QueryUserByUsernameArgs = {
  token: Scalars['String'];
  username: Scalars['String'];
};


export type QueryVideosArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryViewPublicNewsArgs = {
  id?: InputMaybe<Scalars['String']>;
};

/** query result with validation errors */
export type QueryResultInterface = {
  result: ValidationResult;
  success: Scalars['Boolean'];
};

/** Quick Registration input */
export type QuickRegistrationInput = {
  /** Activation code */
  activationCode?: InputMaybe<Scalars['String']>;
  /** Address */
  address: Scalars['String'];
  /** City */
  city: Scalars['String'];
  /** Country Id */
  countryId: Scalars['Int'];
  /** date of birth */
  dateOfBirth: Scalars['String'];
  /** Email */
  email: Scalars['String'];
  /** escrow time for activation code */
  escrowTime?: InputMaybe<Scalars['Int']>;
  /** First name */
  firstName: Scalars['String'];
  /** Last name */
  lastName?: InputMaybe<Scalars['String']>;
  mainAccountId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
  /** phone */
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  /** Postcode */
  postcode: Scalars['String'];
  /** Repeat email */
  repeatEmail: Scalars['String'];
  /** State */
  state: Scalars['String'];
  /** right team or left team */
  team: Scalars['String'];
  /** Username */
  username: Scalars['String'];
};

export type Rank = {
  __typename?: 'Rank';
  id: Scalars['ID'];
  nextRank?: Maybe<Rank>;
  title: Scalars['String'];
};

export type RankPrize = {
  __typename?: 'RankPrize';
  createdDate: Scalars['String'];
  eventIds?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  receivedAsMoney?: Maybe<Scalars['String']>;
  receivedPrizes?: Maybe<Scalars['String']>;
  updatedDate: Scalars['String'];
  userId: Scalars['Int'];
  userRequestedAsMoney?: Maybe<Scalars['String']>;
  userRequestedAtEvent?: Maybe<Scalars['String']>;
};

export type RankPrizesMutations = {
  __typename?: 'RankPrizesMutations';
  update: UpdateAwardResult;
};


export type RankPrizesMutationsUpdateArgs = {
  data: UpdateAwardInput;
};

export type RankPrizesQueries = {
  __typename?: 'RankPrizesQueries';
  getAward: GetAwardResult;
};

export type RecentMessagesResult = {
  __typename?: 'RecentMessagesResult';
  data: Array<ChatMessages>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export type RecognitionQuery = {
  __typename?: 'RecognitionQuery';
  rankDetails?: Maybe<RecognitionsResult>;
  ranks: GroupOfRecognitionsResult;
};


export type RecognitionQueryRankDetailsArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  rankId: Scalars['Int'];
};

export type RecognitionVolumeStats = {
  __typename?: 'RecognitionVolumeStats';
  error?: Maybe<Scalars['String']>;
  leftTeamMonthlyVolume: Scalars['Int'];
  leftTeamYearlyVolume: Scalars['Int'];
  rightTeamMonthlyVolume: Scalars['Int'];
  rightTeamYearlyVolume: Scalars['Int'];
};

export type Recognitions = {
  __typename?: 'Recognitions';
  dateAchieved?: Maybe<Scalars['String']>;
  rankId: Scalars['Int'];
  team: Scalars['String'];
  username: Scalars['String'];
};

export type RecognitionsResult = {
  __typename?: 'RecognitionsResult';
  error?: Maybe<Scalars['String']>;
  ranks?: Maybe<Array<Maybe<Recognitions>>>;
  totalRows: Scalars['Int'];
};

export type ReferralUser = {
  __typename?: 'ReferralUser';
  canClaimBonus?: Maybe<Scalars['Int']>;
  createdDate?: Maybe<Scalars['String']>;
  dagpayStatus?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBonusClaimed?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  merchantCreatedDate?: Maybe<Scalars['String']>;
  merchantHasActiveListing?: Maybe<Scalars['Boolean']>;
  merchantId?: Maybe<Scalars['ID']>;
  merchantIsEmailVerified?: Maybe<Scalars['Boolean']>;
  merchantIsUserVerified?: Maybe<Scalars['Boolean']>;
  merchantUserId?: Maybe<Scalars['ID']>;
  ownerId: Scalars['ID'];
  timeLeftTillBonus?: Maybe<Scalars['Int']>;
};

export enum ReferralUserStatus {
  BUSINESS_VERIFIED = 'BUSINESS_VERIFIED',
  EMAIL_VERIFIED = 'EMAIL_VERIFIED',
  IDENTITY_VERIFIED = 'IDENTITY_VERIFIED',
  REGISTERED = 'REGISTERED'
}

export type ReferralsStats = {
  __typename?: 'ReferralsStats';
  active: Scalars['Int'];
  customers: Scalars['Int'];
  registrations: Scalars['Int'];
};

export type ReferralsSubscription = {
  __typename?: 'ReferralsSubscription';
  createdDate: Scalars['String'];
  expiresDate: Scalars['String'];
  id: Scalars['String'];
  products: Array<ServiceProduct>;
  referral: UserInfo;
  status: ReferralsSubscriptionStatus;
};

export enum ReferralsSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  ACTIVE_DISCOUNT = 'ACTIVE_DISCOUNT',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  PENDING_DISCOUNT = 'PENDING_DISCOUNT'
}

export type ReferralsSubscriptionsPerMonth = {
  __typename?: 'ReferralsSubscriptionsPerMonth';
  current: Scalars['Boolean'];
  discountedExtension: Scalars['Boolean'];
  freeExtension: Scalars['Boolean'];
  month: Scalars['Int'];
  records: Array<ReferralsSubscription>;
  year: Scalars['Int'];
};

/** Support Message Result */
export type RegisterPushNotificationDeviceResult = {
  __typename?: 'RegisterPushNotificationDeviceResult';
  /** Validation result */
  result: ValidationResult;
  /** was info updated */
  success: Scalars['Boolean'];
};

export type RegisterTicketInput = {
  country: Scalars['Int'];
  eventId: Scalars['Int'];
  guestFullName?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  otherLanguage?: InputMaybe<Scalars['String']>;
  receiverUsername?: InputMaybe<Scalars['String']>;
  secretPassword: Scalars['String'];
  ticketId: Scalars['Int'];
  ticketIsGivenTo: Scalars['String'];
};

/** Registration input */
export type RegistrationInput = {
  /** Activation code */
  activationCode?: InputMaybe<Scalars['String']>;
  /** Address */
  address: Scalars['String'];
  /** Affiliate Id */
  affiliateId?: InputMaybe<Scalars['String']>;
  /** City */
  city: Scalars['String'];
  /** Country Id */
  countryId: Scalars['Int'];
  /** date of birth */
  dateOfBirth: Scalars['String'];
  /** Email */
  email: Scalars['String'];
  /** escrow time for activation code */
  escrowTime: Scalars['Int'];
  /** First name */
  firstName: Scalars['String'];
  /** Last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Packet Id */
  packet: Scalars['Int'];
  /** Password */
  password: Scalars['String'];
  /** Payment type */
  paymentType: Scalars['String'];
  /** phone */
  phone?: InputMaybe<Scalars['String']>;
  /** Postcode */
  postcode: Scalars['String'];
  /** Repeat email */
  repeatEmail: Scalars['String'];
  /** Repeat Password */
  repeatPassword: Scalars['String'];
  /** Repeat Secret Password */
  repeatSecretPassword: Scalars['String'];
  /** Secret Password */
  secretPassword: Scalars['String'];
  /** Should passwords be sent with registration email */
  sendPasswordWithEmail?: InputMaybe<Scalars['Int']>;
  /** State */
  state: Scalars['String'];
  /** Terms And Conditions */
  termsAndConditions: Scalars['Int'];
  /** Username */
  username: Scalars['String'];
};

/** Registration Result */
export type RegistrationResult = {
  __typename?: 'RegistrationResult';
  /** New user ID or null if failed */
  id?: Maybe<Scalars['Int']>;
  /** Validation result */
  result: ValidationResult;
};

export type SandBoxNotificationDataInput = {
  description: Scalars['String'];
};

/** Form test input data */
export type SandboxFormInput = {
  /** User age */
  age: Scalars['Int'];
  /** User email */
  email: Scalars['String'];
  /** User name */
  name: Scalars['String'];
};

export type SandboxMutation = {
  __typename?: 'SandboxMutation';
  /** Test form submission error handling (yes it should be normally a mutation) */
  form: ValidationResult;
  /** Throws an error inside database method */
  testDatabaseThrowError: Scalars['Int'];
  /** Test push notification */
  testPushNotification: Scalars['String'];
  /** Returns an error from the resolver */
  testResolverReturnError: Scalars['Int'];
  /** Returns an invalid value */
  testResolverReturnInvalid: Scalars['Int'];
  /** Throws an error inside the resolver */
  testResolverThrowError: Scalars['Int'];
};


export type SandboxMutationFormArgs = {
  info: SandboxFormInput;
};


export type SandboxMutationTestPushNotificationArgs = {
  data: SandboxPushNotificationInput;
};

/** Payment inititiation info */
export type SandboxPaymentInitiationResult = {
  __typename?: 'SandboxPaymentInitiationResult';
  /** Payment identifier (null if failed) */
  id?: Maybe<Scalars['String']>;
  /** Was initiating the payment successful */
  success: Scalars['Boolean'];
};

export type SandboxPushNotificationInput = {
  /** Notification body */
  body: Scalars['String'];
  /** Notification channel id */
  channelId?: InputMaybe<Scalars['String']>;
  /** Notification data */
  data?: InputMaybe<SandBoxNotificationDataInput>;
  /** Notification title */
  title: Scalars['String'];
  /** User id to send notification */
  to: Scalars['Int'];
};

/** Namespace for testing various GraphQL features */
export type SandboxQuery = {
  __typename?: 'SandboxQuery';
  /** Returns sandbox user, simulating asyncronously fetch */
  asyncUser?: Maybe<SandboxUser>;
  /** Simulates returning error when a return value was promised */
  errorDefinitely?: Maybe<Scalars['String']>;
  /** Simulates returning error when no return value was promised */
  errorMaybe?: Maybe<Scalars['String']>;
  /** Simulates throwing error when a return value was promised */
  exceptionDefinitely: Scalars['String'];
  /** Simulates throwing error when no return value was promised */
  exceptionMaybe?: Maybe<Scalars['String']>;
  /** Simulates throwing error in an asyncronous handler (currently crashes server) */
  exceptionPromise: Scalars['String'];
  /** Returns a list of integers */
  list: Array<Scalars['Int']>;
  /** Returns a simple string */
  message: Scalars['String'];
  /** Returns an ever-increasing counter based on user session */
  session: Scalars['Int'];
  /** Returns sum of two required integers */
  sum: Scalars['Int'];
  /** Returns base64 pdf */
  testPdf: Scalars['String'];
  /** Returns sandbox user by id or null if not found */
  user?: Maybe<SandboxUser>;
};


/** Namespace for testing various GraphQL features */
export type SandboxQueryAsyncUserArgs = {
  id: Scalars['Int'];
};


/** Namespace for testing various GraphQL features */
export type SandboxQuerySumArgs = {
  a: Scalars['Int'];
  b: Scalars['Int'];
};


/** Namespace for testing various GraphQL features */
export type SandboxQueryUserArgs = {
  id: Scalars['Int'];
};

/** Represents a sandbox user */
export type SandboxUser = {
  __typename?: 'SandboxUser';
  /** User identifier */
  id: Scalars['Int'];
  /** User name */
  name: Scalars['String'];
};

export type SandboxUserInput = {
  /** User id */
  id: Scalars['Int'];
  /** User username */
  username: Scalars['String'];
};

export type SaveCourseSlideBookmarkResult = {
  __typename?: 'SaveCourseSlideBookmarkResult';
  /** Validation result */
  result: ValidationResult;
  /** User user course slide bookmark */
  success: Scalars['Boolean'];
};

export type SaveUserAvatarResult = {
  __typename?: 'SaveUserAvatarResult';
  /** Validation result */
  result: ValidationResult;
  /** User avatar updated */
  success: Scalars['Boolean'];
};

/** Password input */
export type SecretPasswordInput = {
  /** Current Secret password */
  currentSecretPassword: Scalars['String'];
  /** New Secret password */
  newSecretPassword: Scalars['String'];
  /** Repeat new Secret password */
  repeatNewSecretPassword: Scalars['String'];
};

export type ServiceCart = {
  __typename?: 'ServiceCart';
  codeDiscount?: Maybe<Scalars['String']>;
  comboDiscount?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  discountApplied?: Maybe<ServiceDiscount>;
  finalizationHash: Scalars['String'];
  id: Scalars['ID'];
  items: Array<ServiceCartItem>;
  offers: Array<ServiceOffer>;
  taxCountryId?: Maybe<Scalars['String']>;
  totalDiscount?: Maybe<Scalars['String']>;
  totalFee?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['String']>;
  totalPriceWithoutTax?: Maybe<Scalars['String']>;
  totalScr?: Maybe<Scalars['String']>;
  totalShipping?: Maybe<Scalars['String']>;
  totalTax?: Maybe<Scalars['String']>;
};


export type ServiceCartCodeDiscountArgs = {
  method: PaymentMethod;
};


export type ServiceCartComboDiscountArgs = {
  method: PaymentMethod;
};


export type ServiceCartTotalDiscountArgs = {
  method: PaymentMethod;
};


export type ServiceCartTotalFeeArgs = {
  method: PaymentMethod;
};


export type ServiceCartTotalPriceArgs = {
  method: PaymentMethod;
};


export type ServiceCartTotalPriceWithoutTaxArgs = {
  method: PaymentMethod;
};


export type ServiceCartTotalTaxArgs = {
  method: PaymentMethod;
};

export type ServiceCartItem = {
  __typename?: 'ServiceCartItem';
  cart: ServiceCart;
  id: Scalars['ID'];
  period: ServicePeriod;
  product: ServiceProduct;
  quantity?: Maybe<Scalars['Int']>;
};

export type ServiceDiscount = {
  __typename?: 'ServiceDiscount';
  code: Scalars['String'];
  id: Scalars['ID'];
  percent?: Maybe<Scalars['Float']>;
  value?: Maybe<Monetary>;
};

export type ServiceOffer = {
  __typename?: 'ServiceOffer';
  activeSubscription?: Maybe<ServiceSubscription>;
  availability: ServiceOfferAvailability;
  currency: Currency;
  discount: Scalars['String'];
  discountEur: Scalars['String'];
  discountNext?: Maybe<Scalars['String']>;
  discountNextEur?: Maybe<Scalars['String']>;
  discountedPrice?: Maybe<Scalars['String']>;
  discountedPriceEur?: Maybe<Scalars['String']>;
  discountedPriceNext?: Maybe<Scalars['String']>;
  discountedPriceNextEur?: Maybe<Scalars['String']>;
  fullPrice: Scalars['String'];
  fullPriceEur: Scalars['String'];
  fullPriceNext?: Maybe<Scalars['String']>;
  fullPriceNextEur?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  labelText?: Maybe<Scalars['String']>;
  maxScrAmount: Scalars['String'];
  period: ServicePeriod;
  products: Array<ServiceProduct>;
  upgradableSubscriptions: Array<ServiceSubscription>;
};

export enum ServiceOfferAvailability {
  AVAILABLE_FOR_PURCHASE = 'AVAILABLE_FOR_PURCHASE',
  AVAILABLE_FOR_UPGRADE = 'AVAILABLE_FOR_UPGRADE',
  UNAVAILABLE_ALREADY_IN_CART = 'UNAVAILABLE_ALREADY_IN_CART',
  UNAVAILABLE_ALREADY_SUBSCRIBED = 'UNAVAILABLE_ALREADY_SUBSCRIBED',
  UNAVAILABLE_FOR_COUNTRY = 'UNAVAILABLE_FOR_COUNTRY',
  UNAVAILABLE_FOR_UPGRADE = 'UNAVAILABLE_FOR_UPGRADE'
}

export type ServicePeriod = {
  __typename?: 'ServicePeriod';
  code: ServicePeriodCode;
  name: Scalars['String'];
};

export enum ServicePeriodCode {
  LIFETIME = 'LIFETIME',
  ONE_MONTH = 'ONE_MONTH',
  SIX_MONTHS = 'SIX_MONTHS',
  TWELVE_MONTHS = 'TWELVE_MONTHS'
}

export type ServiceProduct = {
  __typename?: 'ServiceProduct';
  code: ServiceProductCode;
  isActive: Scalars['Boolean'];
  isQuantifiable: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  offers: Array<ServiceOffer>;
};

export enum ServiceProductCode {
  AWENTURES = 'AWENTURES',
  BANCUS = 'BANCUS',
  BANK_BASIC = 'BANK_BASIC',
  BANK_FULL = 'BANK_FULL',
  BUSINESS_FEE_BASIC = 'BUSINESS_FEE_BASIC',
  BUSINESS_FEE_PRO = 'BUSINESS_FEE_PRO',
  FOREX = 'FOREX',
  FOREX_PRO = 'FOREX_PRO',
  HUNTER_SYSTEMS_BASIC = 'HUNTER_SYSTEMS_BASIC',
  HUNTER_SYSTEMS_PLUS = 'HUNTER_SYSTEMS_PLUS',
  HUNTER_SYSTEMS_PRO = 'HUNTER_SYSTEMS_PRO',
  HUNTER_SYSTEMS_STANDARD = 'HUNTER_SYSTEMS_STANDARD',
  MEMBERSHIP_BASIC = 'MEMBERSHIP_BASIC',
  MEMBERSHIP_PRO = 'MEMBERSHIP_PRO',
  PLATFORM_FEE = 'PLATFORM_FEE',
  SF_MARKETING_FEE = 'SF_MARKETING_FEE',
  VIEW_BASIC = 'VIEW_BASIC',
  VIEW_STANDARD = 'VIEW_STANDARD',
  VIEW_SUPER = 'VIEW_SUPER',
  VIEW_ULTRA = 'VIEW_ULTRA',
  VIEW_ULTRA_PLUS = 'VIEW_ULTRA_PLUS'
}

export type ServiceSubscription = {
  __typename?: 'ServiceSubscription';
  billingAmount?: Maybe<Scalars['String']>;
  billingCurrency: Currency;
  billingDate?: Maybe<Scalars['String']>;
  dateEnd?: Maybe<Scalars['String']>;
  dateStart: Scalars['String'];
  expiresInSeconds: Scalars['String'];
  gracePeriodDateEnd: Scalars['String'];
  gracePeriodExpiresInSeconds: Scalars['String'];
  id: Scalars['ID'];
  isContinuable: Scalars['Boolean'];
  isDiscontinuable: Scalars['Boolean'];
  isLegacy: Scalars['Boolean'];
  period: ServicePeriod;
  periodCode: ServicePeriodCode;
  productCodes: Array<ServiceProductCode>;
  products: Array<ServiceProduct>;
  referralsStatsForCurrentMonth?: Maybe<ReferralsStats>;
  referralsSubscriptionsActiveForNearestMonths?: Maybe<Array<ReferralsSubscriptionsPerMonth>>;
  referralsSubscriptionsActiveForPreviousMonths?: Maybe<Array<ReferralsSubscriptionsPerMonth>>;
  referralsSubscriptionsForCurrentMonth?: Maybe<ReferralsSubscriptionsPerMonth>;
  status: ServiceSubscriptionStatus;
  upgradeOffers: Array<ServiceOffer>;
};


export type ServiceSubscriptionBillingAmountArgs = {
  method: PaymentMethod;
};

export type ServiceSubscriptionInvoice = {
  __typename?: 'ServiceSubscriptionInvoice';
  amount?: Maybe<Scalars['String']>;
  createdDate: Scalars['String'];
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  orderNo: Scalars['String'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodName?: Maybe<Scalars['String']>;
  paymentSource?: Maybe<PaymentSource>;
  paymentType?: Maybe<PaymentEntityType>;
  products: Array<ServiceSubscriptionInvoiceService>;
  status: PaymentStatus;
};

export type ServiceSubscriptionInvoiceService = {
  __typename?: 'ServiceSubscriptionInvoiceService';
  periodCode: ServicePeriodCode;
  productNames: Array<Scalars['String']>;
};

export type ServiceSubscriptionInvoicesResult = OffsetPagination & {
  __typename?: 'ServiceSubscriptionInvoicesResult';
  rows: Array<ServiceSubscriptionInvoice>;
  totalRows: Scalars['Int'];
};

export enum ServiceSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  DISCONTINUED = 'DISCONTINUED',
  EXPIRED = 'EXPIRED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_PENDING = 'PAYMENT_PENDING'
}

export type ServiceSubscriptionUpgrade = {
  __typename?: 'ServiceSubscriptionUpgrade';
  currency: Currency;
  difference: Scalars['String'];
  differenceFee: Scalars['String'];
  differenceTax: Scalars['String'];
  differenceTotal: Scalars['String'];
  id: Scalars['ID'];
  offer: ServiceOffer;
};


export type ServiceSubscriptionUpgradeDifferenceFeeArgs = {
  method: PaymentMethod;
};


export type ServiceSubscriptionUpgradeDifferenceTaxArgs = {
  method: PaymentMethod;
};


export type ServiceSubscriptionUpgradeDifferenceTotalArgs = {
  method: PaymentMethod;
};

export type SetSwipexAccountLinkStatusInput = {
  action: SwipexAccountLinkRequestAction;
  swipexAccountName: Scalars['String'];
};

/** Skillex sign up result */
export type SkillexSignUpResult = {
  __typename?: 'SkillexSignUpResult';
  /** error (null if success) */
  error?: Maybe<Scalars['String']>;
  /** Was signUp successful */
  success: Scalars['Boolean'];
  /** JWT token with user data */
  url: Scalars['String'];
};

export type StarterKitInputObject = {
  amount?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<SubscriptionPeriod>;
  vat?: InputMaybe<Scalars['Int']>;
};

export type StatisticsQuery = {
  __typename?: 'StatisticsQuery';
  commissions: CommissionsStatsResult;
  directSales: DirectSalesStatsResult;
  leadershipBonus: LeadershipBonusStatsResult;
  members: MembersStats;
  membersCountInPeriod: MembersCountInPeriodResult;
  ranks?: Maybe<LeadershipRankStatsResult>;
  volume: RecognitionVolumeStats;
};


export type StatisticsQueryCommissionsArgs = {
  yearweek?: InputMaybe<Scalars['Int']>;
};


export type StatisticsQueryMembersCountInPeriodArgs = {
  groupByDay?: InputMaybe<Scalars['Int']>;
  groupByMonth?: InputMaybe<Scalars['Int']>;
  groupByWeek?: InputMaybe<Scalars['Int']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  cancelledByUser: Scalars['Int'];
  createdDate: Scalars['String'];
  failedDate?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastTryDate?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
  paymentExpireDate?: Maybe<Scalars['String']>;
  payments: Array<SubscriptionPayments>;
  period?: Maybe<Array<SubscriptionPeriodType>>;
  price: Scalars['Float'];
  productId: Scalars['Int'];
  productInformation?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  provider: SubscriptionProvider;
  status: SubscriptionStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  type?: Maybe<SubscriptionType>;
  updatedDate: Scalars['String'];
};

export type SubscriptionPayments = {
  __typename?: 'SubscriptionPayments';
  amount: Scalars['Float'];
  createdDate: Scalars['String'];
  description: Scalars['String'];
  periodEnd?: Maybe<Scalars['String']>;
  periodStart?: Maybe<Scalars['String']>;
  productSubProduct?: Maybe<ProductSubProduct>;
  productType?: Maybe<ProductTypes>;
  status: PaymentStatus;
};

export enum SubscriptionPeriod {
  ANNUAL = 'ANNUAL',
  MONTHLY = 'MONTHLY',
  SEMIANNUAL = 'SEMIANNUAL'
}

export type SubscriptionPeriodType = {
  __typename?: 'SubscriptionPeriodType';
  extra: Scalars['Int'];
  name: Scalars['String'];
  period: Scalars['Int'];
  price: Scalars['Float'];
  type: Scalars['String'];
};

export enum SubscriptionProvider {
  ACTIVATION_CODE = 'ACTIVATION_CODE',
  STRIPE = 'STRIPE'
}

export enum SubscriptionStatus {
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  GRACE_PERIOD = 'GRACE_PERIOD',
  NOT_PAID = 'NOT_PAID',
  PAID = 'PAID',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PENDING = 'PENDING'
}

export enum SubscriptionType {
  ANNUAL = 'ANNUAL',
  MONTHLY = 'MONTHLY',
  SEMIANNUAL = 'SEMIANNUAL'
}

export enum SupportCategoryTypes {
  EMAIL_CHANGE = 'EMAIL_CHANGE',
  FINANCIAL = 'FINANCIAL',
  OTHER = 'OTHER',
  OWNERSHIP_CHANGE = 'OWNERSHIP_CHANGE',
  PASSWORD_CHANGE = 'PASSWORD_CHANGE',
  TEAM_BUILDING = 'TEAM_BUILDING',
  TECHNICAL = 'TECHNICAL',
  VERIFICATION = 'VERIFICATION',
  WALLET_ADDRESS_CHANGE = 'WALLET_ADDRESS_CHANGE'
}

export type SupportMessage = {
  __typename?: 'SupportMessage';
  category: SupportCategoryTypes;
  id: Scalars['Int'];
  message: Scalars['String'];
  ownerId: Scalars['String'];
  status?: Maybe<SupportMessageStatus>;
  subject: Scalars['String'];
};

export type SupportMessageAttachment = {
  __typename?: 'SupportMessageAttachment';
  content: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['Int'];
  messageId: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type SupportMessageAttachmentInput = {
  content: Scalars['String'];
  messageId: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type SupportMessageAttachmentResult = {
  __typename?: 'SupportMessageAttachmentResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type SupportMessageInput = {
  category: SupportCategoryTypes;
  message: Scalars['String'];
  subject: Scalars['String'];
};

export type SupportMessageResult = {
  __typename?: 'SupportMessageResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export enum SupportMessageStatus {
  CLOSED = 'CLOSED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export enum SwipexAccountLinkRequestAction {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export type Team = TeamInterface & {
  __typename?: 'Team';
  createdDate: Scalars['String'];
  details: Array<TeamDetails>;
  id: Scalars['ID'];
  isJoinable?: Maybe<Scalars['Boolean']>;
  membersCount: Scalars['Int'];
  owner: TeamMember;
};

export type TeamBlockedMember = {
  __typename?: 'TeamBlockedMember';
  country?: Maybe<Country>;
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};

export type TeamBuildingPriorityResult = {
  __typename?: 'TeamBuildingPriorityResult';
  /** Validation result */
  result: ValidationResult;
  /** Was updated success */
  success: Scalars['Boolean'];
};

export type TeamDetails = {
  __typename?: 'TeamDetails';
  content: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  status: TeamDetailsStatusEnum;
  type: TeamDetailsType;
};

export enum TeamDetailsStatusEnum {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum TeamDetailsType {
  DESCRIPTION = 'DESCRIPTION',
  LOGO_PATH = 'LOGO_PATH',
  MISSION_STATEMENT = 'MISSION_STATEMENT',
  NAME = 'NAME',
  RULES = 'RULES'
}

export type TeamInterface = {
  createdDate: Scalars['String'];
  details: Array<TeamDetails>;
  id: Scalars['ID'];
  membersCount: Scalars['Int'];
  owner: TeamMember;
};

export type TeamLeaderboard = {
  __typename?: 'TeamLeaderboard';
  affiliates?: Maybe<Array<TeamLeaderboardResult>>;
  customers?: Maybe<Array<TeamLeaderboardResult>>;
};


export type TeamLeaderboardAffiliatesArgs = {
  period: Scalars['String'];
};


export type TeamLeaderboardCustomersArgs = {
  period: Scalars['String'];
};

export enum TeamLeaderboardPeriods {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export type TeamLeaderboardResult = {
  __typename?: 'TeamLeaderboardResult';
  avatar: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  rankId: Scalars['Int'];
  totalUsers: Scalars['Int'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  country?: Maybe<Country>;
  displayName: Scalars['String'];
  highestRank?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isItMe: Scalars['Boolean'];
  joinedDate?: Maybe<Scalars['String']>;
  rankId?: Maybe<Scalars['Int']>;
  role: TeamMemberRole;
  username?: Maybe<Scalars['String']>;
};

export enum TeamMemberRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

export type TeamMembersResult = {
  __typename?: 'TeamMembersResult';
  rows: Array<TeamMember>;
  totalRows: Scalars['Int'];
};

export type TeamNews = {
  __typename?: 'TeamNews';
  author: TeamMember;
  content: Scalars['String'];
  createdDate: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type TeamNewsResult = {
  __typename?: 'TeamNewsResult';
  hasMore: Scalars['Boolean'];
  lastId?: Maybe<Scalars['ID']>;
  rows: Array<TeamNews>;
};

export type TeamResource = {
  __typename?: 'TeamResource';
  category: TeamResourceCategory;
  createdDate: Scalars['String'];
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: TeamResourceStatus;
};

export enum TeamResourceCategory {
  DESIGN = 'DESIGN',
  PRESENTATION = 'PRESENTATION',
  TRAINING_MATERIAL = 'TRAINING_MATERIAL'
}

export enum TeamResourceStatus {
  ACCEPTED = 'ACCEPTED',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum TeamStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  IN_REVIEW = 'IN_REVIEW'
}

export enum TeamType {
  BOTH = 'BOTH',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export type TheViewForDagsOfferType = {
  __typename?: 'TheViewForDagsOfferType';
  dagOffer: ServiceOffer;
  eurOffer: ServiceOffer;
  eurOfferPurchaseDate: Scalars['String'];
  id: Scalars['ID'];
};

export type TheViewForDagsType = {
  __typename?: 'TheViewForDagsType';
  dateEnd: Scalars['String'];
  dateStart: Scalars['String'];
  expiresInSeconds: Scalars['Float'];
  offers: Array<TheViewForDagsOfferType>;
};

export type TicketsInput = {
  id?: InputMaybe<Scalars['Int']>;
  tickets?: InputMaybe<TicketsTypeInput>;
};

export type TicketsPrices = {
  EXCLUSIVE?: InputMaybe<Scalars['Int']>;
  EXCLUSIVETEN?: InputMaybe<Scalars['Int']>;
  GOLD?: InputMaybe<Scalars['Int']>;
  GOLDTEN?: InputMaybe<Scalars['Int']>;
  SILVER?: InputMaybe<Scalars['Int']>;
  SILVERTEN?: InputMaybe<Scalars['Int']>;
  STANDARD?: InputMaybe<Scalars['Int']>;
  STANDARDTEN?: InputMaybe<Scalars['Int']>;
  VIP?: InputMaybe<Scalars['Int']>;
  VIPTEN?: InputMaybe<Scalars['Int']>;
};

export type TicketsTypeInput = {
  Exclusive?: InputMaybe<Scalars['Int']>;
  ExclusiveTen?: InputMaybe<Scalars['Int']>;
  Gold?: InputMaybe<Scalars['Int']>;
  GoldTen?: InputMaybe<Scalars['Int']>;
  Silver?: InputMaybe<Scalars['Int']>;
  SilverTen?: InputMaybe<Scalars['Int']>;
  Standard?: InputMaybe<Scalars['Int']>;
  StandardTen?: InputMaybe<Scalars['Int']>;
  Vip?: InputMaybe<Scalars['Int']>;
  VipTen?: InputMaybe<Scalars['Int']>;
};

export type TotalBurned = {
  __typename?: 'TotalBurned';
  rate: Scalars['Float'];
  totalDags: Scalars['String'];
};

export type TradingAccountFields = {
  __typename?: 'TradingAccountFields';
  transactions?: Maybe<TradingAccountResult>;
};


export type TradingAccountFieldsTransactionsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type TradingAccountResult = QueryResultInterface & {
  __typename?: 'TradingAccountResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
  transactions?: Maybe<Array<TradingAccountTransaction>>;
};

export type TradingAccountTransaction = {
  __typename?: 'TradingAccountTransaction';
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  transactionDate: Scalars['String'];
  transactionStatus: TradingAccountTransactionStatus;
  transactionType: TradingAccountTransactionType;
};

export enum TradingAccountTransactionStatus {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SUCCESS = 'SUCCESS'
}

export enum TradingAccountTransactionType {
  FROM_LINKED_ACCOUNT = 'FROM_LINKED_ACCOUNT',
  PURCHASE_OF_COINS = 'PURCHASE_OF_COINS',
  TO_LINKED_ACCOUNT = 'TO_LINKED_ACCOUNT',
  TRANSFER_FROM_CASH_ACCOUNT = 'TRANSFER_FROM_CASH_ACCOUNT',
  TRANSFER_TO_COIN_ACCOUNT = 'TRANSFER_TO_COIN_ACCOUNT',
  TRANSFER_TO_SWIPEX = 'TRANSFER_TO_SWIPEX',
  WEEKLY_COMMISSION = 'WEEKLY_COMMISSION'
}

export type UpSellOfferUnion = ServiceCart | ServiceSubscriptionUpgrade;

export type UpdateAwardInput = {
  userRequestedAsMoney?: InputMaybe<Scalars['String']>;
  userRequestedAtEvent?: InputMaybe<Scalars['String']>;
};

export type UpdateAwardResult = {
  __typename?: 'UpdateAwardResult';
  success: Scalars['Boolean'];
};

export type UpdateCompanyResult = QueryResultInterface & {
  __typename?: 'UpdateCompanyResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type UpdatePushNotificationDeviceInfoInput = {
  /** Native app version */
  appVersion: Scalars['String'];
  /** Notification channels to register to */
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** locale name to send multilingual messages */
  localeName: Scalars['String'];
  /** Native package id */
  packageId?: InputMaybe<Scalars['String']>;
  /** Platform */
  platform: PushNotificationPlatformType;
  /** Push notifiaction registration token */
  registrationToken: Scalars['String'];
};

export type UpdatePushNotificationDeviceResult = {
  __typename?: 'UpdatePushNotificationDeviceResult';
  /** updated device info */
  device?: Maybe<PushNotificationDevice>;
  /** Validation result */
  result: ValidationResult;
  /** was info updated */
  success: Scalars['Boolean'];
};

export type UpdateReferralUsersResult = {
  __typename?: 'UpdateReferralUsersResult';
  /** Response */
  referrals: Array<Maybe<ReferralUser>>;
  /** Validation result */
  result: ValidationResult;
  /** Was query successful */
  success: Scalars['Boolean'];
};

export enum UpdateTeamStatusStatus {
  ACTIVE = 'ACTIVE'
}

export type UpgradeTicketInput = {
  secretPassword: Scalars['String'];
  ticketId: Scalars['Int'];
  upgradeTo: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  activationDate?: Maybe<Scalars['String']>;
  activeBusinessFeeCount?: Maybe<Scalars['Int']>;
  activePacketId?: Maybe<Scalars['Int']>;
  activeRanks: ActiveRanksResult;
  activeStarterKit?: Maybe<Scalars['Int']>;
  activeVerification?: Maybe<UserVerification>;
  address?: Maybe<Scalars['String']>;
  advCashAccount?: Maybe<Scalars['String']>;
  affiliateActiveDate?: Maybe<Scalars['String']>;
  affiliateId?: Maybe<Scalars['Int']>;
  becomeAffiliateCountdown?: Maybe<Scalars['Int']>;
  bitcoinWalletAddress?: Maybe<Scalars['String']>;
  bonusCap?: Maybe<Scalars['Int']>;
  canChooseIncomeCentre?: Maybe<Scalars['Boolean']>;
  cashAccount: CashAccountFields;
  cashAccountBalance?: Maybe<Scalars['Float']>;
  children: ChildrenResult;
  city?: Maybe<Scalars['String']>;
  coinAccount: CoinAccountFields;
  coinAccountBalance?: Maybe<Scalars['Float']>;
  commissions: CommissionsFields;
  company: CompanyQuery;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  countryOfBirth?: Maybe<Scalars['String']>;
  countryOfBirthId?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currency>;
  dagcoinWalletAddress?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  depth?: Maybe<Scalars['Int']>;
  descendants?: Maybe<Scalars['Int']>;
  directMembers: DirectMembers;
  email?: Maybe<Scalars['String']>;
  escrowCoinAccountBalance?: Maybe<Scalars['Float']>;
  eventTickets: UserEventTicketsQuery;
  firstName?: Maybe<Scalars['String']>;
  forceEmailChange: Scalars['Boolean'];
  gen?: Maybe<Scalars['Int']>;
  genealogy: Genealogy;
  hasAccessToWebOffice: Scalars['Boolean'];
  hasActiveStarterKit: Scalars['Boolean'];
  hasCustomerWaitingForConfirmation?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  incomeCentres?: Maybe<UsersIncomeCentreListResult>;
  invoices: InvoiceQuery;
  isActive?: Maybe<Scalars['String']>;
  isBlocked?: Maybe<Scalars['Int']>;
  isCustomer: Scalars['Boolean'];
  isVerifiedForced?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  leadership: Members;
  leftId?: Maybe<Scalars['Int']>;
  leftTeamMonthlyVolume?: Maybe<Scalars['Int']>;
  leftTeamRankId?: Maybe<Scalars['Int']>;
  leftTeamRankUserId?: Maybe<Scalars['Int']>;
  leftTeamVolume?: Maybe<Scalars['Int']>;
  leftTeamYearlyVolume?: Maybe<Scalars['Int']>;
  mainAccountId?: Maybe<Scalars['Int']>;
  mainUserId?: Maybe<Scalars['Int']>;
  mainUsername?: Maybe<Scalars['String']>;
  maxRankId?: Maybe<Scalars['Int']>;
  members: Members;
  messages: MessagesQuery;
  mustUpdateProfile?: Maybe<Scalars['Int']>;
  packages: UserPackagesQuery;
  parentDescendants?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  passportExpireDate?: Maybe<Scalars['String']>;
  passportNumber?: Maybe<Scalars['String']>;
  payzaAccount?: Maybe<Scalars['String']>;
  perfectMoneyAccount?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  rank?: Maybe<UserRankInfoResult>;
  rankAward: GetAwardResult;
  rankId: Scalars['Int'];
  recognition: RecognitionQuery;
  referralCode?: Maybe<Scalars['String']>;
  referralRegistrationUrl?: Maybe<Scalars['String']>;
  referralUsersTotal?: Maybe<Scalars['Int']>;
  registerDate?: Maybe<Scalars['String']>;
  rightId?: Maybe<Scalars['Int']>;
  rightTeamMonthlyVolume?: Maybe<Scalars['Int']>;
  rightTeamRankId?: Maybe<Scalars['Int']>;
  rightTeamRankUserId?: Maybe<Scalars['Int']>;
  rightTeamVolume?: Maybe<Scalars['Int']>;
  rightTeamYearlyVolume?: Maybe<Scalars['Int']>;
  scrCreditBalance: Scalars['Float'];
  shopCreditBalance: Scalars['Float'];
  sponsorId?: Maybe<Scalars['Int']>;
  sponsorName?: Maybe<Scalars['String']>;
  starterKit: UserStarterKitPackagesQuery;
  starterKitData: UserStarterKitPackages;
  state?: Maybe<Scalars['String']>;
  statistics: StatisticsQuery;
  stripeCustomerId?: Maybe<Scalars['String']>;
  swipexAccount?: Maybe<Scalars['String']>;
  team?: Maybe<Scalars['String']>;
  teamBuildingPriority?: Maybe<Scalars['String']>;
  timeFromPreviousLogin?: Maybe<Scalars['Int']>;
  totalCustomerVolume?: Maybe<Scalars['Int']>;
  totalMembersInLeft?: Maybe<Scalars['Int']>;
  totalMembersInRight?: Maybe<Scalars['Int']>;
  totalSponsoredChildren?: Maybe<Scalars['Int']>;
  tradingAccount: TradingAccountFields;
  tradingAccountBalance?: Maybe<Scalars['Float']>;
  userIncomeCentre?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  verifyStatus?: Maybe<UserVerificationStatus>;
  volume: VolumeQuery;
  wallets: WalletsQuery;
};


export type UserChildrenArgs = {
  depth?: InputMaybe<Scalars['Int']>;
  moveId?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
};


export type UserDirectMembersArgs = {
  filter?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type UserGenealogyArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type UserMembersArgs = {
  filter?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type UserChildren = {
  __typename?: 'UserChildren';
  depth?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  mainUserId?: Maybe<Scalars['Int']>;
  maxRankId?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  rankId: Scalars['Int'];
  sponsorId?: Maybe<Scalars['Int']>;
  totalMembersInLeft: Scalars['Int'];
  totalMembersInRight: Scalars['Int'];
  username?: Maybe<Scalars['String']>;
};

export type UserConsent = {
  __typename?: 'UserConsent';
  code: UserConsentCode;
  granted: Scalars['Boolean'];
  isForAffiliates: Scalars['Boolean'];
  isForCustomers: Scalars['Boolean'];
  required: Scalars['Boolean'];
};

export enum UserConsentCode {
  ATC1 = 'ATC1',
  ATC2 = 'ATC2',
  ATC3 = 'ATC3',
  ATC4 = 'ATC4',
  FXPP = 'FXPP',
  FXTOU = 'FXTOU',
  NEWSLETTER = 'NEWSLETTER',
  TBDPA = 'TBDPA',
  TBPP = 'TBPP',
  TBTOU = 'TBTOU',
  TVTOUC = 'TVTOUC',
  WROW = 'WROW',
  WROW2 = 'WROW2'
}

export type UserCoursesMap = {
  __typename?: 'UserCoursesMap';
  courseId: Scalars['Int'];
  createdDate?: Maybe<Scalars['String']>;
  finishedDate?: Maybe<Scalars['String']>;
  ownerId: Scalars['Int'];
  packetId: Scalars['Int'];
  progress: Scalars['Float'];
};

export type UserCustomerBonus = {
  __typename?: 'UserCustomerBonus';
  amount: Scalars['Float'];
  date: Scalars['String'];
  id: Scalars['Int'];
  joinWeek: Scalars['Int'];
  joinYear: Scalars['Int'];
  ownerId: Scalars['Int'];
  packageId: Scalars['Int'];
  team: Scalars['String'];
  userId: Scalars['Int'];
  username: Scalars['String'];
  yearweek?: Maybe<Scalars['String']>;
};

export type UserDashboardProductsStats = {
  __typename?: 'UserDashboardProductsStats';
  isActive: Scalars['Boolean'];
  leftTeam: Scalars['Int'];
  leftTeamVolume: Scalars['Float'];
  rightTeam: Scalars['Int'];
  rightTeamVolume: Scalars['Float'];
  volumeType: Scalars['String'];
};

export type UserDirectSales = {
  __typename?: 'UserDirectSales';
  amount: Scalars['Float'];
  date: Scalars['String'];
  id: Scalars['Int'];
  joinWeek: Scalars['Int'];
  joinYear: Scalars['Int'];
  ownerId: Scalars['Int'];
  packageId: Scalars['Int'];
  team: Scalars['String'];
  userId: Scalars['Int'];
  username: Scalars['String'];
  volumeType: Scalars['String'];
  yearweek?: Maybe<Scalars['String']>;
};

export type UserEventTickets = {
  __typename?: 'UserEventTickets';
  eventId?: Maybe<Scalars['Int']>;
  exclusiveTenPackPrice?: Maybe<Scalars['Int']>;
  exclusiveTicketLimit?: Maybe<Scalars['Int']>;
  exclusiveTicketPrice?: Maybe<Scalars['Int']>;
  exclusiveTicketsSold?: Maybe<Scalars['Int']>;
  goldTenPackPrice?: Maybe<Scalars['Int']>;
  goldTicketLimit?: Maybe<Scalars['Int']>;
  goldTicketPrice?: Maybe<Scalars['Int']>;
  goldTicketsSold?: Maybe<Scalars['Int']>;
  guestFullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  ownerId: Scalars['Int'];
  ownerUsername?: Maybe<Scalars['String']>;
  purchaseDate: Scalars['String'];
  silverTenPackPrice?: Maybe<Scalars['Int']>;
  silverTicketLimit?: Maybe<Scalars['Int']>;
  silverTicketPrice?: Maybe<Scalars['Int']>;
  silverTicketsSold?: Maybe<Scalars['Int']>;
  standardTenPackPrice?: Maybe<Scalars['Int']>;
  standardTicketLimit?: Maybe<Scalars['Int']>;
  standardTicketPrice?: Maybe<Scalars['Int']>;
  standardTicketsSold?: Maybe<Scalars['Int']>;
  ticketCode: Scalars['String'];
  ticketEventType?: Maybe<Scalars['String']>;
  ticketIsGivenTo?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Scalars['String']>;
  ticketYear?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
  vipTenPackPrice?: Maybe<Scalars['Int']>;
  vipTicketLimit?: Maybe<Scalars['Int']>;
  vipTicketPrice?: Maybe<Scalars['Int']>;
  vipTicketsSold?: Maybe<Scalars['Int']>;
};

export type UserEventTicketsMutation = {
  __typename?: 'UserEventTicketsMutation';
  assignTicket?: Maybe<DefaultEventTicketResult>;
  createEventTicket: CreateEventTicketsResult;
  eventTicket: EventTicketResult;
  registerTicket?: Maybe<DefaultEventTicketResult>;
  upgradeTicket?: Maybe<DefaultEventTicketResult>;
};


export type UserEventTicketsMutationAssignTicketArgs = {
  data: AssignTicketInput;
};


export type UserEventTicketsMutationCreateEventTicketArgs = {
  secretPassword: Scalars['String'];
  tickets: Array<TicketsInput>;
};


export type UserEventTicketsMutationEventTicketArgs = {
  id: Scalars['Int'];
};


export type UserEventTicketsMutationRegisterTicketArgs = {
  data: RegisterTicketInput;
};


export type UserEventTicketsMutationUpgradeTicketArgs = {
  data: UpgradeTicketInput;
};

export type UserEventTicketsQuery = {
  __typename?: 'UserEventTicketsQuery';
  eventTickets?: Maybe<UserEventTicketsResult>;
};


export type UserEventTicketsQueryEventTicketsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type UserEventTicketsResult = QueryResultInterface & {
  __typename?: 'UserEventTicketsResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
  tickets?: Maybe<Array<Maybe<UserEventTickets>>>;
  totalRows: Scalars['Int'];
};

export type UserFounderPackage = {
  __typename?: 'UserFounderPackage';
  id: Scalars['Int'];
  packageType: FounderPackagesType;
  purchaseDate: Scalars['String'];
};

export type UserFounderPackageInput = {
  L?: InputMaybe<Scalars['Int']>;
  M?: InputMaybe<Scalars['Int']>;
  S?: InputMaybe<Scalars['Int']>;
  XL?: InputMaybe<Scalars['Int']>;
};

export type UserFounderPackagesResult = {
  __typename?: 'UserFounderPackagesResult';
  accessUrl?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<Maybe<UserFounderPackage>>>;
  totalRows: Scalars['Int'];
};

export type UserIncomeCentreStatus = {
  __typename?: 'UserIncomeCentreStatus';
  canAddIncomeCentre?: Maybe<Scalars['Boolean']>;
  limitReached?: Maybe<Scalars['Boolean']>;
  paymentAmount?: Maybe<Scalars['String']>;
};

export type UserIncomeCentreType = {
  __typename?: 'UserIncomeCentreType';
  id: Scalars['Int'];
  isSelected?: Maybe<Scalars['Int']>;
  username: Scalars['String'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  inviteLink: Scalars['String'];
  isAffiliate: Scalars['Boolean'];
  isCOC: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type UserIntercashProfile = {
  __typename?: 'UserIntercashProfile';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  county?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
};

export type UserMovilToken = {
  __typename?: 'UserMovilToken';
  activatedByUserId?: Maybe<Scalars['Int']>;
  activatedByUsername?: Maybe<Scalars['String']>;
  activationCode: Scalars['String'];
  activationDate?: Maybe<Scalars['String']>;
  discount: Scalars['String'];
  id: Scalars['Int'];
  ownerId: Scalars['Int'];
  packageId: Scalars['Int'];
  purchaseDate: Scalars['String'];
};

export type UserMovilTokenResult = QueryResultInterface & {
  __typename?: 'UserMovilTokenResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
  tokens?: Maybe<Array<Maybe<UserMovilToken>>>;
  totalRows: Scalars['Int'];
};

export type UserMutation = {
  __typename?: 'UserMutation';
  cashAccount?: Maybe<CashAccountMutation>;
  changePassword?: Maybe<UserPasswordResult>;
  changeSecretPassword?: Maybe<UserPasswordResult>;
  changeTeamBuildingPriority?: Maybe<TeamBuildingPriorityResult>;
  coinAccount?: Maybe<CoinAccountMutation>;
  company?: Maybe<CompanyMutation>;
  eventTickets?: Maybe<UserEventTicketsMutation>;
  invoices?: Maybe<InvoiceMutation>;
  messages?: Maybe<MessagesMutation>;
  packages?: Maybe<UserPackagesMutation>;
  saveCourseSlideBookmark?: Maybe<SaveCourseSlideBookmarkResult>;
  saveUserAvatar?: Maybe<SaveUserAvatarResult>;
  starterKit?: Maybe<UserStarterKitMutation>;
  update?: Maybe<UserProfileResult>;
  updateAccountNumber: AccountNumberResult;
  wallets?: Maybe<WalletsMutation>;
};


export type UserMutationChangePasswordArgs = {
  data?: InputMaybe<PasswordInput>;
};


export type UserMutationChangeSecretPasswordArgs = {
  data?: InputMaybe<SecretPasswordInput>;
};


export type UserMutationChangeTeamBuildingPriorityArgs = {
  teamBuildingPriority?: InputMaybe<TeamType>;
};


export type UserMutationSaveCourseSlideBookmarkArgs = {
  courseId: Scalars['Int'];
  slideId: Scalars['Int'];
};


export type UserMutationSaveUserAvatarArgs = {
  id: Scalars['String'];
};


export type UserMutationUpdateArgs = {
  data?: InputMaybe<ProfileInput>;
};


export type UserMutationUpdateAccountNumberArgs = {
  data: AccountNumberInput;
};

export type UserPackages = {
  __typename?: 'UserPackages';
  activatedByUserId?: Maybe<Scalars['Int']>;
  activatedByUsername?: Maybe<Scalars['String']>;
  activationCode: Scalars['String'];
  activationDate?: Maybe<Scalars['String']>;
  discount: Scalars['String'];
  id: Scalars['Int'];
  ownerId: Scalars['Int'];
  packageId: Scalars['Int'];
  purchaseDate: Scalars['String'];
};

export type UserPackagesMutation = {
  __typename?: 'UserPackagesMutation';
  activatePackage: ActivatePackageResult;
  createBulkPackages: CreateBulkPackageResult;
  createMovilToken: CreateMovilTokenResult;
  validatePackage: ValidatePackageResult;
};


export type UserPackagesMutationActivatePackageArgs = {
  activationCode: Scalars['String'];
  escrowTime: Scalars['Int'];
};


export type UserPackagesMutationCreateBulkPackagesArgs = {
  packageInfo: BulkPackageInput;
  secretPassword: Scalars['String'];
};


export type UserPackagesMutationCreateMovilTokenArgs = {
  packageInfo: MovilTokenInput;
  secretPassword: Scalars['String'];
};


export type UserPackagesMutationValidatePackageArgs = {
  activationCode: Scalars['String'];
};

export type UserPackagesQuery = {
  __typename?: 'UserPackagesQuery';
  activatedPackages?: Maybe<UserPackagesResult>;
  activatedStarterKitPackages?: Maybe<UserStarterKitPackagesResult>;
  movilTokenCount?: Maybe<MovilTokenCountResult>;
  movilTokens?: Maybe<UserMovilTokenResult>;
  packages?: Maybe<UserPackagesResult>;
  starterKitPackages?: Maybe<UserStarterKitPackagesResult>;
};


export type UserPackagesQueryMovilTokensArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type UserPackagesQueryPackagesArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type UserPackagesQueryStarterKitPackagesArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type UserPackagesResult = QueryResultInterface & {
  __typename?: 'UserPackagesResult';
  packages?: Maybe<Array<Maybe<UserPackages>>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export type UserPasswordResult = {
  __typename?: 'UserPasswordResult';
  /** Validation result */
  result: ValidationResult;
  /** Was password updated */
  success: Scalars['Boolean'];
};

export type UserPersonalCustomerFilterType = {
  country?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  joinDateFrom?: InputMaybe<Scalars['String']>;
  joinDateTo?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UserPersonalCustomerType = {
  __typename?: 'UserPersonalCustomerType';
  affiliateAgreementDate?: Maybe<Scalars['String']>;
  becomeAffiliateCountdown?: Maybe<Scalars['Int']>;
  confirmationStatus?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  forex?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  parentId: Scalars['Int'];
  parentUsername?: Maybe<Scalars['String']>;
  registerDate: Scalars['String'];
  sponsorSetParentId?: Maybe<Scalars['Int']>;
  sponsorSetPosition?: Maybe<Scalars['String']>;
  sponsorSetSponsorId?: Maybe<Scalars['Int']>;
  team?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

export type UserProfileResult = {
  __typename?: 'UserProfileResult';
  /** Validation result */
  result: ValidationResult;
  /** User profile updated */
  success: Scalars['Boolean'];
  viewer?: Maybe<User>;
};

export type UserRank = {
  __typename?: 'UserRank';
  dateAchieved: Scalars['String'];
  id: Scalars['ID'];
  ownerId: Scalars['Int'];
  rankId: Scalars['Int'];
};

export type UserRankInfoResult = {
  __typename?: 'UserRankInfoResult';
  name: Scalars['String'];
  rank: Scalars['String'];
  rankId: Scalars['Int'];
};

export type UserStarterKitMutation = {
  __typename?: 'UserStarterKitMutation';
  activateStarterKitPackage: ActivateStarterKitPackageResult;
  buyStarterKit: BuyStarterKitResult;
  createBulkStarterKitPackages: CreateBulkStarterKitPackageResult;
  /** Create new package */
  createStarterKitPackage?: Maybe<CreateStarterKitPackageResult>;
  createUserFounderPackages: CreateUserFounderPackagesResult;
  validateStarterKitPackage: ValidateStarterKitPackageResult;
};


export type UserStarterKitMutationActivateStarterKitPackageArgs = {
  activationCode: Scalars['String'];
};


export type UserStarterKitMutationBuyStarterKitArgs = {
  kit: BuyStarterKitInput;
};


export type UserStarterKitMutationCreateBulkStarterKitPackagesArgs = {
  packageInfo: BulkStarterKitPackageInput;
  secretPassword: Scalars['String'];
};


export type UserStarterKitMutationCreateStarterKitPackageArgs = {
  packageId: Scalars['Int'];
};


export type UserStarterKitMutationCreateUserFounderPackagesArgs = {
  packageInfo: UserFounderPackageInput;
  secretPassword: Scalars['String'];
};


export type UserStarterKitMutationValidateStarterKitPackageArgs = {
  activationCode: Scalars['String'];
};

export type UserStarterKitPackages = {
  __typename?: 'UserStarterKitPackages';
  activatedByUserId?: Maybe<Scalars['Int']>;
  activatedByUsername?: Maybe<Scalars['String']>;
  activationCode: Scalars['String'];
  activationDate?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  ownerId: Scalars['Int'];
  packageId: Scalars['Int'];
  purchaseDate: Scalars['String'];
  shipmentDetails?: Maybe<Scalars['String']>;
  shipmentStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  vat: Scalars['Int'];
};

export type UserStarterKitPackagesQuery = {
  __typename?: 'UserStarterKitPackagesQuery';
  activatedStarterKitPackages?: Maybe<UserStarterKitPackagesResult>;
  founderPackages?: Maybe<UserFounderPackagesResult>;
  starterKitPackages?: Maybe<UserStarterKitPackagesResult>;
};


export type UserStarterKitPackagesQueryFounderPackagesArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type UserStarterKitPackagesQueryStarterKitPackagesArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type UserStarterKitPackagesResult = QueryResultInterface & {
  __typename?: 'UserStarterKitPackagesResult';
  packages?: Maybe<Array<Maybe<UserStarterKitPackages>>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export type UserTeamVolumesResult = {
  __typename?: 'UserTeamVolumesResult';
  error?: Maybe<Scalars['String']>;
  leftTeamMonthlyVolume: Scalars['Int'];
  leftTeamYearlyVolume: Scalars['Int'];
  rightTeamMonthlyVolume: Scalars['Int'];
  rightTeamYearlyVolume: Scalars['Int'];
};

export type UserVerification = {
  __typename?: 'UserVerification';
  addressVerificationStatus: VerificationStatus;
  callbackDate?: Maybe<Scalars['String']>;
  callbackJson?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdDate: Scalars['String'];
  dateOfBirth?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  identityVerificationStatus: VerificationStatus;
  lastName?: Maybe<Scalars['String']>;
  ownerId: Scalars['String'];
  profileMatch: Scalars['Int'];
  transactionId?: Maybe<Scalars['String']>;
  updatedDate: Scalars['String'];
  userProvidedCountry?: Maybe<Scalars['String']>;
  verificationStatus: UserVerificationStatuses;
  verifyOnceUserId?: Maybe<Scalars['String']>;
  verifyOnceUserStatus: VerifyOnceUserStatus;
};

export type UserVerificationCreateInput = {
  userProvidedCountry?: InputMaybe<Scalars['String']>;
};

export type UserVerificationCreationResult = {
  __typename?: 'UserVerificationCreationResult';
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  transactionId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type UserVerificationDocument = {
  __typename?: 'UserVerificationDocument';
  /** Additional description about document approval */
  createdDate?: Maybe<Scalars['String']>;
  /** Additional description about document approval */
  description?: Maybe<Scalars['String']>;
  /** Document in base64 format */
  document?: Maybe<Scalars['String']>;
  /** Shows what type of document it is: png, jpg or pdf */
  documentFormatType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** Shows verification status */
  isApproved: ApprovedTypes;
  /** Shows if it's passport, address or company */
  type?: Maybe<UserVerificationDocumentType>;
};

export enum UserVerificationDocumentJumioStatus {
  DISCARDED = 'DISCARDED',
  EXTRACTED = 'EXTRACTED',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  UPLOADED = 'UPLOADED'
}

export enum UserVerificationDocumentType {
  /** Address type */
  ADDRESS = 'Address',
  /** Compnay type */
  COMPANY = 'Company',
  /** Passport type */
  PASSPORT = 'Passport'
}

export enum UserVerificationStatus {
  CANT_RETRY = 'CANT_RETRY',
  FRAUD = 'FRAUD',
  INITIATED = 'INITIATED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  PENDING = 'PENDING',
  PROFILE_MISMATCH = 'PROFILE_MISMATCH',
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED'
}

export enum UserVerificationStatuses {
  CANT_RETRY = 'CANT_RETRY',
  FRAUD = 'FRAUD',
  INITIATED = 'INITIATED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  PENDING = 'PENDING',
  PROFILE_MISMATCH = 'PROFILE_MISMATCH',
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED'
}

export type UserVerificationsMutations = {
  __typename?: 'UserVerificationsMutations';
  create: UserVerificationCreationResult;
};


export type UserVerificationsMutationsCreateArgs = {
  userVerification: UserVerificationCreateInput;
};

export type UserVolume = {
  __typename?: 'UserVolume';
  date?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  ownerId?: Maybe<Scalars['Int']>;
  packageId: Scalars['Int'];
  points: Scalars['Int'];
  team?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  username?: Maybe<Scalars['String']>;
  volumeType?: Maybe<Scalars['String']>;
  yearweek?: Maybe<Scalars['String']>;
};

export type UserVolumeGroup = {
  __typename?: 'UserVolumeGroup';
  currentWeekLeftTeam: Scalars['Int'];
  currentWeekRightTeam: Scalars['Int'];
  id: Scalars['Int'];
  lastWeekLeftTeam: Scalars['Int'];
  lastWeekRightTeam: Scalars['Int'];
  ownerId: Scalars['Int'];
  volumeWeek: Scalars['Int'];
  volumeYear: Scalars['Int'];
  yearweek?: Maybe<Scalars['String']>;
};

export type UserVolumeGroupResult = {
  __typename?: 'UserVolumeGroupResult';
  error?: Maybe<Scalars['String']>;
  totalRows: Scalars['Int'];
  volume?: Maybe<Array<Maybe<UserVolumeGroup>>>;
};

export type UserVolumeResult = {
  __typename?: 'UserVolumeResult';
  error?: Maybe<Scalars['String']>;
  totalRows: Scalars['Int'];
  volume?: Maybe<Array<Maybe<UserVolume>>>;
};

export enum UserWalletTypesEnum {
  BEP20 = 'BEP20',
  ERC20 = 'ERC20',
  SOL = 'SOL',
  TRC20 = 'TRC20'
}

export type UserWalletsResult = {
  __typename?: 'UserWalletsResult';
  address: Scalars['String'];
  walletType: Scalars['String'];
};

export type UserWeekVolumeResult = QueryResultInterface & {
  __typename?: 'UserWeekVolumeResult';
  result: ValidationResult;
  success: Scalars['Boolean'];
  volume?: Maybe<UserVolumeGroup>;
};

export type UserXeraInfo = {
  __typename?: 'UserXeraInfo';
  id: Scalars['String'];
  isIncomeCentre: Scalars['Boolean'];
  username: Scalars['String'];
  xeraEmail: Scalars['String'];
  xeraUsername: Scalars['String'];
};

export type UsersIncomeCentre = {
  __typename?: 'UsersIncomeCentre';
  rankId: Scalars['Int'];
  userId: Scalars['Int'];
  username: Scalars['String'];
};

export type UsersIncomeCentreListResult = {
  __typename?: 'UsersIncomeCentreListResult';
  displayedIncomeCentreId?: Maybe<Scalars['ID']>;
  list?: Maybe<Array<UsersIncomeCentre>>;
  status?: Maybe<UsersIncomeCentreStatus>;
  totalRows: Scalars['Int'];
};

export type UsersIncomeCentreStatus = {
  __typename?: 'UsersIncomeCentreStatus';
  canAddIncomeCentre: Scalars['Boolean'];
  limitReached: Scalars['Boolean'];
  paymentAmount: Scalars['Float'];
};

export enum ValidAccountNumberTypes {
  /** Adv Cash account */
  ADV_CASH = 'ADV_CASH',
  BEP20 = 'BEP20',
  /** Bitcoin wallet account */
  BTC = 'BTC',
  /** Dagcoin wallet */
  DAGCOIN_WALLET = 'DAGCOIN_WALLET',
  ERC20 = 'ERC20',
  /** Intercash account */
  INTERCASH = 'INTERCASH',
  /** Payza account */
  PAYZA = 'PAYZA',
  /** Perfect money account */
  PERFECT_MONEY = 'PERFECT_MONEY',
  SOL = 'SOL',
  TRC20 = 'TRC20'
}

export enum ValidUserAccountTypes {
  BEP20 = 'BEP20',
  ERC20 = 'ERC20',
  SOL = 'SOL',
  TRC20 = 'TRC20'
}

export type ValidateDagPackagesResult = {
  __typename?: 'ValidateDagPackagesResult';
  baseDags: Scalars['Int'];
  baseDagsThreeYears: Scalars['Int'];
  escrow: DagPackageEscrowType;
  price: Scalars['Int'];
};

export type ValidatePackageResult = {
  __typename?: 'ValidatePackageResult';
  /** Result */
  packageInfo?: Maybe<UserPackages>;
  /** Result */
  result: ValidationResult;
  /** Was package activation success */
  success: Scalars['Boolean'];
};

export type ValidateStarterKitPackageResult = {
  __typename?: 'ValidateStarterKitPackageResult';
  /** Result */
  packageInfo?: Maybe<UserPackages>;
  /** Result */
  result: ValidationResult;
  /** Was package activation success */
  success: Scalars['Boolean'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  errors: Array<ValidationParameterError>;
  message: Scalars['String'];
  parameter: Scalars['String'];
};

export enum ValidationErrorType {
  ACCOUNT_IS_INCOME_CENTRE = 'ACCOUNT_IS_INCOME_CENTRE',
  ACCOUNT_NOT_VERIFIED = 'ACCOUNT_NOT_VERIFIED',
  ACTIVATION_CODE_IN_USE = 'ACTIVATION_CODE_IN_USE',
  ACTIVATION_CODE_LOWER_THAN_CURRENT = 'ACTIVATION_CODE_LOWER_THAN_CURRENT',
  BLOCKED_ACCOUNT = 'BLOCKED_ACCOUNT',
  DAGCOIN_WALLET_NOT_SET = 'DAGCOIN_WALLET_NOT_SET',
  DB_UPDATE_FAILED = 'DB_UPDATE_FAILED',
  DISCOUNT_CODE_HAS_EXPIRED = 'DISCOUNT_CODE_HAS_EXPIRED',
  DISCOUNT_CODE_NOT_ACTIVE = 'DISCOUNT_CODE_NOT_ACTIVE',
  DISCOUNT_CODE_NOT_CORRECT = 'DISCOUNT_CODE_NOT_CORRECT',
  EMPTY = 'EMPTY',
  FIELD_DOES_NOT_MATCH = 'FIELD_DOES_NOT_MATCH',
  HAS_NO_LATIN_LETTERS = 'HAS_NO_LATIN_LETTERS',
  HAS_SPACE = 'HAS_SPACE',
  HAS_SPACE_CHARACTER = 'HAS_SPACE_CHARACTER',
  INVALID_ADDRESS = 'INVALID_ADDRESS',
  INVALID_AGE = 'INVALID_AGE',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  INVALID_CURRENCY = 'INVALID_CURRENCY',
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  INVALID_DECIMAL = 'INVALID_DECIMAL',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_FULL_NAME_LENGTH = 'INVALID_FULL_NAME_LENGTH',
  INVALID_LENGTH = 'INVALID_LENGTH',
  INVALID_OPTION = 'INVALID_OPTION',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  INVALID_RANGE = 'INVALID_RANGE',
  INVALID_START_OF_A_STRING = 'INVALID_START_OF_A_STRING',
  INVALID_VALUE = 'INVALID_VALUE',
  IS_NOT_CHECKED = 'IS_NOT_CHECKED',
  MAXIMUM_LIMIT_EXEEDED = 'MAXIMUM_LIMIT_EXEEDED',
  MAX_WITHDRAWABLE_AMOUNT_EXCEEDED = 'MAX_WITHDRAWABLE_AMOUNT_EXCEEDED',
  MISSING_PAYMENT_INFO = 'MISSING_PAYMENT_INFO',
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  NOT_ENOUGH_FUNDS = 'NOT_ENOUGH_FUNDS',
  NO_DIGITS = 'NO_DIGITS',
  NO_LOWERCASE = 'NO_LOWERCASE',
  NO_UPPERCASE = 'NO_UPPERCASE',
  ONLY_LETTERS_AND_NUMBERS = 'ONLY_LETTERS_AND_NUMBERS',
  RECAPTCHA_INVALID = 'RECAPTCHA_INVALID',
  RESOURCE_DOES_NOT_EXIST = 'RESOURCE_DOES_NOT_EXIST',
  RESOURCE_EXISTS = 'RESOURCE_EXISTS',
  TIMEOUT_NOT_PASSED = 'TIMEOUT_NOT_PASSED',
  VALUE_IS_NOT_A_NUMBER = 'VALUE_IS_NOT_A_NUMBER',
  WRONG_SECURE_PASSWORD = 'WRONG_SECURE_PASSWORD'
}

export type ValidationParameterError = {
  __typename?: 'ValidationParameterError';
  details: Array<KeyValuePair>;
  message: Scalars['String'];
  type: ValidationErrorType;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  errors: Array<ValidationError>;
  message?: Maybe<ValidationParameterError>;
  type: ValidationResultType;
};

export enum ValidationResultType {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  SUCCESS = 'SUCCESS',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export type VerificationDeleteResult = {
  __typename?: 'VerificationDeleteResult';
  /** Validation result */
  result: ValidationResult;
  /** Was verification document deleted */
  success: Scalars['Boolean'];
};

export enum VerificationStatus {
  DOCUMENT_EXPIRED_REJECTED = 'DOCUMENT_EXPIRED_REJECTED',
  DOCUMENT_EXPIRING_VERIFIED = 'DOCUMENT_EXPIRING_VERIFIED',
  FAILED = 'FAILED',
  INITIATED = 'INITIATED',
  LOCKED = 'LOCKED',
  PENDING = 'PENDING',
  UNINITIATED = 'UNINITIATED',
  VERIFICATION_EXPIRED_REJECTED = 'VERIFICATION_EXPIRED_REJECTED',
  VERIFICATION_EXPIRING_VERIFIED = 'VERIFICATION_EXPIRING_VERIFIED',
  VERIFIED = 'VERIFIED'
}

export enum VerifyOnceUserStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED'
}

export enum VideosCategory {
  EVENTS = 'EVENTS',
  PRESENTATIONS = 'PRESENTATIONS',
  RANK_AWARDS = 'RANK_AWARDS',
  TUTORIALS = 'TUTORIALS'
}

/** Videos item */
export type VideosItem = {
  __typename?: 'VideosItem';
  category?: Maybe<VideosCategory>;
  contentTitle?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: VideosStatusEnum;
  title: Scalars['String'];
  videoId: Scalars['String'];
};

export type VideosResult = {
  __typename?: 'VideosResult';
  data?: Maybe<Array<VideosItem>>;
  result: ValidationResult;
  success: Scalars['Boolean'];
  totalRows: Scalars['Int'];
};

export enum VideosStatusEnum {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE'
}

export type ViewPublicNewsResult = QueryResultInterface & {
  __typename?: 'ViewPublicNewsResult';
  news?: Maybe<NewsItem>;
  result: ValidationResult;
  success: Scalars['Boolean'];
};

export type VolumeBonus = {
  __typename?: 'VolumeBonus';
  totalVolumeBonus: Scalars['Int'];
  weekEndBalanceLeft: Scalars['Int'];
  weekEndBalanceRight: Scalars['Int'];
};

export type VolumeQuery = {
  __typename?: 'VolumeQuery';
  getCurrentWeek: UserWeekVolumeResult;
  getForYear?: Maybe<UserVolumeGroupResult>;
  getTeamsVolumes: UserTeamVolumesResult;
  groups?: Maybe<UserVolumeGroupResult>;
  points?: Maybe<UserVolumeResult>;
};


export type VolumeQueryGetTeamsVolumesArgs = {
  id: Scalars['Int'];
};


export type VolumeQueryGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type VolumeQueryPointsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  week: Scalars['Int'];
  year: Scalars['Int'];
};

export enum Wallet {
  ADV_CASH = 'ADV_CASH',
  BEP20 = 'BEP20',
  BTC = 'BTC',
  DAGCOIN_WALLET = 'DAGCOIN_WALLET',
  ERC20 = 'ERC20',
  INTERCASH = 'INTERCASH',
  PAYZA = 'PAYZA',
  PERFECT_MONEY = 'PERFECT_MONEY',
  SOL = 'SOL',
  TRC20 = 'TRC20'
}

export type WalletQuery = {
  __typename?: 'WalletQuery';
  /** lookup selected rank details */
  all?: Maybe<Array<Maybe<UserWalletsResult>>>;
  /** lookup user reconitions */
  wallet?: Maybe<UserWalletsResult>;
};


export type WalletQueryWalletArgs = {
  wallet: ValidAccountNumberTypes;
};

export type WalletUpdateInput = {
  accountConfirmationBox?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<Scalars['String']>;
  secretPassword?: InputMaybe<Scalars['String']>;
  wallet?: InputMaybe<Wallet>;
};

export type WalletsMutation = {
  __typename?: 'WalletsMutation';
  update: Scalars['Boolean'];
};


export type WalletsMutationUpdateArgs = {
  data: WalletUpdateInput;
};

export type WalletsQuery = {
  __typename?: 'WalletsQuery';
  all: Array<Maybe<UserWalletsResult>>;
  wallet?: Maybe<UserWalletsResult>;
};


export type WalletsQueryWalletArgs = {
  wallet?: InputMaybe<Wallet>;
};

export type WalletsUpdateInput = {
  /** Confirmation checkbox */
  accountConfirmationBox: Scalars['Int'];
  /** User account number/wallet */
  address: Scalars['String'];
  /** User secret password for validation */
  secretPassword: Scalars['String'];
  /** User account type, what to update */
  wallet: ValidAccountNumberTypes;
};

export type WheelOfSuccessList = {
  __typename?: 'WheelOfSuccessList';
  activationCode: Scalars['String'];
  activationDate?: Maybe<Scalars['String']>;
  packageId: Scalars['Int'];
  prizeOne?: Maybe<Scalars['String']>;
  prizeThree?: Maybe<Scalars['String']>;
  prizeTwo?: Maybe<Scalars['String']>;
  purchaseDate: Scalars['String'];
  spinCount: Scalars['Int'];
};

export type AddServicesToCartButtonServiceSubscriptionsQueryVariables = Exact<{
  activeSubscriptionId: Scalars['String'];
}>;


export type AddServicesToCartButtonServiceSubscriptionsQuery = { __typename?: 'Query', me: { __typename?: 'Me', serviceSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string, isLegacy: boolean, periodCode: ServicePeriodCode, productCodes: Array<ServiceProductCode>, upgradeOffers: Array<{ __typename?: 'ServiceOffer', id: string, fullPrice: string, discount: string, discountedPrice?: string | null, currency: { __typename?: 'Currency', code: CurrencyCode }, products: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode }>, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> }> } };

export type AddServicesToCartButtonGetSubscriptionUpgradeQueryVariables = Exact<{
  id: Scalars['String'];
  paymentMethod: PaymentMethod;
}>;


export type AddServicesToCartButtonGetSubscriptionUpgradeQuery = { __typename?: 'Query', me: { __typename?: 'Me', serviceSubscriptionUpgrade?: { __typename?: 'ServiceSubscriptionUpgrade', id: string, difference: string, differenceFee: string, differenceTax: string, differenceTotal: string, currency: { __typename?: 'Currency', code: CurrencyCode }, offer: { __typename?: 'ServiceOffer', fullPrice: string, discount: string, discountedPrice?: string | null, products: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode }>, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } } } | null } };

export type AddServicesToCartButtonCreateSubscriptionUpgradeMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
  offerId: Scalars['String'];
}>;


export type AddServicesToCartButtonCreateSubscriptionUpgradeMutation = { __typename?: 'Mutation', upgradeServiceSubscription: { __typename?: 'ServiceSubscriptionUpgrade', id: string } };

export type AddToCartButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type AddToCartButtonQuery = { __typename?: 'Query', me: { __typename?: 'Me', theiaAccess?: string | null, forexInsidersAccess?: string | null, membershipAccess?: string | null, consents?: Array<{ __typename?: 'UserConsent', code: UserConsentCode, isForAffiliates: boolean, isForCustomers: boolean, required: boolean, granted: boolean }> | null } };

export type AppQueryVariables = Exact<{ [key: string]: never; }>;


export type AppQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: number, referralCode?: string | null, email?: string | null, username?: string | null, country?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, hasAccessToWebOffice: boolean, isActive?: string | null, forceEmailChange: boolean, verifyStatus?: UserVerificationStatus | null } | null, me: { __typename?: 'Me', activeBusinessFeeSubscription?: { __typename?: 'ServiceSubscription', id: string } | null, activePlatofrmFeeSubscription?: { __typename?: 'ServiceSubscription', id: string } | null, activeMarketingFeeSubscription?: { __typename?: 'ServiceSubscription', id: string } | null, info?: { __typename?: 'UserInfo', username?: string | null, isAffiliate: boolean } | null, currency: { __typename?: 'Currency', code: CurrencyCode }, consents?: Array<{ __typename?: 'UserConsent', code: UserConsentCode, required: boolean, granted: boolean, isForAffiliates: boolean, isForCustomers: boolean }> | null, growAccount: { __typename?: 'GrowAccount', hasAccessLink?: boolean | null, linkedAccount?: string | null } }, getAffiliate?: { __typename?: 'User', id: number, firstName?: string | null, affiliateId?: number | null } | null, bank?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability }> }> | null, forex?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability }> }> | null, awentures?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability }> }> | null, bancus?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability }> }> | null, hunterSystems?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability }> }> | null };

export type AppGrowMigrationAccessButtonMutationVariables = Exact<{
  secretPassword: Scalars['String'];
}>;


export type AppGrowMigrationAccessButtonMutation = { __typename?: 'Mutation', growAccountAccessLink: string };

export type PaymentMethodInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodInfoQuery = { __typename?: 'Query', me: { __typename?: 'Me', currency: { __typename?: 'Currency', code: CurrencyCode }, paymentMethods: Array<{ __typename?: 'PaymentMethodInfo', method: PaymentMethod, limits?: { __typename?: 'PaymentMethodLimits', minimum: { __typename?: 'Monetary', amount: string, currency: { __typename?: 'Currency', code: CurrencyCode } }, maximum: { __typename?: 'Monetary', amount: string, currency: { __typename?: 'Currency', code: CurrencyCode } } } | null }> } };

export type LoginViewQueryVariables = Exact<{ [key: string]: never; }>;


export type LoginViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', askReCaptcha: boolean } };

export type PaymentMethodsListQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsListQuery = { __typename?: 'Query', me: { __typename?: 'Me', paymentMethods: Array<{ __typename?: 'PaymentMethodInfo', name: string, method: PaymentMethod, enabled: boolean, sources?: Array<{ __typename?: 'PaymentMethodSource', priority: number, source: { __typename?: 'PaymentSource', id: string, hasExpired: boolean, info?: { __typename: 'PaymentSourceCreditCard', brand?: string | null, type?: string | null, expYear?: number | null, expMonth?: number | null, last4?: string | null } | { __typename: 'PaymentSourceScrCredit', available: string, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode } } | { __typename: 'PaymentSourceShopCredit', available: string, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode } } | null } }> | null, limits?: { __typename?: 'PaymentMethodLimits', minimum: { __typename?: 'Monetary', amount: string, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string } }, maximum: { __typename?: 'Monetary', amount: string, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string } } } | null }>, currency: { __typename?: 'Currency', code: CurrencyCode } } };

export type RedeemGiftCardMutationVariables = Exact<{
  cardCode: Scalars['String'];
}>;


export type RedeemGiftCardMutation = { __typename?: 'Mutation', redeemGiftCard: { __typename?: 'GiftCard', code: string, amount: string, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string } } };

export type StripeCreditCardFormSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type StripeCreditCardFormSetupIntentMutation = { __typename?: 'Mutation', createStripeSetupIntent: string };

export type StripeCreditCardFormRegisterSourceMutationVariables = Exact<{
  setupIntentClientSecret: Scalars['String'];
}>;


export type StripeCreditCardFormRegisterSourceMutation = { __typename?: 'Mutation', registerStripePaymentSource: { __typename?: 'PaymentSource', id: string } };

export type StripeCreditCardFormRemoveSourceMutationVariables = Exact<{
  paymentSourceId: Scalars['String'];
}>;


export type StripeCreditCardFormRemoveSourceMutation = { __typename?: 'Mutation', removePaymentSource: Array<{ __typename?: 'PaymentSource', id: string }> };

export type ValidationResultInfoFragment = { __typename?: 'ValidationResult', type: ValidationResultType, message?: { __typename?: 'ValidationParameterError', message: string } | null, errors: Array<{ __typename?: 'ValidationError', parameter: string, errors: Array<{ __typename?: 'ValidationParameterError', type: ValidationErrorType, details: Array<{ __typename?: 'KeyValuePair', key: string, value?: string | null }> }> }> };

export type ActivateSubscriptionByCodeMutationVariables = Exact<{
  activationCode: Scalars['String'];
  productId: Scalars['Int'];
}>;


export type ActivateSubscriptionByCodeMutation = { __typename?: 'Mutation', activateSubscriptionByCode: boolean };

export type AddCartItemMutationVariables = Exact<{
  productId: Scalars['Int'];
  color?: InputMaybe<ProductColor>;
  size?: InputMaybe<ProductSize>;
  quantity: Scalars['Int'];
  neckline?: InputMaybe<ProductNecklines>;
}>;


export type AddCartItemMutation = { __typename?: 'Mutation', addCartItem: boolean };

export type AddServiceCartItemMutationVariables = Exact<{
  productCode: ServiceProductCode;
  periodCode: ServicePeriodCode;
}>;


export type AddServiceCartItemMutation = { __typename?: 'Mutation', addServiceCartItem: { __typename?: 'ServiceCartItem', id: string, cart: { __typename?: 'ServiceCart', id: string } } };

export type CreatePaymentMutationVariables = Exact<{
  selectedSourceId?: InputMaybe<Scalars['String']>;
  totalAmount: Scalars['Float'];
  unit: PaymentUnit;
  entityType: PaymentEntityType;
  method: PaymentMethod;
  entityId?: InputMaybe<Scalars['Int']>;
  returnUrl?: InputMaybe<Scalars['String']>;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', payments: { __typename?: 'PaymentsMutation', create: { __typename?: 'PaymentInitiationResult', id?: string | null, success: boolean, signature?: string | null, error?: string | null, initiationUrl?: string | null, initiationForm?: Array<{ __typename?: 'PaymentInitiationFormEntry', key: string, value: string }> | null } } };

export type CreateStripeSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateStripeSetupIntentMutation = { __typename?: 'Mutation', createStripeSetupIntent: string };

export type ExtendSubscriptionByCodeMutationVariables = Exact<{
  activationCode: Scalars['String'];
  subscriptionId: Scalars['Int'];
}>;


export type ExtendSubscriptionByCodeMutation = { __typename?: 'Mutation', extendSubscriptionByCode: boolean };

export type InitiateCartPaymentMutationVariables = Exact<{
  paymentMethod: Scalars['String'];
}>;


export type InitiateCartPaymentMutation = { __typename?: 'Mutation', initiateCartPayment: { __typename?: 'InitiateCartPaymentResult', paymentId?: string | null, paymentIntentClientSecret?: string | null } };

export type InitiateSubscriptionPaymentMutationVariables = Exact<{
  productId: Scalars['Int'];
  countryId: Scalars['Int'];
  paymentMethod: Scalars['String'];
  period: SubscriptionPeriod;
}>;


export type InitiateSubscriptionPaymentMutation = { __typename?: 'Mutation', initiateSubscriptionPayment: { __typename?: 'InitiateSubscriptionPaymentResult', paymentId?: string | null, paymentIntentClientSecret?: string | null } };

export type RegisterStripePaymentSourceMutationVariables = Exact<{
  setupIntentClientSecret: Scalars['String'];
}>;


export type RegisterStripePaymentSourceMutation = { __typename?: 'Mutation', registerStripePaymentSource: { __typename?: 'PaymentSource', id: string } };

export type RemoveCartItemMutationVariables = Exact<{
  cartItemId: Scalars['Int'];
}>;


export type RemoveCartItemMutation = { __typename?: 'Mutation', removeCartItem: boolean };

export type RemoveServiceCartItemMutationVariables = Exact<{
  productCode: ServiceProductCode;
}>;


export type RemoveServiceCartItemMutation = { __typename?: 'Mutation', removeServiceCartItem: boolean };

export type RequestInviteMutationVariables = Exact<{
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  countryId: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
}>;


export type RequestInviteMutation = { __typename?: 'Mutation', requestInvite: boolean };

export type SendContactSupportMessageMutationVariables = Exact<{
  data?: InputMaybe<PublicSupportMessageInput>;
}>;


export type SendContactSupportMessageMutation = { __typename?: 'Mutation', sendContactSupportMessage?: { __typename?: 'SupportMessageResult', success: boolean } | null };

export type StoreUserConsentMutationVariables = Exact<{
  code: UserConsentCode;
  granted: Scalars['Boolean'];
}>;


export type StoreUserConsentMutation = { __typename?: 'Mutation', storeUserConsent: boolean };

export type UpdateCartItemMutationVariables = Exact<{
  cartItemId: Scalars['Int'];
  quantity: Scalars['Int'];
}>;


export type UpdateCartItemMutation = { __typename?: 'Mutation', updateCartItem: boolean };

export type UpdateServiceCartItemPeriodMutationVariables = Exact<{
  productCode: ServiceProductCode;
  periodCode: ServicePeriodCode;
}>;


export type UpdateServiceCartItemPeriodMutation = { __typename?: 'Mutation', updateServiceCartItemPeriod: boolean };

export type PrivateViewQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivateViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', intercomHash?: string | null, info?: { __typename?: 'UserInfo', isAffiliate: boolean, isCOC: boolean } | null, consents?: Array<{ __typename?: 'UserConsent', code: UserConsentCode, required: boolean, granted: boolean, isForAffiliates: boolean, isForCustomers: boolean }> | null }, viewer?: { __typename?: 'User', id: number, isActive?: string | null, username?: string | null, email?: string | null, country?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, referralCode?: string | null, hasAccessToWebOffice: boolean, rankId: number, registerDate?: string | null, dateOfBirth?: string | null } | null };

export type AppAuthenticationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type AppAuthenticationStatusQuery = { __typename?: 'Query', me: { __typename?: 'Me', isLoggedIn?: boolean | null } };

export type CartItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type CartItemsQuery = { __typename?: 'Query', me: { __typename?: 'Me', serviceCart?: { __typename?: 'ServiceCart', id: string, items: Array<{ __typename?: 'ServiceCartItem', id: string }> } | null } };

export type CountryQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryQuery = { __typename?: 'Query', country: { __typename?: 'CountryResult', countries?: Array<{ __typename?: 'Country', id: number, code?: string | null, name?: string | null }> | null } };

export type GetAffiliateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAffiliateQuery = { __typename?: 'Query', getAffiliate?: { __typename?: 'User', id: number, affiliateId?: number | null, firstName?: string | null, lastName?: string | null } | null };

export type GetPaymentStatusQueryVariables = Exact<{
  paymentId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaymentStatusQuery = { __typename?: 'Query', getPaymentStatus?: { __typename?: 'GetPaymentStatusResult', status: PaymentStatus } | null };

export type GetSubscriptionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetSubscriptionQuery = { __typename?: 'Query', getSubscription: { __typename?: 'Subscription', id: number, ownerId: number, productId: number, productInformation?: string | null, type?: SubscriptionType | null, status: SubscriptionStatus, provider: SubscriptionProvider, price: number, stripeSubscriptionId?: string | null, paymentExpireDate?: string | null, productName: string, failedDate?: string | null, lastTryDate?: string | null, createdDate: string, updatedDate: string, payments: Array<{ __typename?: 'SubscriptionPayments', amount: number, periodStart?: string | null, createdDate: string, periodEnd?: string | null, status: PaymentStatus, description: string }> } };

export type PaymentStatusQueryVariables = Exact<{
  transactionId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
}>;


export type PaymentStatusQuery = { __typename?: 'Query', payments: { __typename?: 'PaymentsQueries', fetch?: { __typename?: 'Payment', id?: number | null, entityType: PaymentEntityType, entityId?: number | null, status: PaymentStatus } | null } };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: number, username?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, postcode?: string | null, countryId?: number | null, referralCode?: string | null, dateOfBirth?: string | null, country?: string | null, countryCode?: string | null, state?: string | null, city?: string | null, address?: string | null, hasActiveStarterKit: boolean, hasAccessToWebOffice: boolean, isActive?: string | null, affiliateId?: number | null, forceEmailChange: boolean, rankId: number, registerDate?: string | null, coinAccountBalance?: number | null, shopCreditBalance: number, scrCreditBalance: number } | null, me: { __typename?: 'Me', intercomHash?: string | null, currency: { __typename?: 'Currency', code: CurrencyCode }, info?: { __typename?: 'UserInfo', isAffiliate: boolean, isCOC: boolean } | null, xera?: Array<{ __typename?: 'UserXeraInfo', id: string, username: string, isIncomeCentre: boolean, xeraUsername: string, xeraEmail: string }> | null, webwalletAddresses?: Array<{ __typename?: 'MeWebWallets', address?: string | null, walletType?: string | null }> | null, dagsInfo?: { __typename?: 'MeDagsInfo', totalDags?: string | null, totalScr?: string | null, usedDags?: string | null, ratio?: string | null, burned?: Array<{ __typename?: 'BurnedDags', dags: string, scr: string, createdAt: string }> | null } | null, meD2TInfo?: { __typename?: 'MeD2TInfoType', totalDags?: string | null, totalScr?: string | null, usedDags?: string | null, ratio?: string | null, burned?: Array<{ __typename?: 'BurnedDagsD2T', dags: string, scr: string, createdAt: string, name?: string | null, email?: string | null }> | null } | null } };

export type AccountViewQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', activePlatofrmFeeSubscription?: { __typename?: 'ServiceSubscription', productCodes: Array<ServiceProductCode>, dateEnd?: string | null, expiresInSeconds: string, gracePeriodDateEnd: string, gracePeriodExpiresInSeconds: string } | null, currency: { __typename?: 'Currency', code: CurrencyCode } } };

export type BankCodeAccessViewQueryVariables = Exact<{ [key: string]: never; }>;


export type BankCodeAccessViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', codebreakerAccess?: { __typename?: 'CodeBreakerAccess', bankBasicUrl?: string | null, bankFullUrl?: string | null } | null } };

export type BecomeAffiliateViewQueryVariables = Exact<{ [key: string]: never; }>;


export type BecomeAffiliateViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', activeServiceProductCodes: Array<ServiceProductCode>, currency: { __typename?: 'Currency', code: CurrencyCode }, info?: { __typename?: 'UserInfo', isAffiliate: boolean, username?: string | null, email?: string | null } | null, consents?: Array<{ __typename?: 'UserConsent', code: UserConsentCode, required: boolean, granted: boolean, isForAffiliates: boolean }> | null } };

export type BecomeAffiliateMutationVariables = Exact<{
  activationCode?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
  leftUsername?: InputMaybe<Scalars['String']>;
  rightUsername?: InputMaybe<Scalars['String']>;
}>;


export type BecomeAffiliateMutation = { __typename?: 'Mutation', becomeAffiliate: boolean };

export type BecomeAffiliateViewStoreUserConsentMutationVariables = Exact<{
  code: UserConsentCode;
  granted: Scalars['Boolean'];
}>;


export type BecomeAffiliateViewStoreUserConsentMutation = { __typename?: 'Mutation', storeUserConsent: boolean };

export type DigitalProductsViewQueryVariables = Exact<{
  theViewProductCodes: Array<ServiceProductCode> | ServiceProductCode;
  paymentMethod: PaymentMethod;
}>;


export type DigitalProductsViewQuery = { __typename?: 'Query', awentures?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, hunterSystems?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> }> | null, bancus?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, forex?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, forexPro?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, bankBasic?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, bankFull?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, businessFeeBasic?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, businessFeePro?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, membershipBasic?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, membershipPro?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, platformFee?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, marketingFee?: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, theView?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, offers: Array<{ __typename?: 'ServiceOffer', fullPrice: string, availability: ServiceOfferAvailability, discountedPrice?: string | null, currency: { __typename?: 'Currency', code: CurrencyCode } }> }> | null, viewer?: { __typename?: 'User', id: number, isActive?: string | null, coinAccountBalance?: number | null, phone?: string | null, registerDate?: string | null } | null, me: { __typename?: 'Me', activeServiceProductCodes: Array<ServiceProductCode>, forexInsidersAccess?: string | null, membershipAccess?: string | null, theiaAccess?: string | null, hunterSystemsAccess?: { __typename?: 'HunterSystemsAccess', url: string, accessUrl: string, description: string } | null, activePlatofrmFeeSubscription?: { __typename?: 'ServiceSubscription', productCodes: Array<ServiceProductCode>, dateEnd?: string | null, expiresInSeconds: string, gracePeriodDateEnd: string, gracePeriodExpiresInSeconds: string } | null, activeMarketingFeeSubscription?: { __typename?: 'ServiceSubscription', productCodes: Array<ServiceProductCode>, dateEnd?: string | null, expiresInSeconds: string, gracePeriodDateEnd: string, gracePeriodExpiresInSeconds: string } | null, activeBusinessFeeSubscription?: { __typename?: 'ServiceSubscription', productCodes: Array<ServiceProductCode>, dateEnd?: string | null, expiresInSeconds: string, gracePeriodDateEnd: string, gracePeriodExpiresInSeconds: string } | null, paymentMethods: Array<{ __typename?: 'PaymentMethodInfo', enabled: boolean, method: PaymentMethod }>, currency: { __typename?: 'Currency', code: CurrencyCode }, serviceSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string, status: ServiceSubscriptionStatus, billingAmount?: string | null, gracePeriodDateEnd: string, gracePeriodExpiresInSeconds: string, productCodes: Array<ServiceProductCode>, periodCode: ServicePeriodCode, dateStart: string, billingCurrency: { __typename?: 'Currency', code: CurrencyCode }, products: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode }> }>, codebreakerAccess?: { __typename?: 'CodeBreakerAccess', bankBasicUrl?: string | null, bankFullUrl?: string | null } | null, webwalletAddresses?: Array<{ __typename?: 'MeWebWallets', address?: string | null, walletType?: string | null }> | null, theViewForDags?: { __typename?: 'TheViewForDagsType', dateStart: string, dateEnd: string, expiresInSeconds: number, offers: Array<{ __typename?: 'TheViewForDagsOfferType', id: string, eurOfferPurchaseDate: string, dagOffer: { __typename?: 'ServiceOffer', id: string, fullPrice: string }, eurOffer: { __typename?: 'ServiceOffer', fullPrice: string, labelText?: string | null } }> } | null, productsForDags: Array<{ __typename?: 'ProductForDags', dateStart: string, dateEnd: string, expiresInSeconds: number, product: { __typename?: 'ServiceProduct', code: ServiceProductCode }, offers: Array<{ __typename?: 'ServiceOffer', id: string, fullPrice: string, fullPriceEur: string, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> }>, consents?: Array<{ __typename?: 'UserConsent', code: UserConsentCode, isForAffiliates: boolean, isForCustomers: boolean, required: boolean, granted: boolean }> | null } };

export type RegisterWebinarMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RegisterWebinarMutation = { __typename?: 'Mutation', registerWebinar: boolean };

export type UpdateUserWalletMutationVariables = Exact<{
  wallet: UserWalletTypesEnum;
  address: Scalars['String'];
}>;


export type UpdateUserWalletMutation = { __typename?: 'Mutation', updateUserWallet: boolean };

export type DigitalProductsCreateTheViewForDagsCartMutationVariables = Exact<{
  dagOffersIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type DigitalProductsCreateTheViewForDagsCartMutation = { __typename?: 'Mutation', createTheViewForDagsCart: { __typename?: 'ServiceCart', id: string } };

export type DigitalProductsCreateProductsForDagsCartMutationVariables = Exact<{
  offerIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type DigitalProductsCreateProductsForDagsCartMutation = { __typename?: 'Mutation', createProductsForDagsCart: { __typename?: 'ServiceCart', id: string } };

export type ConvertDagsToScrMutationVariables = Exact<{
  totalAmount: Scalars['String'];
}>;


export type ConvertDagsToScrMutation = { __typename?: 'Mutation', convertDags: boolean };

export type ConvertCommunityDagsToScrMutationVariables = Exact<{
  totalAmount: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
}>;


export type ConvertCommunityDagsToScrMutation = { __typename?: 'Mutation', convertCommunityDags: boolean };

export type ConvertDagsToD2TMutationVariables = Exact<{
  totalAmount: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
}>;


export type ConvertDagsToD2TMutation = { __typename?: 'Mutation', convertDagsD2T: boolean };

export type GetAwenturesLoginLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type GetAwenturesLoginLinkMutation = { __typename?: 'Mutation', getAwenturesLoginLink: string };

export type DigitalProductsViewServicePartsFragment = { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, isActive: boolean, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> };

export type DagCommunityViewQueryVariables = Exact<{ [key: string]: never; }>;


export type DagCommunityViewQuery = { __typename?: 'Query', getTotalBurned: { __typename?: 'TotalBurned', totalDags: string, rate: number } };

export type DigitalProductBarginQueryVariables = Exact<{ [key: string]: never; }>;


export type DigitalProductBarginQuery = { __typename?: 'Query', me: { __typename?: 'Me', serviceSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string, isLegacy: boolean, status: ServiceSubscriptionStatus, upgradeOffers: Array<{ __typename?: 'ServiceOffer', id: string, fullPrice: string, discount: string, discountedPrice?: string | null, labelText?: string | null, products: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string }>, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode, name: string }, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string } }> }> } };

export type DriveForFiveViewQueryVariables = Exact<{ [key: string]: never; }>;


export type DriveForFiveViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', info?: { __typename?: 'UserInfo', username?: string | null, inviteLink: string } | null, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string }, referralsStats: { __typename?: 'ReferralsStats', active: number, registrations: number, customers: number }, serviceSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string, isLegacy: boolean, referralsStatsForCurrentMonth?: { __typename?: 'ReferralsStats', active: number, customers: number, registrations: number } | null, referralsSubscriptionsForCurrentMonth?: { __typename?: 'ReferralsSubscriptionsPerMonth', month: number, freeExtension: boolean, records: Array<{ __typename?: 'ReferralsSubscription', id: string, status: ReferralsSubscriptionStatus }> } | null, products: Array<{ __typename?: 'ServiceProduct', name: string, code: ServiceProductCode }> }> } };

export type DriveForFiveMembershipViewQueryVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type DriveForFiveMembershipViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', info?: { __typename?: 'UserInfo', inviteLink: string } | null, serviceSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string, isLegacy: boolean, products: Array<{ __typename?: 'ServiceProduct', name: string, code: ServiceProductCode }>, referralsSubscriptionsActiveForNearestMonths?: Array<{ __typename?: 'ReferralsSubscriptionsPerMonth', year: number, month: number, current: boolean, freeExtension: boolean, discountedExtension: boolean, records: Array<{ __typename?: 'ReferralsSubscription', id: string, referral: { __typename?: 'UserInfo', firstName?: string | null, lastName?: string | null, email?: string | null }, products: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string }> }> }> | null, referralsSubscriptionsForCurrentMonth?: { __typename?: 'ReferralsSubscriptionsPerMonth', month: number, freeExtension: boolean, records: Array<{ __typename?: 'ReferralsSubscription', id: string, status: ReferralsSubscriptionStatus, createdDate: string, expiresDate: string, referral: { __typename?: 'UserInfo', firstName?: string | null, lastName?: string | null, email?: string | null }, products: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string }> }> } | null, referralsStatsForCurrentMonth?: { __typename?: 'ReferralsStats', active: number, customers: number, registrations: number } | null }> } };

export type GrowLinkingAccountViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GrowLinkingAccountViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', growAccount: { __typename?: 'GrowAccount', hasAccessLink?: boolean | null, linkedAccount?: string | null } } };

export type GrowAccountAccessLinkMutationVariables = Exact<{
  secretPassword: Scalars['String'];
}>;


export type GrowAccountAccessLinkMutation = { __typename?: 'Mutation', growAccountAccessLink: string };

export type InvoicesListViewQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type InvoicesListViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', serviceSubscriptionInvoices: { __typename?: 'ServiceSubscriptionInvoicesResult', totalRows: number, rows: Array<{ __typename?: 'ServiceSubscriptionInvoice', id: string, orderNo: string, status: PaymentStatus, createdDate: string, amount?: string | null, paymentMethod?: PaymentMethod | null, paymentMethodName?: string | null, paymentType?: PaymentEntityType | null, currency?: { __typename?: 'Currency', sign: string, code: CurrencyCode } | null, paymentSource?: { __typename?: 'PaymentSource', info?: { __typename: 'PaymentSourceCreditCard', last4?: string | null } | { __typename: 'PaymentSourceScrCredit' } | { __typename: 'PaymentSourceShopCredit' } | null } | null, products: Array<{ __typename?: 'ServiceSubscriptionInvoiceService', productNames: Array<string> }> }> } } };

export type NewsListViewQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  filter?: InputMaybe<Scalars['String']>;
}>;


export type NewsListViewQuery = { __typename?: 'Query', memberAreaNews: { __typename?: 'MemberAreaNewsResult', totalRows: string, data?: Array<{ __typename?: 'NewsItem', id: number, title: string, content?: string | null, category?: NewsCategory | null, publishedDate: string, createdDate: string, isPrivate: NewsPrivateEnum, needsConfirmation: NewsPrivateEnum, status: NewsStatusEnum }> | null } };

export type PaymentMethodsViewQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsViewQuery = { __typename?: 'Query', getGiftCards: Array<{ __typename?: 'GiftCard', id: string, code: string, active: boolean, amount: string, usedBy?: string | null, type: string, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string } }>, me: { __typename?: 'Me', currency: { __typename?: 'Currency', code: CurrencyCode }, paymentSources?: Array<{ __typename?: 'PaymentSource', id: string, hasExpired: boolean, info?: { __typename?: 'PaymentSourceCreditCard', brand?: string | null, type?: string | null, expYear?: number | null, expMonth?: number | null, last4?: string | null } | { __typename?: 'PaymentSourceScrCredit', available: string, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode } } | { __typename?: 'PaymentSourceShopCredit', available: string, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode } } | null }> | null } };

export type PaymentMethodsViewRedeemGiftCardMutationVariables = Exact<{
  cardCode: Scalars['String'];
}>;


export type PaymentMethodsViewRedeemGiftCardMutation = { __typename?: 'Mutation', redeemGiftCard: { __typename?: 'GiftCard', code: string, amount: string, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string } } };

export type ArrangePaymentSourcesMutationVariables = Exact<{
  paymentSourcesIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type ArrangePaymentSourcesMutation = { __typename?: 'Mutation', arrangePaymentSources: Array<{ __typename?: 'PaymentSource', id: string, hasExpired: boolean, info?: { __typename: 'PaymentSourceCreditCard' } | { __typename: 'PaymentSourceScrCredit' } | { __typename: 'PaymentSourceShopCredit' } | null }> };

export type RemovePaymentSourceMutationVariables = Exact<{
  paymentSourceId: Scalars['String'];
}>;


export type RemovePaymentSourceMutation = { __typename?: 'Mutation', removePaymentSource: Array<{ __typename?: 'PaymentSource', id: string }> };

export type ProfileViewQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', currency: { __typename?: 'Currency', code: CurrencyCode } }, viewer?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, phone?: string | null, email?: string | null, address?: string | null, city?: string | null, state?: string | null, postcode?: string | null, country?: string | null, countryCode?: string | null } | null, country: { __typename?: 'CountryResult', countries?: Array<{ __typename?: 'Country', id: number, code?: string | null }> | null } };

export type ProfileViewChangeUserInfoMutationVariables = Exact<{
  secretPassword: Scalars['String'];
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}>;


export type ProfileViewChangeUserInfoMutation = { __typename?: 'Mutation', user?: { __typename?: 'UserMutation', update?: { __typename?: 'UserProfileResult', success: boolean, result: { __typename?: 'ValidationResult', errors: Array<{ __typename?: 'ValidationError', parameter: string, message: string }> } } | null } | null };

export type ProfileViewChangePasswordMutationVariables = Exact<{
  data: PasswordInput;
}>;


export type ProfileViewChangePasswordMutation = { __typename?: 'Mutation', user?: { __typename?: 'UserMutation', changePassword?: { __typename?: 'UserPasswordResult', success: boolean, result: { __typename?: 'ValidationResult', message?: { __typename?: 'ValidationParameterError', message: string } | null } } | null } | null };

export type ForgottenConfirmationPasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ForgottenConfirmationPasswordMutation = { __typename?: 'Mutation', forgottenConfirmationPassword: { __typename?: 'ForgottenLoginResult', result: { __typename?: 'ValidationResult', type: ValidationResultType } } };

export type ChangeConfirmationPasswordMutationVariables = Exact<{
  data: ForgottenPasswordInput;
}>;


export type ChangeConfirmationPasswordMutation = { __typename?: 'Mutation', changeConfirmationPassword: { __typename?: 'ForgottenPasswordResult', success: boolean, result: { __typename?: 'ValidationResult', type: ValidationResultType } } };

export type SubscriptionsListViewQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionsListViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', serviceSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string, isLegacy: boolean, productCodes: Array<ServiceProductCode>, periodCode: ServicePeriodCode, dateStart: string, dateEnd?: string | null, billingDate?: string | null, status: ServiceSubscriptionStatus, isDiscontinuable: boolean, upgradeOffers: Array<{ __typename?: 'ServiceOffer', id: string, fullPrice: string, discount: string, discountedPrice?: string | null, labelText?: string | null, products: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string }>, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode, name: string }, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string } }>, products: Array<{ __typename?: 'ServiceProduct', name: string, code: ServiceProductCode }> }> } };

export type DiscontinueServiceSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type DiscontinueServiceSubscriptionMutation = { __typename?: 'Mutation', discontinueServiceSubscription: boolean };

export type ContinueServiceSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type ContinueServiceSubscriptionMutation = { __typename?: 'Mutation', continueServiceSubscription: boolean };

export type CancelSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['Int'];
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: boolean };

export type UpgradeServiceSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String'];
  offerId: Scalars['String'];
  paymentMethod: PaymentMethod;
}>;


export type UpgradeServiceSubscriptionMutation = { __typename?: 'Mutation', upgradeServiceSubscription: { __typename?: 'ServiceSubscriptionUpgrade', id: string, difference: string, differenceFee: string, differenceTax: string, differenceTotal: string, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string }, offer: { __typename?: 'ServiceOffer', fullPrice: string, labelText?: string | null, discountedPrice?: string | null, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode, name: string } } } };

export type EditSubscriptionUpgradeOfferQueryVariables = Exact<{
  id: Scalars['String'];
  paymentMethod: PaymentMethod;
}>;


export type EditSubscriptionUpgradeOfferQuery = { __typename?: 'Query', me: { __typename?: 'Me', serviceSubscriptionUpgrade?: { __typename?: 'ServiceSubscriptionUpgrade', id: string, difference: string, differenceFee: string, differenceTax: string, differenceTotal: string, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string }, offer: { __typename?: 'ServiceOffer', fullPrice: string, labelText?: string | null, discountedPrice?: string | null, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode, name: string } } } | null } };

export type EditSubscriptionUpgradeOfferPartsFragment = { __typename?: 'ServiceSubscriptionUpgrade', id: string, difference: string, differenceFee: string, differenceTax: string, differenceTotal: string, currency: { __typename?: 'Currency', code: CurrencyCode, sign: string }, offer: { __typename?: 'ServiceOffer', fullPrice: string, labelText?: string | null, discountedPrice?: string | null, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode, name: string } } };

export type BusinessTrainingViewQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessTrainingViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', activeServiceProductCodes: Array<ServiceProductCode>, info?: { __typename?: 'UserInfo', isAffiliate: boolean } | null } };

export type BusinessTrainingMenuViewQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessTrainingMenuViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', currency: { __typename?: 'Currency', code: CurrencyCode } } };

export type BankCodeSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type BankCodeSectionQuery = { __typename?: 'Query', me: { __typename?: 'Me', codebreakerAccess?: { __typename?: 'CodeBreakerAccess', kickStarterUrl?: string | null } | null } };

export type ChapterViewQueryVariables = Exact<{ [key: string]: never; }>;


export type ChapterViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', currency: { __typename?: 'Currency', code: CurrencyCode } } };

export type CartUpSellViewQueryVariables = Exact<{
  paymentMethod: PaymentMethod;
}>;


export type CartUpSellViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', activeServiceProductCodes: Array<ServiceProductCode>, personalServiceOffers: Array<{ __typename: 'ServiceCart', id: string, totalPrice?: string | null, totalPriceWithoutTax?: string | null, totalDiscount?: string | null, totalFee?: string | null, totalTax?: string | null, maybeCurrency?: { __typename?: 'Currency', code: CurrencyCode } | null, offers: Array<{ __typename?: 'ServiceOffer', id: string, discountedPrice?: string | null, fullPrice: string, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode }, products: Array<{ __typename?: 'ServiceProduct', name: string, code: ServiceProductCode }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode } }> } | { __typename: 'ServiceSubscriptionUpgrade', id: string, difference: string, differenceTotal: string, differenceFee: string, differenceTax: string, currency: { __typename?: 'Currency', code: CurrencyCode }, offer: { __typename?: 'ServiceOffer', id: string, discountedPrice?: string | null, fullPrice: string, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode }, products: Array<{ __typename?: 'ServiceProduct', name: string, code: ServiceProductCode }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode } } }> } };

export type CartUpSellViewRejectPersonalOffersMutationVariables = Exact<{ [key: string]: never; }>;


export type CartUpSellViewRejectPersonalOffersMutation = { __typename?: 'Mutation', rejectPersonalOffers: boolean };

export type CartUpSellViewOfferFragmentFragment = { __typename?: 'ServiceOffer', id: string, discountedPrice?: string | null, fullPrice: string, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode }, products: Array<{ __typename?: 'ServiceProduct', name: string, code: ServiceProductCode }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode } };

export type CartViewQueryVariables = Exact<{
  periodCode: ServicePeriodCode;
  paymentMethod: PaymentMethod;
}>;


export type CartViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', serviceCart?: { __typename?: 'ServiceCart', id: string, totalPrice?: string | null, comboDiscount?: string | null, totalFee?: string | null, totalTax?: string | null, totalShipping?: string | null, totalScr?: string | null, taxCountryId?: string | null, finalizationHash: string, currency?: { __typename?: 'Currency', code: CurrencyCode } | null, discountApplied?: { __typename?: 'ServiceDiscount', id: string, percent?: number | null, value?: { __typename?: 'Monetary', amount: string, currency: { __typename?: 'Currency', code: CurrencyCode } } | null } | null, items: Array<{ __typename?: 'ServiceCartItem', id: string, quantity?: number | null, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode, name: string }, product: { __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, label?: string | null, isQuantifiable: boolean, offers: Array<{ __typename?: 'ServiceOffer', id: string, discountedPrice?: string | null, discountedPriceNext?: string | null, fullPrice: string, fullPriceNext?: string | null, maxScrAmount: string, labelText?: string | null, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode }, currency: { __typename?: 'Currency', code: CurrencyCode } }> } }> } | null, serviceOfferRecommendations: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, products: Array<{ __typename?: 'ServiceProduct', name: string, code: ServiceProductCode }>, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> }, viewer?: { __typename?: 'User', id: number, isActive?: string | null, shopCreditBalance: number } | null, forex?: { __typename?: 'ServiceOffer', id: string, fullPrice: string, discountedPrice?: string | null, currency: { __typename?: 'Currency', code: CurrencyCode } } | null, bankFull?: { __typename?: 'ServiceOffer', id: string, fullPrice: string, discountedPrice?: string | null, currency: { __typename?: 'Currency', code: CurrencyCode } } | null };

export type CartViewRemoveItemMutationVariables = Exact<{
  productCode: ServiceProductCode;
}>;


export type CartViewRemoveItemMutation = { __typename?: 'Mutation', removeServiceCartItem: boolean };

export type CartViewUpdateItemPeriodMutationVariables = Exact<{
  productCode: ServiceProductCode;
  periodCode: ServicePeriodCode;
}>;


export type CartViewUpdateItemPeriodMutation = { __typename?: 'Mutation', updateServiceCartItemPeriod: boolean };

export type CartViewFinalizeCartMutationVariables = Exact<{
  finalizationHash: Scalars['String'];
  paymentMethod: PaymentMethod;
}>;


export type CartViewFinalizeCartMutation = { __typename?: 'Mutation', finalizeCart: { __typename?: 'ServiceCart', id: string, totalPrice?: string | null, currency?: { __typename?: 'Currency', code: CurrencyCode } | null } };

export type CartViewCloneCartMutationVariables = Exact<{
  cartId: Scalars['String'];
}>;


export type CartViewCloneCartMutation = { __typename?: 'Mutation', cloneInactiveServiceCart: { __typename?: 'ServiceCart', id: string } };

export type UpdateServiceCartItemQuantityMutationVariables = Exact<{
  productCode: ServiceProductCode;
  quantity: Scalars['Int'];
}>;


export type UpdateServiceCartItemQuantityMutation = { __typename?: 'Mutation', updateServiceCartItemQuantity: boolean };

export type CartViewApplyServiceCartDiscountCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type CartViewApplyServiceCartDiscountCodeMutation = { __typename?: 'Mutation', applyServiceCartDiscountCode: { __typename?: 'ServiceDiscount', id: string, percent?: number | null, value?: { __typename?: 'Monetary', amount: string, currency: { __typename?: 'Currency', code: CurrencyCode } } | null } };

export type CartViewClearServiceCartDiscountCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type CartViewClearServiceCartDiscountCodeMutation = { __typename?: 'Mutation', clearServiceCartDiscountCode: boolean };

export type CartViewDiscountPartsFragment = { __typename?: 'ServiceDiscount', id: string, percent?: number | null, value?: { __typename?: 'Monetary', amount: string, currency: { __typename?: 'Currency', code: CurrencyCode } } | null };

export type ContactViewQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', currency: { __typename?: 'Currency', code: CurrencyCode } } };

export type ActivateEmailByHashMutationVariables = Exact<{
  hash: Scalars['String'];
}>;


export type ActivateEmailByHashMutation = { __typename?: 'Mutation', activateEmailByHash: boolean };

export type CreateEmailChangeMutationVariables = Exact<{
  email: Scalars['String'];
  repeatEmail: Scalars['String'];
  password: Scalars['String'];
}>;


export type CreateEmailChangeMutation = { __typename?: 'Mutation', createEmailChange: boolean };

export type ForgottenLoginMutationMutationVariables = Exact<{
  data: ForgottenLoginInput;
}>;


export type ForgottenLoginMutationMutation = { __typename?: 'Mutation', forgottenLogin: { __typename?: 'ForgottenLoginResult', result: { __typename?: 'ValidationResult', type: ValidationResultType } } };

export type GiftCardViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GiftCardViewQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', verifyStatus?: UserVerificationStatus | null } | null, me: { __typename?: 'Me', currency: { __typename?: 'Currency', code: CurrencyCode }, giftCardLimits: { __typename?: 'GiftCardLimits', minimum: { __typename?: 'Monetary', amount: string }, maximum: { __typename?: 'Monetary', amount: string } } } };

export type HomeViewQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeViewQuery = { __typename?: 'Query', awentures?: { __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, discount: string, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, products: Array<{ __typename?: 'ServiceProduct', name: string, code: ServiceProductCode }>, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } } | null, awentureService?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, discountedPrice?: string | null, currency: { __typename?: 'Currency', code: CurrencyCode } }> }> | null, me: { __typename?: 'Me', theiaAccess?: string | null, awenturesAccess: boolean, codebreakerAccess?: { __typename?: 'CodeBreakerAccess', bankBasicUrl?: string | null, bankFullUrl?: string | null } | null, currency: { __typename?: 'Currency', code: CurrencyCode }, hunterSystemsAccess?: { __typename?: 'HunterSystemsAccess', url: string, accessUrl: string, description: string } | null, consents?: Array<{ __typename?: 'UserConsent', code: UserConsentCode, isForAffiliates: boolean, isForCustomers: boolean, required: boolean, granted: boolean }> | null } };

export type HomeViewOfferPartsFragment = { __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, discount: string, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, products: Array<{ __typename?: 'ServiceProduct', name: string, code: ServiceProductCode }>, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } };

export type LoginViewLoginMutationMutationVariables = Exact<{
  credentials?: InputMaybe<CredentialsInput>;
}>;


export type LoginViewLoginMutationMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResult', result: { __typename?: 'ValidationResult', type: ValidationResultType } } };

export type LogoutViewLogoutMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutViewLogoutMutationMutation = { __typename?: 'Mutation', logout: boolean };

export type RegisterLooreUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  dateOfBirth: Scalars['String'];
  countryId: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  termsAndConditions: Scalars['Boolean'];
  username: Scalars['String'];
}>;


export type RegisterLooreUserMutation = { __typename?: 'Mutation', registerLooreUser?: number | null };

export type ProductAwenturesViewQueryVariables = Exact<{
  productCodes: Array<ServiceProductCode> | ServiceProductCode;
}>;


export type ProductAwenturesViewQuery = { __typename?: 'Query', services?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, discountedPrice?: string | null, fullPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> }> | null };

export type BankLandingViewQueriesQueryVariables = Exact<{ [key: string]: never; }>;


export type BankLandingViewQueriesQuery = { __typename?: 'Query', bankBasic?: { __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, bankFull?: { __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, forex?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability }> }> | null };

export type ProductBancusViewQueryVariables = Exact<{
  productCodes: Array<ServiceProductCode> | ServiceProductCode;
}>;


export type ProductBancusViewQuery = { __typename?: 'Query', services?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, discountedPrice?: string | null, fullPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> }> | null };

export type ForexLandingViewQueriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ForexLandingViewQueriesQuery = { __typename?: 'Query', forex?: { __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, discount: string, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, forexPro?: { __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, discount: string, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> } | null, bank?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability }> }> | null, me: { __typename?: 'Me', forexInsidersAccess?: string | null } };

export type ForexLandingViewOfferPartsFragment = { __typename?: 'ServiceProduct', code: ServiceProductCode, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, discount: string, fullPrice: string, fullPriceNext?: string | null, discountedPrice?: string | null, discountedPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> };

export type ForexResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type ForexResultsQuery = { __typename?: 'Query', forexStats: { __typename?: 'ForexStats', lastMonthWinRate: string, lastMonthBestReturnOfInvestment: string, lastYearBestReturnOfInvestment: string, updated: string } };

export type ProductHunterSystemsViewQueryVariables = Exact<{
  productCodes: Array<ServiceProductCode> | ServiceProductCode;
}>;


export type ProductHunterSystemsViewQuery = { __typename?: 'Query', services?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, discountedPrice?: string | null, fullPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> }> | null };

export type ProductMemborsAccessViewQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductMemborsAccessViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', membershipAccess?: string | null }, services?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, isActive: boolean }> | null };

export type ProductMemborsViewQueryVariables = Exact<{
  productCodes: Array<ServiceProductCode> | ServiceProductCode;
}>;


export type ProductMemborsViewQuery = { __typename?: 'Query', services?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, discountedPrice?: string | null, fullPriceNext?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', code: CurrencyCode }, period: { __typename?: 'ServicePeriod', code: ServicePeriodCode } }> }> | null };

export type TheViewLandingViewQueriesQueryVariables = Exact<{
  productCodes: Array<ServiceProductCode> | ServiceProductCode;
}>;


export type TheViewLandingViewQueriesQuery = { __typename?: 'Query', services?: Array<{ __typename?: 'ServiceProduct', code: ServiceProductCode, name: string, offers: Array<{ __typename?: 'ServiceOffer', id: string, availability: ServiceOfferAvailability, fullPrice: string, discountedPrice?: string | null, currency: { __typename?: 'Currency', code: CurrencyCode } }> }> | null };

export type RegisterShopUserMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  affiliateId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  dateOfBirth: Scalars['String'];
  countryId: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  termsAndConditions: Scalars['Boolean'];
}>;


export type RegisterShopUserMutation = { __typename?: 'Mutation', registerShopUser?: number | null };

export type ChangeForgottenPasswordMutationVariables = Exact<{
  data: ForgottenPasswordInput;
}>;


export type ChangeForgottenPasswordMutation = { __typename?: 'Mutation', changeForgottenPassword: { __typename?: 'ForgottenPasswordResult', success: boolean, result: { __typename?: 'ValidationResult', type: ValidationResultType } } };

export type SfFeeViewQueryVariables = Exact<{
  productCode: ServiceProductCode;
}>;


export type SfFeeViewQuery = { __typename?: 'Query', me: { __typename?: 'Me', currency: { __typename?: 'Currency', code: CurrencyCode } }, sfFee?: { __typename?: 'ServiceOffer', availability: ServiceOfferAvailability, fullPrice: string, discountedPrice?: string | null, upgradableSubscriptions: Array<{ __typename?: 'ServiceSubscription', id: string }>, currency: { __typename?: 'Currency', sign: string, code: CurrencyCode } } | null };

export type ValidateDagPackageMutationMutationVariables = Exact<{
  activationCode: Scalars['String'];
}>;


export type ValidateDagPackageMutationMutation = { __typename?: 'Mutation', validateDagPackage?: { __typename?: 'ValidateDagPackagesResult', price: number, baseDags: number, baseDagsThreeYears: number, escrow: { __typename?: 'DagPackageEscrowType', one: number, two: number, three: number } } | null };

export type DoesUsernameExistMutationVariables = Exact<{
  username: Scalars['String'];
}>;


export type DoesUsernameExistMutation = { __typename?: 'Mutation', doesUsernameExist: boolean };

export type DoesEmailExistMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type DoesEmailExistMutation = { __typename?: 'Mutation', doesEmailExist: boolean };

export type RegisterInvitedUserMutationVariables = Exact<{
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  affiliateId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  dateOfBirth: Scalars['String'];
  countryId: Scalars['Int'];
  termsAndConditions: Scalars['Boolean'];
  escrowTime?: InputMaybe<Scalars['Int']>;
  activationCode?: InputMaybe<Scalars['String']>;
}>;


export type RegisterInvitedUserMutation = { __typename?: 'Mutation', registerInvitedUser?: number | null };

export type ValidateAffiliateMutationMutationVariables = Exact<{
  affiliateId: Scalars['String'];
}>;


export type ValidateAffiliateMutationMutation = { __typename?: 'Mutation', validateAffiliate?: { __typename?: 'AffiliateResult', user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, result: { __typename?: 'ValidationResult', type: ValidationResultType, message?: { __typename?: 'ValidationParameterError', message: string } | null, errors: Array<{ __typename?: 'ValidationError', parameter: string, errors: Array<{ __typename?: 'ValidationParameterError', type: ValidationErrorType, details: Array<{ __typename?: 'KeyValuePair', key: string, value?: string | null }> }> }> } } | null };

export const namedOperations = {
  Query: {
    AddServicesToCartButtonServiceSubscriptions: 'AddServicesToCartButtonServiceSubscriptions',
    AddServicesToCartButtonGetSubscriptionUpgrade: 'AddServicesToCartButtonGetSubscriptionUpgrade',
    AddToCartButton: 'AddToCartButton',
    App: 'App',
    PaymentMethodInfo: 'PaymentMethodInfo',
    LoginView: 'LoginView',
    PaymentMethodsList: 'PaymentMethodsList',
    PrivateView: 'PrivateView',
    AppAuthenticationStatus: 'AppAuthenticationStatus',
    CartItems: 'CartItems',
    Country: 'Country',
    GetAffiliate: 'GetAffiliate',
    GetPaymentStatus: 'GetPaymentStatus',
    GetSubscription: 'GetSubscription',
    PaymentStatus: 'PaymentStatus',
    Viewer: 'Viewer',
    AccountView: 'AccountView',
    BankCodeAccessView: 'BankCodeAccessView',
    BecomeAffiliateView: 'BecomeAffiliateView',
    DigitalProductsView: 'DigitalProductsView',
    DagCommunityView: 'DagCommunityView',
    DigitalProductBargin: 'DigitalProductBargin',
    DriveForFiveView: 'DriveForFiveView',
    DriveForFiveMembershipView: 'DriveForFiveMembershipView',
    GrowLinkingAccountView: 'GrowLinkingAccountView',
    InvoicesListView: 'InvoicesListView',
    NewsListView: 'NewsListView',
    PaymentMethodsView: 'PaymentMethodsView',
    ProfileView: 'ProfileView',
    SubscriptionsListView: 'SubscriptionsListView',
    EditSubscriptionUpgradeOffer: 'EditSubscriptionUpgradeOffer',
    BusinessTrainingView: 'BusinessTrainingView',
    BusinessTrainingMenuView: 'BusinessTrainingMenuView',
    BankCodeSection: 'BankCodeSection',
    ChapterView: 'ChapterView',
    CartUpSellView: 'CartUpSellView',
    CartView: 'CartView',
    ContactView: 'ContactView',
    GiftCardView: 'GiftCardView',
    HomeView: 'HomeView',
    ProductAwenturesView: 'ProductAwenturesView',
    BankLandingViewQueries: 'BankLandingViewQueries',
    ProductBancusView: 'ProductBancusView',
    ForexLandingViewQueries: 'ForexLandingViewQueries',
    ForexResults: 'ForexResults',
    ProductHunterSystemsView: 'ProductHunterSystemsView',
    ProductMemborsAccessView: 'ProductMemborsAccessView',
    ProductMemborsView: 'ProductMemborsView',
    TheViewLandingViewQueries: 'TheViewLandingViewQueries',
    SfFeeView: 'SfFeeView'
  },
  Mutation: {
    AddServicesToCartButtonCreateSubscriptionUpgrade: 'AddServicesToCartButtonCreateSubscriptionUpgrade',
    AppGrowMigrationAccessButton: 'AppGrowMigrationAccessButton',
    RedeemGiftCard: 'RedeemGiftCard',
    StripeCreditCardFormSetupIntent: 'StripeCreditCardFormSetupIntent',
    StripeCreditCardFormRegisterSource: 'StripeCreditCardFormRegisterSource',
    StripeCreditCardFormRemoveSource: 'StripeCreditCardFormRemoveSource',
    ActivateSubscriptionByCode: 'ActivateSubscriptionByCode',
    AddCartItem: 'AddCartItem',
    AddServiceCartItem: 'AddServiceCartItem',
    CreatePayment: 'CreatePayment',
    CreateStripeSetupIntent: 'CreateStripeSetupIntent',
    ExtendSubscriptionByCode: 'ExtendSubscriptionByCode',
    InitiateCartPayment: 'InitiateCartPayment',
    InitiateSubscriptionPayment: 'InitiateSubscriptionPayment',
    RegisterStripePaymentSource: 'RegisterStripePaymentSource',
    RemoveCartItem: 'RemoveCartItem',
    RemoveServiceCartItem: 'RemoveServiceCartItem',
    RequestInvite: 'RequestInvite',
    SendContactSupportMessage: 'SendContactSupportMessage',
    StoreUserConsent: 'StoreUserConsent',
    UpdateCartItem: 'UpdateCartItem',
    UpdateServiceCartItemPeriod: 'UpdateServiceCartItemPeriod',
    BecomeAffiliate: 'BecomeAffiliate',
    BecomeAffiliateViewStoreUserConsent: 'BecomeAffiliateViewStoreUserConsent',
    RegisterWebinar: 'RegisterWebinar',
    UpdateUserWallet: 'UpdateUserWallet',
    DigitalProductsCreateTheViewForDagsCart: 'DigitalProductsCreateTheViewForDagsCart',
    DigitalProductsCreateProductsForDagsCart: 'DigitalProductsCreateProductsForDagsCart',
    ConvertDagsToScr: 'ConvertDagsToScr',
    ConvertCommunityDagsToScr: 'ConvertCommunityDagsToScr',
    ConvertDagsToD2T: 'ConvertDagsToD2T',
    getAwenturesLoginLink: 'getAwenturesLoginLink',
    GrowAccountAccessLink: 'GrowAccountAccessLink',
    PaymentMethodsViewRedeemGiftCard: 'PaymentMethodsViewRedeemGiftCard',
    ArrangePaymentSources: 'ArrangePaymentSources',
    RemovePaymentSource: 'RemovePaymentSource',
    ProfileViewChangeUserInfo: 'ProfileViewChangeUserInfo',
    ProfileViewChangePassword: 'ProfileViewChangePassword',
    ForgottenConfirmationPassword: 'ForgottenConfirmationPassword',
    ChangeConfirmationPassword: 'ChangeConfirmationPassword',
    DiscontinueServiceSubscription: 'DiscontinueServiceSubscription',
    ContinueServiceSubscription: 'ContinueServiceSubscription',
    CancelSubscription: 'CancelSubscription',
    UpgradeServiceSubscription: 'UpgradeServiceSubscription',
    CartUpSellViewRejectPersonalOffers: 'CartUpSellViewRejectPersonalOffers',
    CartViewRemoveItem: 'CartViewRemoveItem',
    CartViewUpdateItemPeriod: 'CartViewUpdateItemPeriod',
    CartViewFinalizeCart: 'CartViewFinalizeCart',
    CartViewCloneCart: 'CartViewCloneCart',
    UpdateServiceCartItemQuantity: 'UpdateServiceCartItemQuantity',
    CartViewApplyServiceCartDiscountCode: 'CartViewApplyServiceCartDiscountCode',
    CartViewClearServiceCartDiscountCode: 'CartViewClearServiceCartDiscountCode',
    ActivateEmailByHash: 'ActivateEmailByHash',
    CreateEmailChange: 'CreateEmailChange',
    ForgottenLoginMutation: 'ForgottenLoginMutation',
    LoginViewLoginMutation: 'LoginViewLoginMutation',
    LogoutViewLogoutMutation: 'LogoutViewLogoutMutation',
    RegisterLooreUser: 'RegisterLooreUser',
    RegisterShopUser: 'RegisterShopUser',
    ChangeForgottenPassword: 'ChangeForgottenPassword',
    ValidateDagPackageMutation: 'ValidateDagPackageMutation',
    DoesUsernameExist: 'DoesUsernameExist',
    DoesEmailExist: 'DoesEmailExist',
    RegisterInvitedUser: 'RegisterInvitedUser',
    ValidateAffiliateMutation: 'ValidateAffiliateMutation'
  },
  Fragment: {
    validationResultInfo: 'validationResultInfo',
    DigitalProductsViewServiceParts: 'DigitalProductsViewServiceParts',
    EditSubscriptionUpgradeOfferParts: 'EditSubscriptionUpgradeOfferParts',
    CartUpSellViewOfferFragment: 'CartUpSellViewOfferFragment',
    CartViewDiscountParts: 'CartViewDiscountParts',
    HomeViewOfferParts: 'HomeViewOfferParts',
    ForexLandingViewOfferParts: 'ForexLandingViewOfferParts'
  }
}
export const ValidationResultInfoFragmentDoc = gql`
    fragment validationResultInfo on ValidationResult {
  type
  message {
    message
  }
  errors {
    parameter
    errors {
      type
      details {
        key
        value
      }
    }
  }
}
    `;
export const DigitalProductsViewServicePartsFragmentDoc = gql`
    fragment DigitalProductsViewServiceParts on ServiceProduct {
  code
  name
  offers {
    id
    availability
    upgradableSubscriptions {
      id
    }
    fullPrice
    fullPriceNext
    discountedPrice
    discountedPriceNext
    currency {
      sign
      code
    }
    period {
      code
    }
  }
  isActive
  isQuantifiable
}
    `;
export const EditSubscriptionUpgradeOfferPartsFragmentDoc = gql`
    fragment EditSubscriptionUpgradeOfferParts on ServiceSubscriptionUpgrade {
  id
  difference
  differenceFee(method: $paymentMethod)
  differenceTax(method: $paymentMethod)
  differenceTotal(method: $paymentMethod)
  currency {
    code
    sign
  }
  offer {
    fullPrice
    labelText
    discountedPrice
    period {
      code
      name
    }
  }
}
    `;
export const CartUpSellViewOfferFragmentFragmentDoc = gql`
    fragment CartUpSellViewOfferFragment on ServiceOffer {
  id
  period {
    code
  }
  products {
    name
    code
  }
  discountedPrice
  fullPrice
  currency {
    sign
    code
  }
}
    `;
export const CartViewDiscountPartsFragmentDoc = gql`
    fragment CartViewDiscountParts on ServiceDiscount {
  id
  percent
  value {
    amount
    currency {
      code
    }
  }
}
    `;
export const HomeViewOfferPartsFragmentDoc = gql`
    fragment HomeViewOfferParts on ServiceOffer {
  id
  availability
  upgradableSubscriptions {
    id
  }
  discount
  fullPrice
  fullPriceNext
  discountedPrice
  discountedPriceNext
  currency {
    code
  }
  products {
    name
    code
  }
  period {
    code
  }
}
    `;
export const ForexLandingViewOfferPartsFragmentDoc = gql`
    fragment ForexLandingViewOfferParts on ServiceProduct {
  code
  offers {
    id
    availability
    upgradableSubscriptions {
      id
    }
    currency {
      code
    }
    discount
    fullPrice
    fullPriceNext
    discountedPrice
    discountedPriceNext
    period {
      code
    }
  }
}
    `;
export const AddServicesToCartButtonServiceSubscriptionsDocument = gql`
    query AddServicesToCartButtonServiceSubscriptions($activeSubscriptionId: String!) {
  me {
    serviceSubscriptions(id: $activeSubscriptionId) {
      id
      isLegacy
      periodCode
      productCodes
      upgradeOffers {
        id
        fullPrice
        discount
        discountedPrice
        currency {
          code
        }
        products {
          code
        }
        period {
          code
        }
        currency {
          code
        }
      }
    }
  }
}
    `;

/**
 * __useAddServicesToCartButtonServiceSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAddServicesToCartButtonServiceSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddServicesToCartButtonServiceSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddServicesToCartButtonServiceSubscriptionsQuery({
 *   variables: {
 *      activeSubscriptionId: // value for 'activeSubscriptionId'
 *   },
 * });
 */
export function useAddServicesToCartButtonServiceSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<AddServicesToCartButtonServiceSubscriptionsQuery, AddServicesToCartButtonServiceSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddServicesToCartButtonServiceSubscriptionsQuery, AddServicesToCartButtonServiceSubscriptionsQueryVariables>(AddServicesToCartButtonServiceSubscriptionsDocument, options);
      }
export function useAddServicesToCartButtonServiceSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddServicesToCartButtonServiceSubscriptionsQuery, AddServicesToCartButtonServiceSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddServicesToCartButtonServiceSubscriptionsQuery, AddServicesToCartButtonServiceSubscriptionsQueryVariables>(AddServicesToCartButtonServiceSubscriptionsDocument, options);
        }
export type AddServicesToCartButtonServiceSubscriptionsQueryHookResult = ReturnType<typeof useAddServicesToCartButtonServiceSubscriptionsQuery>;
export type AddServicesToCartButtonServiceSubscriptionsLazyQueryHookResult = ReturnType<typeof useAddServicesToCartButtonServiceSubscriptionsLazyQuery>;
export type AddServicesToCartButtonServiceSubscriptionsQueryResult = Apollo.QueryResult<AddServicesToCartButtonServiceSubscriptionsQuery, AddServicesToCartButtonServiceSubscriptionsQueryVariables>;
export const AddServicesToCartButtonGetSubscriptionUpgradeDocument = gql`
    query AddServicesToCartButtonGetSubscriptionUpgrade($id: String!, $paymentMethod: PaymentMethod!) {
  me {
    serviceSubscriptionUpgrade(upgradeId: $id) {
      id
      difference
      differenceFee(method: $paymentMethod)
      differenceTax(method: $paymentMethod)
      differenceTotal(method: $paymentMethod)
      currency {
        code
      }
      offer {
        fullPrice
        discount
        discountedPrice
        discountedPrice
        products {
          code
        }
        period {
          code
        }
      }
    }
  }
}
    `;

/**
 * __useAddServicesToCartButtonGetSubscriptionUpgradeQuery__
 *
 * To run a query within a React component, call `useAddServicesToCartButtonGetSubscriptionUpgradeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddServicesToCartButtonGetSubscriptionUpgradeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddServicesToCartButtonGetSubscriptionUpgradeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useAddServicesToCartButtonGetSubscriptionUpgradeQuery(baseOptions: Apollo.QueryHookOptions<AddServicesToCartButtonGetSubscriptionUpgradeQuery, AddServicesToCartButtonGetSubscriptionUpgradeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddServicesToCartButtonGetSubscriptionUpgradeQuery, AddServicesToCartButtonGetSubscriptionUpgradeQueryVariables>(AddServicesToCartButtonGetSubscriptionUpgradeDocument, options);
      }
export function useAddServicesToCartButtonGetSubscriptionUpgradeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddServicesToCartButtonGetSubscriptionUpgradeQuery, AddServicesToCartButtonGetSubscriptionUpgradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddServicesToCartButtonGetSubscriptionUpgradeQuery, AddServicesToCartButtonGetSubscriptionUpgradeQueryVariables>(AddServicesToCartButtonGetSubscriptionUpgradeDocument, options);
        }
export type AddServicesToCartButtonGetSubscriptionUpgradeQueryHookResult = ReturnType<typeof useAddServicesToCartButtonGetSubscriptionUpgradeQuery>;
export type AddServicesToCartButtonGetSubscriptionUpgradeLazyQueryHookResult = ReturnType<typeof useAddServicesToCartButtonGetSubscriptionUpgradeLazyQuery>;
export type AddServicesToCartButtonGetSubscriptionUpgradeQueryResult = Apollo.QueryResult<AddServicesToCartButtonGetSubscriptionUpgradeQuery, AddServicesToCartButtonGetSubscriptionUpgradeQueryVariables>;
export const AddServicesToCartButtonCreateSubscriptionUpgradeDocument = gql`
    mutation AddServicesToCartButtonCreateSubscriptionUpgrade($subscriptionId: String!, $offerId: String!) {
  upgradeServiceSubscription(subscriptionId: $subscriptionId, offerId: $offerId) {
    id
  }
}
    `;

/**
 * __useAddServicesToCartButtonCreateSubscriptionUpgradeMutation__
 *
 * To run a mutation, you first call `useAddServicesToCartButtonCreateSubscriptionUpgradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServicesToCartButtonCreateSubscriptionUpgradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServicesToCartButtonCreateSubscriptionUpgradeMutation, { data, loading, error }] = useAddServicesToCartButtonCreateSubscriptionUpgradeMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useAddServicesToCartButtonCreateSubscriptionUpgradeMutation(baseOptions?: Apollo.MutationHookOptions<AddServicesToCartButtonCreateSubscriptionUpgradeMutation, AddServicesToCartButtonCreateSubscriptionUpgradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServicesToCartButtonCreateSubscriptionUpgradeMutation, AddServicesToCartButtonCreateSubscriptionUpgradeMutationVariables>(AddServicesToCartButtonCreateSubscriptionUpgradeDocument, options);
      }
export type AddServicesToCartButtonCreateSubscriptionUpgradeMutationHookResult = ReturnType<typeof useAddServicesToCartButtonCreateSubscriptionUpgradeMutation>;
export type AddServicesToCartButtonCreateSubscriptionUpgradeMutationResult = Apollo.MutationResult<AddServicesToCartButtonCreateSubscriptionUpgradeMutation>;
export type AddServicesToCartButtonCreateSubscriptionUpgradeMutationOptions = Apollo.BaseMutationOptions<AddServicesToCartButtonCreateSubscriptionUpgradeMutation, AddServicesToCartButtonCreateSubscriptionUpgradeMutationVariables>;
export const AddToCartButtonDocument = gql`
    query AddToCartButton {
  me {
    consents {
      code
      isForAffiliates
      isForCustomers
      required
      granted
    }
    theiaAccess
    forexInsidersAccess
    membershipAccess
  }
}
    `;

/**
 * __useAddToCartButtonQuery__
 *
 * To run a query within a React component, call `useAddToCartButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddToCartButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddToCartButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddToCartButtonQuery(baseOptions?: Apollo.QueryHookOptions<AddToCartButtonQuery, AddToCartButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddToCartButtonQuery, AddToCartButtonQueryVariables>(AddToCartButtonDocument, options);
      }
export function useAddToCartButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddToCartButtonQuery, AddToCartButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddToCartButtonQuery, AddToCartButtonQueryVariables>(AddToCartButtonDocument, options);
        }
export type AddToCartButtonQueryHookResult = ReturnType<typeof useAddToCartButtonQuery>;
export type AddToCartButtonLazyQueryHookResult = ReturnType<typeof useAddToCartButtonLazyQuery>;
export type AddToCartButtonQueryResult = Apollo.QueryResult<AddToCartButtonQuery, AddToCartButtonQueryVariables>;
export const AppDocument = gql`
    query App {
  viewer {
    id
    referralCode
    email
    username
    country
    firstName
    lastName
    phone
    hasAccessToWebOffice
    isActive
    forceEmailChange
    verifyStatus
  }
  me {
    activeBusinessFeeSubscription {
      id
    }
    activePlatofrmFeeSubscription {
      id
    }
    activeMarketingFeeSubscription {
      id
    }
    info {
      username
      isAffiliate
    }
    currency {
      code
    }
    consents {
      code
      required
      granted
      isForAffiliates
      isForCustomers
    }
    growAccount {
      hasAccessLink
      linkedAccount
    }
  }
  getAffiliate {
    id
    firstName
    affiliateId
  }
  bank: services(productCodes: [BANK_BASIC, BANK_FULL]) {
    code
    offers {
      id
      availability
    }
  }
  forex: services(productCodes: [FOREX]) {
    code
    offers {
      id
      availability
    }
  }
  awentures: services(productCodes: [AWENTURES]) {
    code
    offers {
      id
      availability
    }
  }
  bancus: services(productCodes: [BANCUS]) {
    code
    offers {
      id
      availability
    }
  }
  hunterSystems: services(
    productCodes: [HUNTER_SYSTEMS_BASIC, HUNTER_SYSTEMS_STANDARD, HUNTER_SYSTEMS_PRO, HUNTER_SYSTEMS_PLUS]
  ) {
    code
    offers {
      id
      availability
    }
  }
}
    `;

/**
 * __useAppQuery__
 *
 * To run a query within a React component, call `useAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppQuery(baseOptions?: Apollo.QueryHookOptions<AppQuery, AppQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppQuery, AppQueryVariables>(AppDocument, options);
      }
export function useAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppQuery, AppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppQuery, AppQueryVariables>(AppDocument, options);
        }
export type AppQueryHookResult = ReturnType<typeof useAppQuery>;
export type AppLazyQueryHookResult = ReturnType<typeof useAppLazyQuery>;
export type AppQueryResult = Apollo.QueryResult<AppQuery, AppQueryVariables>;
export const AppGrowMigrationAccessButtonDocument = gql`
    mutation AppGrowMigrationAccessButton($secretPassword: String!) {
  growAccountAccessLink(secretPassword: $secretPassword)
}
    `;

/**
 * __useAppGrowMigrationAccessButtonMutation__
 *
 * To run a mutation, you first call `useAppGrowMigrationAccessButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppGrowMigrationAccessButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appGrowMigrationAccessButtonMutation, { data, loading, error }] = useAppGrowMigrationAccessButtonMutation({
 *   variables: {
 *      secretPassword: // value for 'secretPassword'
 *   },
 * });
 */
export function useAppGrowMigrationAccessButtonMutation(baseOptions?: Apollo.MutationHookOptions<AppGrowMigrationAccessButtonMutation, AppGrowMigrationAccessButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppGrowMigrationAccessButtonMutation, AppGrowMigrationAccessButtonMutationVariables>(AppGrowMigrationAccessButtonDocument, options);
      }
export type AppGrowMigrationAccessButtonMutationHookResult = ReturnType<typeof useAppGrowMigrationAccessButtonMutation>;
export type AppGrowMigrationAccessButtonMutationResult = Apollo.MutationResult<AppGrowMigrationAccessButtonMutation>;
export type AppGrowMigrationAccessButtonMutationOptions = Apollo.BaseMutationOptions<AppGrowMigrationAccessButtonMutation, AppGrowMigrationAccessButtonMutationVariables>;
export const PaymentMethodInfoDocument = gql`
    query PaymentMethodInfo {
  me {
    currency {
      code
    }
    paymentMethods(paymentUnit: DAG) {
      method
      limits {
        minimum {
          amount
          currency {
            code
          }
        }
        maximum {
          amount
          currency {
            code
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePaymentMethodInfoQuery__
 *
 * To run a query within a React component, call `usePaymentMethodInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodInfoQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodInfoQuery, PaymentMethodInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodInfoQuery, PaymentMethodInfoQueryVariables>(PaymentMethodInfoDocument, options);
      }
export function usePaymentMethodInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodInfoQuery, PaymentMethodInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodInfoQuery, PaymentMethodInfoQueryVariables>(PaymentMethodInfoDocument, options);
        }
export type PaymentMethodInfoQueryHookResult = ReturnType<typeof usePaymentMethodInfoQuery>;
export type PaymentMethodInfoLazyQueryHookResult = ReturnType<typeof usePaymentMethodInfoLazyQuery>;
export type PaymentMethodInfoQueryResult = Apollo.QueryResult<PaymentMethodInfoQuery, PaymentMethodInfoQueryVariables>;
export const LoginViewDocument = gql`
    query LoginView {
  me {
    askReCaptcha
  }
}
    `;

/**
 * __useLoginViewQuery__
 *
 * To run a query within a React component, call `useLoginViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoginViewQuery(baseOptions?: Apollo.QueryHookOptions<LoginViewQuery, LoginViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginViewQuery, LoginViewQueryVariables>(LoginViewDocument, options);
      }
export function useLoginViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginViewQuery, LoginViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginViewQuery, LoginViewQueryVariables>(LoginViewDocument, options);
        }
export type LoginViewQueryHookResult = ReturnType<typeof useLoginViewQuery>;
export type LoginViewLazyQueryHookResult = ReturnType<typeof useLoginViewLazyQuery>;
export type LoginViewQueryResult = Apollo.QueryResult<LoginViewQuery, LoginViewQueryVariables>;
export const PaymentMethodsListDocument = gql`
    query PaymentMethodsList {
  me {
    paymentMethods {
      name
      method
      enabled
      sources {
        priority
        source {
          id
          hasExpired
          info {
            __typename
            ... on PaymentSourceCreditCard {
              brand
              type
              expYear
              expMonth
              last4
            }
            ... on PaymentSourceShopCredit {
              available
              currency {
                sign
                code
              }
            }
            ... on PaymentSourceScrCredit {
              available
              currency {
                sign
                code
              }
            }
          }
        }
      }
      limits {
        minimum {
          amount
          currency {
            code
            sign
          }
        }
        maximum {
          amount
          currency {
            code
            sign
          }
        }
      }
    }
    currency {
      code
    }
  }
}
    `;

/**
 * __usePaymentMethodsListQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodsListQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodsListQuery, PaymentMethodsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsListQuery, PaymentMethodsListQueryVariables>(PaymentMethodsListDocument, options);
      }
export function usePaymentMethodsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsListQuery, PaymentMethodsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsListQuery, PaymentMethodsListQueryVariables>(PaymentMethodsListDocument, options);
        }
export type PaymentMethodsListQueryHookResult = ReturnType<typeof usePaymentMethodsListQuery>;
export type PaymentMethodsListLazyQueryHookResult = ReturnType<typeof usePaymentMethodsListLazyQuery>;
export type PaymentMethodsListQueryResult = Apollo.QueryResult<PaymentMethodsListQuery, PaymentMethodsListQueryVariables>;
export const RedeemGiftCardDocument = gql`
    mutation RedeemGiftCard($cardCode: String!) {
  redeemGiftCard(cardCode: $cardCode) {
    code
    amount
    currency {
      code
      sign
    }
  }
}
    `;

/**
 * __useRedeemGiftCardMutation__
 *
 * To run a mutation, you first call `useRedeemGiftCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemGiftCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemGiftCardMutation, { data, loading, error }] = useRedeemGiftCardMutation({
 *   variables: {
 *      cardCode: // value for 'cardCode'
 *   },
 * });
 */
export function useRedeemGiftCardMutation(baseOptions?: Apollo.MutationHookOptions<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>(RedeemGiftCardDocument, options);
      }
export type RedeemGiftCardMutationHookResult = ReturnType<typeof useRedeemGiftCardMutation>;
export type RedeemGiftCardMutationResult = Apollo.MutationResult<RedeemGiftCardMutation>;
export type RedeemGiftCardMutationOptions = Apollo.BaseMutationOptions<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>;
export const StripeCreditCardFormSetupIntentDocument = gql`
    mutation StripeCreditCardFormSetupIntent {
  createStripeSetupIntent
}
    `;

/**
 * __useStripeCreditCardFormSetupIntentMutation__
 *
 * To run a mutation, you first call `useStripeCreditCardFormSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeCreditCardFormSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeCreditCardFormSetupIntentMutation, { data, loading, error }] = useStripeCreditCardFormSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useStripeCreditCardFormSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<StripeCreditCardFormSetupIntentMutation, StripeCreditCardFormSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeCreditCardFormSetupIntentMutation, StripeCreditCardFormSetupIntentMutationVariables>(StripeCreditCardFormSetupIntentDocument, options);
      }
export type StripeCreditCardFormSetupIntentMutationHookResult = ReturnType<typeof useStripeCreditCardFormSetupIntentMutation>;
export type StripeCreditCardFormSetupIntentMutationResult = Apollo.MutationResult<StripeCreditCardFormSetupIntentMutation>;
export type StripeCreditCardFormSetupIntentMutationOptions = Apollo.BaseMutationOptions<StripeCreditCardFormSetupIntentMutation, StripeCreditCardFormSetupIntentMutationVariables>;
export const StripeCreditCardFormRegisterSourceDocument = gql`
    mutation StripeCreditCardFormRegisterSource($setupIntentClientSecret: String!) {
  registerStripePaymentSource(
    setupIntentClientSecret: $setupIntentClientSecret
    saveForFutureUse: true
  ) {
    id
  }
}
    `;

/**
 * __useStripeCreditCardFormRegisterSourceMutation__
 *
 * To run a mutation, you first call `useStripeCreditCardFormRegisterSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeCreditCardFormRegisterSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeCreditCardFormRegisterSourceMutation, { data, loading, error }] = useStripeCreditCardFormRegisterSourceMutation({
 *   variables: {
 *      setupIntentClientSecret: // value for 'setupIntentClientSecret'
 *   },
 * });
 */
export function useStripeCreditCardFormRegisterSourceMutation(baseOptions?: Apollo.MutationHookOptions<StripeCreditCardFormRegisterSourceMutation, StripeCreditCardFormRegisterSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeCreditCardFormRegisterSourceMutation, StripeCreditCardFormRegisterSourceMutationVariables>(StripeCreditCardFormRegisterSourceDocument, options);
      }
export type StripeCreditCardFormRegisterSourceMutationHookResult = ReturnType<typeof useStripeCreditCardFormRegisterSourceMutation>;
export type StripeCreditCardFormRegisterSourceMutationResult = Apollo.MutationResult<StripeCreditCardFormRegisterSourceMutation>;
export type StripeCreditCardFormRegisterSourceMutationOptions = Apollo.BaseMutationOptions<StripeCreditCardFormRegisterSourceMutation, StripeCreditCardFormRegisterSourceMutationVariables>;
export const StripeCreditCardFormRemoveSourceDocument = gql`
    mutation StripeCreditCardFormRemoveSource($paymentSourceId: String!) {
  removePaymentSource(paymentSourceId: $paymentSourceId) {
    id
  }
}
    `;

/**
 * __useStripeCreditCardFormRemoveSourceMutation__
 *
 * To run a mutation, you first call `useStripeCreditCardFormRemoveSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeCreditCardFormRemoveSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeCreditCardFormRemoveSourceMutation, { data, loading, error }] = useStripeCreditCardFormRemoveSourceMutation({
 *   variables: {
 *      paymentSourceId: // value for 'paymentSourceId'
 *   },
 * });
 */
export function useStripeCreditCardFormRemoveSourceMutation(baseOptions?: Apollo.MutationHookOptions<StripeCreditCardFormRemoveSourceMutation, StripeCreditCardFormRemoveSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeCreditCardFormRemoveSourceMutation, StripeCreditCardFormRemoveSourceMutationVariables>(StripeCreditCardFormRemoveSourceDocument, options);
      }
export type StripeCreditCardFormRemoveSourceMutationHookResult = ReturnType<typeof useStripeCreditCardFormRemoveSourceMutation>;
export type StripeCreditCardFormRemoveSourceMutationResult = Apollo.MutationResult<StripeCreditCardFormRemoveSourceMutation>;
export type StripeCreditCardFormRemoveSourceMutationOptions = Apollo.BaseMutationOptions<StripeCreditCardFormRemoveSourceMutation, StripeCreditCardFormRemoveSourceMutationVariables>;
export const ActivateSubscriptionByCodeDocument = gql`
    mutation ActivateSubscriptionByCode($activationCode: String!, $productId: Int!) {
  activateSubscriptionByCode(
    activationCode: $activationCode
    productId: $productId
  )
}
    `;

/**
 * __useActivateSubscriptionByCodeMutation__
 *
 * To run a mutation, you first call `useActivateSubscriptionByCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSubscriptionByCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSubscriptionByCodeMutation, { data, loading, error }] = useActivateSubscriptionByCodeMutation({
 *   variables: {
 *      activationCode: // value for 'activationCode'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useActivateSubscriptionByCodeMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSubscriptionByCodeMutation, ActivateSubscriptionByCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSubscriptionByCodeMutation, ActivateSubscriptionByCodeMutationVariables>(ActivateSubscriptionByCodeDocument, options);
      }
export type ActivateSubscriptionByCodeMutationHookResult = ReturnType<typeof useActivateSubscriptionByCodeMutation>;
export type ActivateSubscriptionByCodeMutationResult = Apollo.MutationResult<ActivateSubscriptionByCodeMutation>;
export type ActivateSubscriptionByCodeMutationOptions = Apollo.BaseMutationOptions<ActivateSubscriptionByCodeMutation, ActivateSubscriptionByCodeMutationVariables>;
export const AddCartItemDocument = gql`
    mutation AddCartItem($productId: Int!, $color: ProductColor, $size: ProductSize, $quantity: Int!, $neckline: ProductNecklines) {
  addCartItem(
    productId: $productId
    color: $color
    size: $size
    quantity: $quantity
    neckline: $neckline
  )
}
    `;

/**
 * __useAddCartItemMutation__
 *
 * To run a mutation, you first call `useAddCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCartItemMutation, { data, loading, error }] = useAddCartItemMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      color: // value for 'color'
 *      size: // value for 'size'
 *      quantity: // value for 'quantity'
 *      neckline: // value for 'neckline'
 *   },
 * });
 */
export function useAddCartItemMutation(baseOptions?: Apollo.MutationHookOptions<AddCartItemMutation, AddCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCartItemMutation, AddCartItemMutationVariables>(AddCartItemDocument, options);
      }
export type AddCartItemMutationHookResult = ReturnType<typeof useAddCartItemMutation>;
export type AddCartItemMutationResult = Apollo.MutationResult<AddCartItemMutation>;
export type AddCartItemMutationOptions = Apollo.BaseMutationOptions<AddCartItemMutation, AddCartItemMutationVariables>;
export const AddServiceCartItemDocument = gql`
    mutation AddServiceCartItem($productCode: ServiceProductCode!, $periodCode: ServicePeriodCode!) {
  addServiceCartItem(productCode: $productCode, periodCode: $periodCode) {
    id
    cart {
      id
    }
  }
}
    `;

/**
 * __useAddServiceCartItemMutation__
 *
 * To run a mutation, you first call `useAddServiceCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceCartItemMutation, { data, loading, error }] = useAddServiceCartItemMutation({
 *   variables: {
 *      productCode: // value for 'productCode'
 *      periodCode: // value for 'periodCode'
 *   },
 * });
 */
export function useAddServiceCartItemMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceCartItemMutation, AddServiceCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceCartItemMutation, AddServiceCartItemMutationVariables>(AddServiceCartItemDocument, options);
      }
export type AddServiceCartItemMutationHookResult = ReturnType<typeof useAddServiceCartItemMutation>;
export type AddServiceCartItemMutationResult = Apollo.MutationResult<AddServiceCartItemMutation>;
export type AddServiceCartItemMutationOptions = Apollo.BaseMutationOptions<AddServiceCartItemMutation, AddServiceCartItemMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation CreatePayment($selectedSourceId: String, $totalAmount: Float!, $unit: PaymentUnit!, $entityType: PaymentEntityType!, $method: PaymentMethod!, $entityId: Int, $returnUrl: String) {
  payments {
    create(
      paymentInfo: {selectedSourceId: $selectedSourceId, entityId: $entityId, method: $method, entityType: $entityType, amount: $totalAmount, unit: $unit, returnUrl: $returnUrl}
    ) {
      id
      success
      signature
      error
      initiationUrl
      initiationForm {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      selectedSourceId: // value for 'selectedSourceId'
 *      totalAmount: // value for 'totalAmount'
 *      unit: // value for 'unit'
 *      entityType: // value for 'entityType'
 *      method: // value for 'method'
 *      entityId: // value for 'entityId'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentMutation, CreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const CreateStripeSetupIntentDocument = gql`
    mutation CreateStripeSetupIntent {
  createStripeSetupIntent
}
    `;

/**
 * __useCreateStripeSetupIntentMutation__
 *
 * To run a mutation, you first call `useCreateStripeSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeSetupIntentMutation, { data, loading, error }] = useCreateStripeSetupIntentMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateStripeSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeSetupIntentMutation, CreateStripeSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeSetupIntentMutation, CreateStripeSetupIntentMutationVariables>(CreateStripeSetupIntentDocument, options);
      }
export type CreateStripeSetupIntentMutationHookResult = ReturnType<typeof useCreateStripeSetupIntentMutation>;
export type CreateStripeSetupIntentMutationResult = Apollo.MutationResult<CreateStripeSetupIntentMutation>;
export type CreateStripeSetupIntentMutationOptions = Apollo.BaseMutationOptions<CreateStripeSetupIntentMutation, CreateStripeSetupIntentMutationVariables>;
export const ExtendSubscriptionByCodeDocument = gql`
    mutation ExtendSubscriptionByCode($activationCode: String!, $subscriptionId: Int!) {
  extendSubscriptionByCode(
    activationCode: $activationCode
    subscriptionId: $subscriptionId
  )
}
    `;

/**
 * __useExtendSubscriptionByCodeMutation__
 *
 * To run a mutation, you first call `useExtendSubscriptionByCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendSubscriptionByCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendSubscriptionByCodeMutation, { data, loading, error }] = useExtendSubscriptionByCodeMutation({
 *   variables: {
 *      activationCode: // value for 'activationCode'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useExtendSubscriptionByCodeMutation(baseOptions?: Apollo.MutationHookOptions<ExtendSubscriptionByCodeMutation, ExtendSubscriptionByCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtendSubscriptionByCodeMutation, ExtendSubscriptionByCodeMutationVariables>(ExtendSubscriptionByCodeDocument, options);
      }
export type ExtendSubscriptionByCodeMutationHookResult = ReturnType<typeof useExtendSubscriptionByCodeMutation>;
export type ExtendSubscriptionByCodeMutationResult = Apollo.MutationResult<ExtendSubscriptionByCodeMutation>;
export type ExtendSubscriptionByCodeMutationOptions = Apollo.BaseMutationOptions<ExtendSubscriptionByCodeMutation, ExtendSubscriptionByCodeMutationVariables>;
export const InitiateCartPaymentDocument = gql`
    mutation InitiateCartPayment($paymentMethod: String!) {
  initiateCartPayment(paymentMethod: $paymentMethod) {
    paymentId
    paymentIntentClientSecret
  }
}
    `;

/**
 * __useInitiateCartPaymentMutation__
 *
 * To run a mutation, you first call `useInitiateCartPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateCartPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateCartPaymentMutation, { data, loading, error }] = useInitiateCartPaymentMutation({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useInitiateCartPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiateCartPaymentMutation, InitiateCartPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateCartPaymentMutation, InitiateCartPaymentMutationVariables>(InitiateCartPaymentDocument, options);
      }
export type InitiateCartPaymentMutationHookResult = ReturnType<typeof useInitiateCartPaymentMutation>;
export type InitiateCartPaymentMutationResult = Apollo.MutationResult<InitiateCartPaymentMutation>;
export type InitiateCartPaymentMutationOptions = Apollo.BaseMutationOptions<InitiateCartPaymentMutation, InitiateCartPaymentMutationVariables>;
export const InitiateSubscriptionPaymentDocument = gql`
    mutation InitiateSubscriptionPayment($productId: Int!, $countryId: Int!, $paymentMethod: String!, $period: SubscriptionPeriod!) {
  initiateSubscriptionPayment(
    productId: $productId
    countryId: $countryId
    paymentMethod: $paymentMethod
    period: $period
  ) {
    paymentId
    paymentIntentClientSecret
  }
}
    `;

/**
 * __useInitiateSubscriptionPaymentMutation__
 *
 * To run a mutation, you first call `useInitiateSubscriptionPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateSubscriptionPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateSubscriptionPaymentMutation, { data, loading, error }] = useInitiateSubscriptionPaymentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      countryId: // value for 'countryId'
 *      paymentMethod: // value for 'paymentMethod'
 *      period: // value for 'period'
 *   },
 * });
 */
export function useInitiateSubscriptionPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiateSubscriptionPaymentMutation, InitiateSubscriptionPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateSubscriptionPaymentMutation, InitiateSubscriptionPaymentMutationVariables>(InitiateSubscriptionPaymentDocument, options);
      }
export type InitiateSubscriptionPaymentMutationHookResult = ReturnType<typeof useInitiateSubscriptionPaymentMutation>;
export type InitiateSubscriptionPaymentMutationResult = Apollo.MutationResult<InitiateSubscriptionPaymentMutation>;
export type InitiateSubscriptionPaymentMutationOptions = Apollo.BaseMutationOptions<InitiateSubscriptionPaymentMutation, InitiateSubscriptionPaymentMutationVariables>;
export const RegisterStripePaymentSourceDocument = gql`
    mutation RegisterStripePaymentSource($setupIntentClientSecret: String!) {
  registerStripePaymentSource(
    setupIntentClientSecret: $setupIntentClientSecret
    saveForFutureUse: true
  ) {
    id
  }
}
    `;

/**
 * __useRegisterStripePaymentSourceMutation__
 *
 * To run a mutation, you first call `useRegisterStripePaymentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterStripePaymentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerStripePaymentSourceMutation, { data, loading, error }] = useRegisterStripePaymentSourceMutation({
 *   variables: {
 *      setupIntentClientSecret: // value for 'setupIntentClientSecret'
 *   },
 * });
 */
export function useRegisterStripePaymentSourceMutation(baseOptions?: Apollo.MutationHookOptions<RegisterStripePaymentSourceMutation, RegisterStripePaymentSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterStripePaymentSourceMutation, RegisterStripePaymentSourceMutationVariables>(RegisterStripePaymentSourceDocument, options);
      }
export type RegisterStripePaymentSourceMutationHookResult = ReturnType<typeof useRegisterStripePaymentSourceMutation>;
export type RegisterStripePaymentSourceMutationResult = Apollo.MutationResult<RegisterStripePaymentSourceMutation>;
export type RegisterStripePaymentSourceMutationOptions = Apollo.BaseMutationOptions<RegisterStripePaymentSourceMutation, RegisterStripePaymentSourceMutationVariables>;
export const RemoveCartItemDocument = gql`
    mutation RemoveCartItem($cartItemId: Int!) {
  removeCartItem(cartItemId: $cartItemId)
}
    `;

/**
 * __useRemoveCartItemMutation__
 *
 * To run a mutation, you first call `useRemoveCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCartItemMutation, { data, loading, error }] = useRemoveCartItemMutation({
 *   variables: {
 *      cartItemId: // value for 'cartItemId'
 *   },
 * });
 */
export function useRemoveCartItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCartItemMutation, RemoveCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCartItemMutation, RemoveCartItemMutationVariables>(RemoveCartItemDocument, options);
      }
export type RemoveCartItemMutationHookResult = ReturnType<typeof useRemoveCartItemMutation>;
export type RemoveCartItemMutationResult = Apollo.MutationResult<RemoveCartItemMutation>;
export type RemoveCartItemMutationOptions = Apollo.BaseMutationOptions<RemoveCartItemMutation, RemoveCartItemMutationVariables>;
export const RemoveServiceCartItemDocument = gql`
    mutation RemoveServiceCartItem($productCode: ServiceProductCode!) {
  removeServiceCartItem(productCode: $productCode)
}
    `;

/**
 * __useRemoveServiceCartItemMutation__
 *
 * To run a mutation, you first call `useRemoveServiceCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveServiceCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeServiceCartItemMutation, { data, loading, error }] = useRemoveServiceCartItemMutation({
 *   variables: {
 *      productCode: // value for 'productCode'
 *   },
 * });
 */
export function useRemoveServiceCartItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveServiceCartItemMutation, RemoveServiceCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveServiceCartItemMutation, RemoveServiceCartItemMutationVariables>(RemoveServiceCartItemDocument, options);
      }
export type RemoveServiceCartItemMutationHookResult = ReturnType<typeof useRemoveServiceCartItemMutation>;
export type RemoveServiceCartItemMutationResult = Apollo.MutationResult<RemoveServiceCartItemMutation>;
export type RemoveServiceCartItemMutationOptions = Apollo.BaseMutationOptions<RemoveServiceCartItemMutation, RemoveServiceCartItemMutationVariables>;
export const RequestInviteDocument = gql`
    mutation RequestInvite($email: String!, $firstName: String!, $lastName: String!, $phone: String!, $countryId: Int!, $state: String, $city: String) {
  requestInvite(
    email: $email
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    countryId: $countryId
    state: $state
    city: $city
  )
}
    `;

/**
 * __useRequestInviteMutation__
 *
 * To run a mutation, you first call `useRequestInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestInviteMutation, { data, loading, error }] = useRequestInviteMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      countryId: // value for 'countryId'
 *      state: // value for 'state'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useRequestInviteMutation(baseOptions?: Apollo.MutationHookOptions<RequestInviteMutation, RequestInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestInviteMutation, RequestInviteMutationVariables>(RequestInviteDocument, options);
      }
export type RequestInviteMutationHookResult = ReturnType<typeof useRequestInviteMutation>;
export type RequestInviteMutationResult = Apollo.MutationResult<RequestInviteMutation>;
export type RequestInviteMutationOptions = Apollo.BaseMutationOptions<RequestInviteMutation, RequestInviteMutationVariables>;
export const SendContactSupportMessageDocument = gql`
    mutation SendContactSupportMessage($data: PublicSupportMessageInput) {
  sendContactSupportMessage(data: $data) {
    success
  }
}
    `;

/**
 * __useSendContactSupportMessageMutation__
 *
 * To run a mutation, you first call `useSendContactSupportMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendContactSupportMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendContactSupportMessageMutation, { data, loading, error }] = useSendContactSupportMessageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendContactSupportMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendContactSupportMessageMutation, SendContactSupportMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendContactSupportMessageMutation, SendContactSupportMessageMutationVariables>(SendContactSupportMessageDocument, options);
      }
export type SendContactSupportMessageMutationHookResult = ReturnType<typeof useSendContactSupportMessageMutation>;
export type SendContactSupportMessageMutationResult = Apollo.MutationResult<SendContactSupportMessageMutation>;
export type SendContactSupportMessageMutationOptions = Apollo.BaseMutationOptions<SendContactSupportMessageMutation, SendContactSupportMessageMutationVariables>;
export const StoreUserConsentDocument = gql`
    mutation StoreUserConsent($code: UserConsentCode!, $granted: Boolean!) {
  storeUserConsent(code: $code, granted: $granted)
}
    `;

/**
 * __useStoreUserConsentMutation__
 *
 * To run a mutation, you first call `useStoreUserConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreUserConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeUserConsentMutation, { data, loading, error }] = useStoreUserConsentMutation({
 *   variables: {
 *      code: // value for 'code'
 *      granted: // value for 'granted'
 *   },
 * });
 */
export function useStoreUserConsentMutation(baseOptions?: Apollo.MutationHookOptions<StoreUserConsentMutation, StoreUserConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreUserConsentMutation, StoreUserConsentMutationVariables>(StoreUserConsentDocument, options);
      }
export type StoreUserConsentMutationHookResult = ReturnType<typeof useStoreUserConsentMutation>;
export type StoreUserConsentMutationResult = Apollo.MutationResult<StoreUserConsentMutation>;
export type StoreUserConsentMutationOptions = Apollo.BaseMutationOptions<StoreUserConsentMutation, StoreUserConsentMutationVariables>;
export const UpdateCartItemDocument = gql`
    mutation UpdateCartItem($cartItemId: Int!, $quantity: Int!) {
  updateCartItem(cartItemId: $cartItemId, quantity: $quantity)
}
    `;

/**
 * __useUpdateCartItemMutation__
 *
 * To run a mutation, you first call `useUpdateCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCartItemMutation, { data, loading, error }] = useUpdateCartItemMutation({
 *   variables: {
 *      cartItemId: // value for 'cartItemId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateCartItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCartItemMutation, UpdateCartItemMutationVariables>(UpdateCartItemDocument, options);
      }
export type UpdateCartItemMutationHookResult = ReturnType<typeof useUpdateCartItemMutation>;
export type UpdateCartItemMutationResult = Apollo.MutationResult<UpdateCartItemMutation>;
export type UpdateCartItemMutationOptions = Apollo.BaseMutationOptions<UpdateCartItemMutation, UpdateCartItemMutationVariables>;
export const UpdateServiceCartItemPeriodDocument = gql`
    mutation UpdateServiceCartItemPeriod($productCode: ServiceProductCode!, $periodCode: ServicePeriodCode!) {
  updateServiceCartItemPeriod(productCode: $productCode, periodCode: $periodCode)
}
    `;

/**
 * __useUpdateServiceCartItemPeriodMutation__
 *
 * To run a mutation, you first call `useUpdateServiceCartItemPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceCartItemPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceCartItemPeriodMutation, { data, loading, error }] = useUpdateServiceCartItemPeriodMutation({
 *   variables: {
 *      productCode: // value for 'productCode'
 *      periodCode: // value for 'periodCode'
 *   },
 * });
 */
export function useUpdateServiceCartItemPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceCartItemPeriodMutation, UpdateServiceCartItemPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceCartItemPeriodMutation, UpdateServiceCartItemPeriodMutationVariables>(UpdateServiceCartItemPeriodDocument, options);
      }
export type UpdateServiceCartItemPeriodMutationHookResult = ReturnType<typeof useUpdateServiceCartItemPeriodMutation>;
export type UpdateServiceCartItemPeriodMutationResult = Apollo.MutationResult<UpdateServiceCartItemPeriodMutation>;
export type UpdateServiceCartItemPeriodMutationOptions = Apollo.BaseMutationOptions<UpdateServiceCartItemPeriodMutation, UpdateServiceCartItemPeriodMutationVariables>;
export const PrivateViewDocument = gql`
    query PrivateView {
  me {
    info {
      isAffiliate
      isCOC
    }
    intercomHash
    consents {
      code
      required
      granted
      isForAffiliates
      isForCustomers
    }
  }
  viewer {
    id
    isActive
    username
    email
    country
    firstName
    lastName
    phone
    referralCode
    hasAccessToWebOffice
    rankId
    registerDate
    dateOfBirth
  }
}
    `;

/**
 * __usePrivateViewQuery__
 *
 * To run a query within a React component, call `usePrivateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateViewQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrivateViewQuery(baseOptions?: Apollo.QueryHookOptions<PrivateViewQuery, PrivateViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivateViewQuery, PrivateViewQueryVariables>(PrivateViewDocument, options);
      }
export function usePrivateViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivateViewQuery, PrivateViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivateViewQuery, PrivateViewQueryVariables>(PrivateViewDocument, options);
        }
export type PrivateViewQueryHookResult = ReturnType<typeof usePrivateViewQuery>;
export type PrivateViewLazyQueryHookResult = ReturnType<typeof usePrivateViewLazyQuery>;
export type PrivateViewQueryResult = Apollo.QueryResult<PrivateViewQuery, PrivateViewQueryVariables>;
export const AppAuthenticationStatusDocument = gql`
    query AppAuthenticationStatus {
  me {
    isLoggedIn
  }
}
    `;

/**
 * __useAppAuthenticationStatusQuery__
 *
 * To run a query within a React component, call `useAppAuthenticationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppAuthenticationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppAuthenticationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppAuthenticationStatusQuery(baseOptions?: Apollo.QueryHookOptions<AppAuthenticationStatusQuery, AppAuthenticationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppAuthenticationStatusQuery, AppAuthenticationStatusQueryVariables>(AppAuthenticationStatusDocument, options);
      }
export function useAppAuthenticationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppAuthenticationStatusQuery, AppAuthenticationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppAuthenticationStatusQuery, AppAuthenticationStatusQueryVariables>(AppAuthenticationStatusDocument, options);
        }
export type AppAuthenticationStatusQueryHookResult = ReturnType<typeof useAppAuthenticationStatusQuery>;
export type AppAuthenticationStatusLazyQueryHookResult = ReturnType<typeof useAppAuthenticationStatusLazyQuery>;
export type AppAuthenticationStatusQueryResult = Apollo.QueryResult<AppAuthenticationStatusQuery, AppAuthenticationStatusQueryVariables>;
export const CartItemsDocument = gql`
    query CartItems {
  me {
    serviceCart {
      id
      items {
        id
      }
    }
  }
}
    `;

/**
 * __useCartItemsQuery__
 *
 * To run a query within a React component, call `useCartItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartItemsQuery(baseOptions?: Apollo.QueryHookOptions<CartItemsQuery, CartItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartItemsQuery, CartItemsQueryVariables>(CartItemsDocument, options);
      }
export function useCartItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartItemsQuery, CartItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartItemsQuery, CartItemsQueryVariables>(CartItemsDocument, options);
        }
export type CartItemsQueryHookResult = ReturnType<typeof useCartItemsQuery>;
export type CartItemsLazyQueryHookResult = ReturnType<typeof useCartItemsLazyQuery>;
export type CartItemsQueryResult = Apollo.QueryResult<CartItemsQuery, CartItemsQueryVariables>;
export const CountryDocument = gql`
    query Country {
  country {
    countries {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useCountryQuery__
 *
 * To run a query within a React component, call `useCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountryQuery(baseOptions?: Apollo.QueryHookOptions<CountryQuery, CountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountryQuery, CountryQueryVariables>(CountryDocument, options);
      }
export function useCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountryQuery, CountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountryQuery, CountryQueryVariables>(CountryDocument, options);
        }
export type CountryQueryHookResult = ReturnType<typeof useCountryQuery>;
export type CountryLazyQueryHookResult = ReturnType<typeof useCountryLazyQuery>;
export type CountryQueryResult = Apollo.QueryResult<CountryQuery, CountryQueryVariables>;
export const GetAffiliateDocument = gql`
    query GetAffiliate {
  getAffiliate {
    id
    affiliateId
    firstName
    lastName
  }
}
    `;

/**
 * __useGetAffiliateQuery__
 *
 * To run a query within a React component, call `useGetAffiliateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAffiliateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAffiliateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAffiliateQuery(baseOptions?: Apollo.QueryHookOptions<GetAffiliateQuery, GetAffiliateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAffiliateQuery, GetAffiliateQueryVariables>(GetAffiliateDocument, options);
      }
export function useGetAffiliateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAffiliateQuery, GetAffiliateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAffiliateQuery, GetAffiliateQueryVariables>(GetAffiliateDocument, options);
        }
export type GetAffiliateQueryHookResult = ReturnType<typeof useGetAffiliateQuery>;
export type GetAffiliateLazyQueryHookResult = ReturnType<typeof useGetAffiliateLazyQuery>;
export type GetAffiliateQueryResult = Apollo.QueryResult<GetAffiliateQuery, GetAffiliateQueryVariables>;
export const GetPaymentStatusDocument = gql`
    query GetPaymentStatus($paymentId: String) {
  getPaymentStatus(paymentId: $paymentId) {
    status
  }
}
    `;

/**
 * __useGetPaymentStatusQuery__
 *
 * To run a query within a React component, call `useGetPaymentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentStatusQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useGetPaymentStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, options);
      }
export function useGetPaymentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>(GetPaymentStatusDocument, options);
        }
export type GetPaymentStatusQueryHookResult = ReturnType<typeof useGetPaymentStatusQuery>;
export type GetPaymentStatusLazyQueryHookResult = ReturnType<typeof useGetPaymentStatusLazyQuery>;
export type GetPaymentStatusQueryResult = Apollo.QueryResult<GetPaymentStatusQuery, GetPaymentStatusQueryVariables>;
export const GetSubscriptionDocument = gql`
    query GetSubscription($id: Int!) {
  getSubscription(id: $id) {
    id
    ownerId
    productId
    productInformation
    type
    status
    provider
    price
    stripeSubscriptionId
    paymentExpireDate
    productName
    payments {
      amount
      periodStart
      createdDate
      periodEnd
      status
      description
    }
    failedDate
    lastTryDate
    createdDate
    updatedDate
  }
}
    `;

/**
 * __useGetSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQuery, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQuery, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionQueryHookResult = ReturnType<typeof useGetSubscriptionQuery>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const PaymentStatusDocument = gql`
    query PaymentStatus($transactionId: String, $paymentId: String) {
  payments {
    fetch(transactionId: $transactionId, paymentId: $paymentId) {
      id
      entityType
      entityId
      status
    }
  }
}
    `;

/**
 * __usePaymentStatusQuery__
 *
 * To run a query within a React component, call `usePaymentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentStatusQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function usePaymentStatusQuery(baseOptions?: Apollo.QueryHookOptions<PaymentStatusQuery, PaymentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentStatusQuery, PaymentStatusQueryVariables>(PaymentStatusDocument, options);
      }
export function usePaymentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentStatusQuery, PaymentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentStatusQuery, PaymentStatusQueryVariables>(PaymentStatusDocument, options);
        }
export type PaymentStatusQueryHookResult = ReturnType<typeof usePaymentStatusQuery>;
export type PaymentStatusLazyQueryHookResult = ReturnType<typeof usePaymentStatusLazyQuery>;
export type PaymentStatusQueryResult = Apollo.QueryResult<PaymentStatusQuery, PaymentStatusQueryVariables>;
export const ViewerDocument = gql`
    query Viewer {
  viewer {
    id
    username
    firstName
    lastName
    email
    phone
    postcode
    countryId
    referralCode
    dateOfBirth
    country
    countryCode
    state
    city
    address
    hasActiveStarterKit
    hasAccessToWebOffice
    isActive
    affiliateId
    forceEmailChange
    rankId
    registerDate
    coinAccountBalance
    shopCreditBalance
    scrCreditBalance
  }
  me {
    currency {
      code
    }
    intercomHash
    info {
      isAffiliate
      isCOC
    }
    xera {
      id
      username
      isIncomeCentre
      xeraUsername
      xeraEmail
    }
    webwalletAddresses {
      address
      walletType
    }
    dagsInfo {
      totalDags
      totalScr
      usedDags
      ratio
      burned {
        dags
        scr
        createdAt
      }
    }
    meD2TInfo {
      totalDags
      totalScr
      usedDags
      ratio
      burned {
        dags
        scr
        createdAt
        name
        email
      }
    }
  }
}
    `;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(baseOptions?: Apollo.QueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
      }
export function useViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerQueryResult = Apollo.QueryResult<ViewerQuery, ViewerQueryVariables>;
export const AccountViewDocument = gql`
    query AccountView {
  me {
    activePlatofrmFeeSubscription {
      productCodes
      dateEnd
      expiresInSeconds
      gracePeriodDateEnd
      gracePeriodExpiresInSeconds
    }
    currency {
      code
    }
  }
}
    `;

/**
 * __useAccountViewQuery__
 *
 * To run a query within a React component, call `useAccountViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountViewQuery(baseOptions?: Apollo.QueryHookOptions<AccountViewQuery, AccountViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountViewQuery, AccountViewQueryVariables>(AccountViewDocument, options);
      }
export function useAccountViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountViewQuery, AccountViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountViewQuery, AccountViewQueryVariables>(AccountViewDocument, options);
        }
export type AccountViewQueryHookResult = ReturnType<typeof useAccountViewQuery>;
export type AccountViewLazyQueryHookResult = ReturnType<typeof useAccountViewLazyQuery>;
export type AccountViewQueryResult = Apollo.QueryResult<AccountViewQuery, AccountViewQueryVariables>;
export const BankCodeAccessViewDocument = gql`
    query BankCodeAccessView {
  me {
    codebreakerAccess {
      bankBasicUrl
      bankFullUrl
    }
  }
}
    `;

/**
 * __useBankCodeAccessViewQuery__
 *
 * To run a query within a React component, call `useBankCodeAccessViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankCodeAccessViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankCodeAccessViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankCodeAccessViewQuery(baseOptions?: Apollo.QueryHookOptions<BankCodeAccessViewQuery, BankCodeAccessViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankCodeAccessViewQuery, BankCodeAccessViewQueryVariables>(BankCodeAccessViewDocument, options);
      }
export function useBankCodeAccessViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankCodeAccessViewQuery, BankCodeAccessViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankCodeAccessViewQuery, BankCodeAccessViewQueryVariables>(BankCodeAccessViewDocument, options);
        }
export type BankCodeAccessViewQueryHookResult = ReturnType<typeof useBankCodeAccessViewQuery>;
export type BankCodeAccessViewLazyQueryHookResult = ReturnType<typeof useBankCodeAccessViewLazyQuery>;
export type BankCodeAccessViewQueryResult = Apollo.QueryResult<BankCodeAccessViewQuery, BankCodeAccessViewQueryVariables>;
export const BecomeAffiliateViewDocument = gql`
    query BecomeAffiliateView {
  me {
    currency {
      code
    }
    info {
      isAffiliate
      username
      email
    }
    activeServiceProductCodes
    consents {
      code
      required
      granted
      isForAffiliates
    }
  }
}
    `;

/**
 * __useBecomeAffiliateViewQuery__
 *
 * To run a query within a React component, call `useBecomeAffiliateViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBecomeAffiliateViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBecomeAffiliateViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useBecomeAffiliateViewQuery(baseOptions?: Apollo.QueryHookOptions<BecomeAffiliateViewQuery, BecomeAffiliateViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BecomeAffiliateViewQuery, BecomeAffiliateViewQueryVariables>(BecomeAffiliateViewDocument, options);
      }
export function useBecomeAffiliateViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BecomeAffiliateViewQuery, BecomeAffiliateViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BecomeAffiliateViewQuery, BecomeAffiliateViewQueryVariables>(BecomeAffiliateViewDocument, options);
        }
export type BecomeAffiliateViewQueryHookResult = ReturnType<typeof useBecomeAffiliateViewQuery>;
export type BecomeAffiliateViewLazyQueryHookResult = ReturnType<typeof useBecomeAffiliateViewLazyQuery>;
export type BecomeAffiliateViewQueryResult = Apollo.QueryResult<BecomeAffiliateViewQuery, BecomeAffiliateViewQueryVariables>;
export const BecomeAffiliateDocument = gql`
    mutation BecomeAffiliate($activationCode: String, $username: String!, $leftUsername: String, $rightUsername: String) {
  becomeAffiliate(
    activationCode: $activationCode
    username: $username
    leftUsername: $leftUsername
    rightUsername: $rightUsername
  )
}
    `;

/**
 * __useBecomeAffiliateMutation__
 *
 * To run a mutation, you first call `useBecomeAffiliateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBecomeAffiliateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [becomeAffiliateMutation, { data, loading, error }] = useBecomeAffiliateMutation({
 *   variables: {
 *      activationCode: // value for 'activationCode'
 *      username: // value for 'username'
 *      leftUsername: // value for 'leftUsername'
 *      rightUsername: // value for 'rightUsername'
 *   },
 * });
 */
export function useBecomeAffiliateMutation(baseOptions?: Apollo.MutationHookOptions<BecomeAffiliateMutation, BecomeAffiliateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BecomeAffiliateMutation, BecomeAffiliateMutationVariables>(BecomeAffiliateDocument, options);
      }
export type BecomeAffiliateMutationHookResult = ReturnType<typeof useBecomeAffiliateMutation>;
export type BecomeAffiliateMutationResult = Apollo.MutationResult<BecomeAffiliateMutation>;
export type BecomeAffiliateMutationOptions = Apollo.BaseMutationOptions<BecomeAffiliateMutation, BecomeAffiliateMutationVariables>;
export const BecomeAffiliateViewStoreUserConsentDocument = gql`
    mutation BecomeAffiliateViewStoreUserConsent($code: UserConsentCode!, $granted: Boolean!) {
  storeUserConsent(code: $code, granted: $granted)
}
    `;

/**
 * __useBecomeAffiliateViewStoreUserConsentMutation__
 *
 * To run a mutation, you first call `useBecomeAffiliateViewStoreUserConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBecomeAffiliateViewStoreUserConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [becomeAffiliateViewStoreUserConsentMutation, { data, loading, error }] = useBecomeAffiliateViewStoreUserConsentMutation({
 *   variables: {
 *      code: // value for 'code'
 *      granted: // value for 'granted'
 *   },
 * });
 */
export function useBecomeAffiliateViewStoreUserConsentMutation(baseOptions?: Apollo.MutationHookOptions<BecomeAffiliateViewStoreUserConsentMutation, BecomeAffiliateViewStoreUserConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BecomeAffiliateViewStoreUserConsentMutation, BecomeAffiliateViewStoreUserConsentMutationVariables>(BecomeAffiliateViewStoreUserConsentDocument, options);
      }
export type BecomeAffiliateViewStoreUserConsentMutationHookResult = ReturnType<typeof useBecomeAffiliateViewStoreUserConsentMutation>;
export type BecomeAffiliateViewStoreUserConsentMutationResult = Apollo.MutationResult<BecomeAffiliateViewStoreUserConsentMutation>;
export type BecomeAffiliateViewStoreUserConsentMutationOptions = Apollo.BaseMutationOptions<BecomeAffiliateViewStoreUserConsentMutation, BecomeAffiliateViewStoreUserConsentMutationVariables>;
export const DigitalProductsViewDocument = gql`
    query DigitalProductsView($theViewProductCodes: [ServiceProductCode!]!, $paymentMethod: PaymentMethod!) {
  awentures: service(productCode: AWENTURES) {
    ...DigitalProductsViewServiceParts
  }
  hunterSystems: services(
    productCodes: [HUNTER_SYSTEMS_BASIC, HUNTER_SYSTEMS_STANDARD, HUNTER_SYSTEMS_PLUS, HUNTER_SYSTEMS_PRO]
  ) {
    ...DigitalProductsViewServiceParts
  }
  bancus: service(productCode: BANCUS) {
    ...DigitalProductsViewServiceParts
  }
  forex: service(productCode: FOREX) {
    ...DigitalProductsViewServiceParts
  }
  forexPro: service(productCode: FOREX_PRO) {
    ...DigitalProductsViewServiceParts
  }
  bankBasic: service(productCode: BANK_BASIC) {
    ...DigitalProductsViewServiceParts
  }
  bankFull: service(productCode: BANK_FULL) {
    ...DigitalProductsViewServiceParts
  }
  businessFeeBasic: service(productCode: BUSINESS_FEE_BASIC) {
    ...DigitalProductsViewServiceParts
  }
  businessFeePro: service(productCode: BUSINESS_FEE_PRO) {
    ...DigitalProductsViewServiceParts
  }
  membershipBasic: service(productCode: MEMBERSHIP_BASIC) {
    ...DigitalProductsViewServiceParts
  }
  membershipPro: service(productCode: MEMBERSHIP_PRO) {
    ...DigitalProductsViewServiceParts
  }
  platformFee: service(productCode: PLATFORM_FEE) {
    ...DigitalProductsViewServiceParts
  }
  marketingFee: service(productCode: SF_MARKETING_FEE) {
    ...DigitalProductsViewServiceParts
  }
  theView: services(productCodes: $theViewProductCodes) {
    code
    name
    offers {
      fullPrice
      availability
      discountedPrice
      currency {
        code
      }
    }
  }
  viewer {
    id
    isActive
    coinAccountBalance
    phone
    registerDate
  }
  me {
    hunterSystemsAccess {
      url
      accessUrl
      description
    }
    activePlatofrmFeeSubscription {
      productCodes
      dateEnd
      expiresInSeconds
      gracePeriodDateEnd
      gracePeriodExpiresInSeconds
    }
    activeMarketingFeeSubscription {
      productCodes
      dateEnd
      expiresInSeconds
      gracePeriodDateEnd
      gracePeriodExpiresInSeconds
    }
    activeServiceProductCodes
    activeBusinessFeeSubscription {
      productCodes
      dateEnd
      expiresInSeconds
      gracePeriodDateEnd
      gracePeriodExpiresInSeconds
    }
    paymentMethods(paymentUnit: DAG) {
      enabled
      method
    }
    currency {
      code
    }
    serviceSubscriptions(active: true) {
      id
      status
      billingAmount(method: $paymentMethod)
      billingCurrency {
        code
      }
      products {
        code
      }
      gracePeriodDateEnd
      gracePeriodExpiresInSeconds
      productCodes
      periodCode
      dateStart
    }
    codebreakerAccess {
      bankBasicUrl
      bankFullUrl
    }
    forexInsidersAccess
    membershipAccess
    webwalletAddresses {
      address
      walletType
    }
    theViewForDags {
      dateStart
      dateEnd
      expiresInSeconds
      offers {
        id
        eurOfferPurchaseDate
        dagOffer {
          id
          fullPrice
        }
        eurOffer {
          fullPrice
          labelText
        }
      }
    }
    productsForDags {
      dateStart
      dateEnd
      expiresInSeconds
      product {
        code
      }
      offers {
        id
        period {
          code
        }
        fullPrice
        fullPriceEur
      }
    }
    theiaAccess
    consents {
      code
      isForAffiliates
      isForCustomers
      required
      granted
    }
  }
}
    ${DigitalProductsViewServicePartsFragmentDoc}`;

/**
 * __useDigitalProductsViewQuery__
 *
 * To run a query within a React component, call `useDigitalProductsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDigitalProductsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDigitalProductsViewQuery({
 *   variables: {
 *      theViewProductCodes: // value for 'theViewProductCodes'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useDigitalProductsViewQuery(baseOptions: Apollo.QueryHookOptions<DigitalProductsViewQuery, DigitalProductsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DigitalProductsViewQuery, DigitalProductsViewQueryVariables>(DigitalProductsViewDocument, options);
      }
export function useDigitalProductsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DigitalProductsViewQuery, DigitalProductsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DigitalProductsViewQuery, DigitalProductsViewQueryVariables>(DigitalProductsViewDocument, options);
        }
export type DigitalProductsViewQueryHookResult = ReturnType<typeof useDigitalProductsViewQuery>;
export type DigitalProductsViewLazyQueryHookResult = ReturnType<typeof useDigitalProductsViewLazyQuery>;
export type DigitalProductsViewQueryResult = Apollo.QueryResult<DigitalProductsViewQuery, DigitalProductsViewQueryVariables>;
export const RegisterWebinarDocument = gql`
    mutation RegisterWebinar($email: String!) {
  registerWebinar(email: $email)
}
    `;

/**
 * __useRegisterWebinarMutation__
 *
 * To run a mutation, you first call `useRegisterWebinarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWebinarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWebinarMutation, { data, loading, error }] = useRegisterWebinarMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRegisterWebinarMutation(baseOptions?: Apollo.MutationHookOptions<RegisterWebinarMutation, RegisterWebinarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterWebinarMutation, RegisterWebinarMutationVariables>(RegisterWebinarDocument, options);
      }
export type RegisterWebinarMutationHookResult = ReturnType<typeof useRegisterWebinarMutation>;
export type RegisterWebinarMutationResult = Apollo.MutationResult<RegisterWebinarMutation>;
export type RegisterWebinarMutationOptions = Apollo.BaseMutationOptions<RegisterWebinarMutation, RegisterWebinarMutationVariables>;
export const UpdateUserWalletDocument = gql`
    mutation UpdateUserWallet($wallet: UserWalletTypesEnum!, $address: String!) {
  updateUserWallet(wallet: $wallet, address: $address)
}
    `;

/**
 * __useUpdateUserWalletMutation__
 *
 * To run a mutation, you first call `useUpdateUserWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserWalletMutation, { data, loading, error }] = useUpdateUserWalletMutation({
 *   variables: {
 *      wallet: // value for 'wallet'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateUserWalletMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserWalletMutation, UpdateUserWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserWalletMutation, UpdateUserWalletMutationVariables>(UpdateUserWalletDocument, options);
      }
export type UpdateUserWalletMutationHookResult = ReturnType<typeof useUpdateUserWalletMutation>;
export type UpdateUserWalletMutationResult = Apollo.MutationResult<UpdateUserWalletMutation>;
export type UpdateUserWalletMutationOptions = Apollo.BaseMutationOptions<UpdateUserWalletMutation, UpdateUserWalletMutationVariables>;
export const DigitalProductsCreateTheViewForDagsCartDocument = gql`
    mutation DigitalProductsCreateTheViewForDagsCart($dagOffersIds: [String!]!) {
  createTheViewForDagsCart(dagOffersIds: $dagOffersIds) {
    id
  }
}
    `;

/**
 * __useDigitalProductsCreateTheViewForDagsCartMutation__
 *
 * To run a mutation, you first call `useDigitalProductsCreateTheViewForDagsCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDigitalProductsCreateTheViewForDagsCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [digitalProductsCreateTheViewForDagsCartMutation, { data, loading, error }] = useDigitalProductsCreateTheViewForDagsCartMutation({
 *   variables: {
 *      dagOffersIds: // value for 'dagOffersIds'
 *   },
 * });
 */
export function useDigitalProductsCreateTheViewForDagsCartMutation(baseOptions?: Apollo.MutationHookOptions<DigitalProductsCreateTheViewForDagsCartMutation, DigitalProductsCreateTheViewForDagsCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DigitalProductsCreateTheViewForDagsCartMutation, DigitalProductsCreateTheViewForDagsCartMutationVariables>(DigitalProductsCreateTheViewForDagsCartDocument, options);
      }
export type DigitalProductsCreateTheViewForDagsCartMutationHookResult = ReturnType<typeof useDigitalProductsCreateTheViewForDagsCartMutation>;
export type DigitalProductsCreateTheViewForDagsCartMutationResult = Apollo.MutationResult<DigitalProductsCreateTheViewForDagsCartMutation>;
export type DigitalProductsCreateTheViewForDagsCartMutationOptions = Apollo.BaseMutationOptions<DigitalProductsCreateTheViewForDagsCartMutation, DigitalProductsCreateTheViewForDagsCartMutationVariables>;
export const DigitalProductsCreateProductsForDagsCartDocument = gql`
    mutation DigitalProductsCreateProductsForDagsCart($offerIds: [String!]!) {
  createProductsForDagsCart(offerIds: $offerIds) {
    id
  }
}
    `;

/**
 * __useDigitalProductsCreateProductsForDagsCartMutation__
 *
 * To run a mutation, you first call `useDigitalProductsCreateProductsForDagsCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDigitalProductsCreateProductsForDagsCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [digitalProductsCreateProductsForDagsCartMutation, { data, loading, error }] = useDigitalProductsCreateProductsForDagsCartMutation({
 *   variables: {
 *      offerIds: // value for 'offerIds'
 *   },
 * });
 */
export function useDigitalProductsCreateProductsForDagsCartMutation(baseOptions?: Apollo.MutationHookOptions<DigitalProductsCreateProductsForDagsCartMutation, DigitalProductsCreateProductsForDagsCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DigitalProductsCreateProductsForDagsCartMutation, DigitalProductsCreateProductsForDagsCartMutationVariables>(DigitalProductsCreateProductsForDagsCartDocument, options);
      }
export type DigitalProductsCreateProductsForDagsCartMutationHookResult = ReturnType<typeof useDigitalProductsCreateProductsForDagsCartMutation>;
export type DigitalProductsCreateProductsForDagsCartMutationResult = Apollo.MutationResult<DigitalProductsCreateProductsForDagsCartMutation>;
export type DigitalProductsCreateProductsForDagsCartMutationOptions = Apollo.BaseMutationOptions<DigitalProductsCreateProductsForDagsCartMutation, DigitalProductsCreateProductsForDagsCartMutationVariables>;
export const ConvertDagsToScrDocument = gql`
    mutation ConvertDagsToScr($totalAmount: String!) {
  convertDags(totalAmount: $totalAmount)
}
    `;

/**
 * __useConvertDagsToScrMutation__
 *
 * To run a mutation, you first call `useConvertDagsToScrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertDagsToScrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertDagsToScrMutation, { data, loading, error }] = useConvertDagsToScrMutation({
 *   variables: {
 *      totalAmount: // value for 'totalAmount'
 *   },
 * });
 */
export function useConvertDagsToScrMutation(baseOptions?: Apollo.MutationHookOptions<ConvertDagsToScrMutation, ConvertDagsToScrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertDagsToScrMutation, ConvertDagsToScrMutationVariables>(ConvertDagsToScrDocument, options);
      }
export type ConvertDagsToScrMutationHookResult = ReturnType<typeof useConvertDagsToScrMutation>;
export type ConvertDagsToScrMutationResult = Apollo.MutationResult<ConvertDagsToScrMutation>;
export type ConvertDagsToScrMutationOptions = Apollo.BaseMutationOptions<ConvertDagsToScrMutation, ConvertDagsToScrMutationVariables>;
export const ConvertCommunityDagsToScrDocument = gql`
    mutation ConvertCommunityDagsToScr($totalAmount: String!, $name: String!, $email: String!) {
  convertCommunityDags(totalAmount: $totalAmount, name: $name, email: $email)
}
    `;

/**
 * __useConvertCommunityDagsToScrMutation__
 *
 * To run a mutation, you first call `useConvertCommunityDagsToScrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertCommunityDagsToScrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertCommunityDagsToScrMutation, { data, loading, error }] = useConvertCommunityDagsToScrMutation({
 *   variables: {
 *      totalAmount: // value for 'totalAmount'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useConvertCommunityDagsToScrMutation(baseOptions?: Apollo.MutationHookOptions<ConvertCommunityDagsToScrMutation, ConvertCommunityDagsToScrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertCommunityDagsToScrMutation, ConvertCommunityDagsToScrMutationVariables>(ConvertCommunityDagsToScrDocument, options);
      }
export type ConvertCommunityDagsToScrMutationHookResult = ReturnType<typeof useConvertCommunityDagsToScrMutation>;
export type ConvertCommunityDagsToScrMutationResult = Apollo.MutationResult<ConvertCommunityDagsToScrMutation>;
export type ConvertCommunityDagsToScrMutationOptions = Apollo.BaseMutationOptions<ConvertCommunityDagsToScrMutation, ConvertCommunityDagsToScrMutationVariables>;
export const ConvertDagsToD2TDocument = gql`
    mutation ConvertDagsToD2T($totalAmount: String!, $name: String!, $email: String!) {
  convertDagsD2T(totalAmount: $totalAmount, name: $name, email: $email)
}
    `;

/**
 * __useConvertDagsToD2TMutation__
 *
 * To run a mutation, you first call `useConvertDagsToD2TMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertDagsToD2TMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertDagsToD2TMutation, { data, loading, error }] = useConvertDagsToD2TMutation({
 *   variables: {
 *      totalAmount: // value for 'totalAmount'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useConvertDagsToD2TMutation(baseOptions?: Apollo.MutationHookOptions<ConvertDagsToD2TMutation, ConvertDagsToD2TMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertDagsToD2TMutation, ConvertDagsToD2TMutationVariables>(ConvertDagsToD2TDocument, options);
      }
export type ConvertDagsToD2TMutationHookResult = ReturnType<typeof useConvertDagsToD2TMutation>;
export type ConvertDagsToD2TMutationResult = Apollo.MutationResult<ConvertDagsToD2TMutation>;
export type ConvertDagsToD2TMutationOptions = Apollo.BaseMutationOptions<ConvertDagsToD2TMutation, ConvertDagsToD2TMutationVariables>;
export const GetAwenturesLoginLinkDocument = gql`
    mutation getAwenturesLoginLink {
  getAwenturesLoginLink
}
    `;

/**
 * __useGetAwenturesLoginLinkMutation__
 *
 * To run a mutation, you first call `useGetAwenturesLoginLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAwenturesLoginLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAwenturesLoginLinkMutation, { data, loading, error }] = useGetAwenturesLoginLinkMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetAwenturesLoginLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetAwenturesLoginLinkMutation, GetAwenturesLoginLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAwenturesLoginLinkMutation, GetAwenturesLoginLinkMutationVariables>(GetAwenturesLoginLinkDocument, options);
      }
export type GetAwenturesLoginLinkMutationHookResult = ReturnType<typeof useGetAwenturesLoginLinkMutation>;
export type GetAwenturesLoginLinkMutationResult = Apollo.MutationResult<GetAwenturesLoginLinkMutation>;
export type GetAwenturesLoginLinkMutationOptions = Apollo.BaseMutationOptions<GetAwenturesLoginLinkMutation, GetAwenturesLoginLinkMutationVariables>;
export const DagCommunityViewDocument = gql`
    query DagCommunityView {
  getTotalBurned {
    totalDags
    rate
  }
}
    `;

/**
 * __useDagCommunityViewQuery__
 *
 * To run a query within a React component, call `useDagCommunityViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDagCommunityViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDagCommunityViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useDagCommunityViewQuery(baseOptions?: Apollo.QueryHookOptions<DagCommunityViewQuery, DagCommunityViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DagCommunityViewQuery, DagCommunityViewQueryVariables>(DagCommunityViewDocument, options);
      }
export function useDagCommunityViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DagCommunityViewQuery, DagCommunityViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DagCommunityViewQuery, DagCommunityViewQueryVariables>(DagCommunityViewDocument, options);
        }
export type DagCommunityViewQueryHookResult = ReturnType<typeof useDagCommunityViewQuery>;
export type DagCommunityViewLazyQueryHookResult = ReturnType<typeof useDagCommunityViewLazyQuery>;
export type DagCommunityViewQueryResult = Apollo.QueryResult<DagCommunityViewQuery, DagCommunityViewQueryVariables>;
export const DigitalProductBarginDocument = gql`
    query DigitalProductBargin {
  me {
    serviceSubscriptions {
      id
      isLegacy
      status
      upgradeOffers {
        id
        products {
          code
          name
        }
        period {
          code
          name
        }
        fullPrice
        discount
        discountedPrice
        currency {
          code
          sign
        }
        labelText
      }
    }
  }
}
    `;

/**
 * __useDigitalProductBarginQuery__
 *
 * To run a query within a React component, call `useDigitalProductBarginQuery` and pass it any options that fit your needs.
 * When your component renders, `useDigitalProductBarginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDigitalProductBarginQuery({
 *   variables: {
 *   },
 * });
 */
export function useDigitalProductBarginQuery(baseOptions?: Apollo.QueryHookOptions<DigitalProductBarginQuery, DigitalProductBarginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DigitalProductBarginQuery, DigitalProductBarginQueryVariables>(DigitalProductBarginDocument, options);
      }
export function useDigitalProductBarginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DigitalProductBarginQuery, DigitalProductBarginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DigitalProductBarginQuery, DigitalProductBarginQueryVariables>(DigitalProductBarginDocument, options);
        }
export type DigitalProductBarginQueryHookResult = ReturnType<typeof useDigitalProductBarginQuery>;
export type DigitalProductBarginLazyQueryHookResult = ReturnType<typeof useDigitalProductBarginLazyQuery>;
export type DigitalProductBarginQueryResult = Apollo.QueryResult<DigitalProductBarginQuery, DigitalProductBarginQueryVariables>;
export const DriveForFiveViewDocument = gql`
    query DriveForFiveView {
  me {
    info {
      username
      inviteLink
    }
    currency {
      code
      sign
    }
    referralsStats {
      active
      registrations
      customers
    }
    serviceSubscriptions(active: true) {
      id
      isLegacy
      referralsStatsForCurrentMonth {
        active
        customers
        registrations
      }
      referralsSubscriptionsForCurrentMonth {
        month
        freeExtension
        records {
          id
          status
        }
      }
      products {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useDriveForFiveViewQuery__
 *
 * To run a query within a React component, call `useDriveForFiveViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriveForFiveViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriveForFiveViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useDriveForFiveViewQuery(baseOptions?: Apollo.QueryHookOptions<DriveForFiveViewQuery, DriveForFiveViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriveForFiveViewQuery, DriveForFiveViewQueryVariables>(DriveForFiveViewDocument, options);
      }
export function useDriveForFiveViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriveForFiveViewQuery, DriveForFiveViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriveForFiveViewQuery, DriveForFiveViewQueryVariables>(DriveForFiveViewDocument, options);
        }
export type DriveForFiveViewQueryHookResult = ReturnType<typeof useDriveForFiveViewQuery>;
export type DriveForFiveViewLazyQueryHookResult = ReturnType<typeof useDriveForFiveViewLazyQuery>;
export type DriveForFiveViewQueryResult = Apollo.QueryResult<DriveForFiveViewQuery, DriveForFiveViewQueryVariables>;
export const DriveForFiveMembershipViewDocument = gql`
    query DriveForFiveMembershipView($subscriptionId: String!) {
  me {
    info {
      inviteLink
    }
    serviceSubscriptions(id: $subscriptionId) {
      id
      isLegacy
      products {
        name
        code
      }
      referralsSubscriptionsActiveForNearestMonths {
        year
        month
        current
        freeExtension
        discountedExtension
        records {
          id
          referral {
            firstName
            lastName
            email
          }
          products {
            code
            name
          }
        }
      }
      referralsSubscriptionsForCurrentMonth {
        month
        freeExtension
        records {
          id
          status
          createdDate
          expiresDate
          referral {
            firstName
            lastName
            email
          }
          products {
            code
            name
          }
        }
      }
      referralsStatsForCurrentMonth {
        active
        customers
        registrations
      }
    }
  }
}
    `;

/**
 * __useDriveForFiveMembershipViewQuery__
 *
 * To run a query within a React component, call `useDriveForFiveMembershipViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriveForFiveMembershipViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriveForFiveMembershipViewQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useDriveForFiveMembershipViewQuery(baseOptions: Apollo.QueryHookOptions<DriveForFiveMembershipViewQuery, DriveForFiveMembershipViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriveForFiveMembershipViewQuery, DriveForFiveMembershipViewQueryVariables>(DriveForFiveMembershipViewDocument, options);
      }
export function useDriveForFiveMembershipViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriveForFiveMembershipViewQuery, DriveForFiveMembershipViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriveForFiveMembershipViewQuery, DriveForFiveMembershipViewQueryVariables>(DriveForFiveMembershipViewDocument, options);
        }
export type DriveForFiveMembershipViewQueryHookResult = ReturnType<typeof useDriveForFiveMembershipViewQuery>;
export type DriveForFiveMembershipViewLazyQueryHookResult = ReturnType<typeof useDriveForFiveMembershipViewLazyQuery>;
export type DriveForFiveMembershipViewQueryResult = Apollo.QueryResult<DriveForFiveMembershipViewQuery, DriveForFiveMembershipViewQueryVariables>;
export const GrowLinkingAccountViewDocument = gql`
    query GrowLinkingAccountView {
  me {
    growAccount {
      hasAccessLink
      linkedAccount
    }
  }
}
    `;

/**
 * __useGrowLinkingAccountViewQuery__
 *
 * To run a query within a React component, call `useGrowLinkingAccountViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowLinkingAccountViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowLinkingAccountViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGrowLinkingAccountViewQuery(baseOptions?: Apollo.QueryHookOptions<GrowLinkingAccountViewQuery, GrowLinkingAccountViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrowLinkingAccountViewQuery, GrowLinkingAccountViewQueryVariables>(GrowLinkingAccountViewDocument, options);
      }
export function useGrowLinkingAccountViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrowLinkingAccountViewQuery, GrowLinkingAccountViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrowLinkingAccountViewQuery, GrowLinkingAccountViewQueryVariables>(GrowLinkingAccountViewDocument, options);
        }
export type GrowLinkingAccountViewQueryHookResult = ReturnType<typeof useGrowLinkingAccountViewQuery>;
export type GrowLinkingAccountViewLazyQueryHookResult = ReturnType<typeof useGrowLinkingAccountViewLazyQuery>;
export type GrowLinkingAccountViewQueryResult = Apollo.QueryResult<GrowLinkingAccountViewQuery, GrowLinkingAccountViewQueryVariables>;
export const GrowAccountAccessLinkDocument = gql`
    mutation GrowAccountAccessLink($secretPassword: String!) {
  growAccountAccessLink(secretPassword: $secretPassword)
}
    `;

/**
 * __useGrowAccountAccessLinkMutation__
 *
 * To run a mutation, you first call `useGrowAccountAccessLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrowAccountAccessLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [growAccountAccessLinkMutation, { data, loading, error }] = useGrowAccountAccessLinkMutation({
 *   variables: {
 *      secretPassword: // value for 'secretPassword'
 *   },
 * });
 */
export function useGrowAccountAccessLinkMutation(baseOptions?: Apollo.MutationHookOptions<GrowAccountAccessLinkMutation, GrowAccountAccessLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrowAccountAccessLinkMutation, GrowAccountAccessLinkMutationVariables>(GrowAccountAccessLinkDocument, options);
      }
export type GrowAccountAccessLinkMutationHookResult = ReturnType<typeof useGrowAccountAccessLinkMutation>;
export type GrowAccountAccessLinkMutationResult = Apollo.MutationResult<GrowAccountAccessLinkMutation>;
export type GrowAccountAccessLinkMutationOptions = Apollo.BaseMutationOptions<GrowAccountAccessLinkMutation, GrowAccountAccessLinkMutationVariables>;
export const InvoicesListViewDocument = gql`
    query InvoicesListView($offset: Int!, $limit: Int!) {
  me {
    serviceSubscriptionInvoices(pagination: {offset: $offset, limit: $limit}) {
      totalRows
      rows {
        id
        orderNo
        status
        createdDate
        amount
        paymentMethod
        paymentMethodName
        paymentType
        currency {
          sign
          code
        }
        paymentSource {
          info {
            __typename
            ... on PaymentSourceCreditCard {
              last4
            }
          }
        }
        products {
          productNames
        }
      }
    }
  }
}
    `;

/**
 * __useInvoicesListViewQuery__
 *
 * To run a query within a React component, call `useInvoicesListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesListViewQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInvoicesListViewQuery(baseOptions: Apollo.QueryHookOptions<InvoicesListViewQuery, InvoicesListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesListViewQuery, InvoicesListViewQueryVariables>(InvoicesListViewDocument, options);
      }
export function useInvoicesListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesListViewQuery, InvoicesListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesListViewQuery, InvoicesListViewQueryVariables>(InvoicesListViewDocument, options);
        }
export type InvoicesListViewQueryHookResult = ReturnType<typeof useInvoicesListViewQuery>;
export type InvoicesListViewLazyQueryHookResult = ReturnType<typeof useInvoicesListViewLazyQuery>;
export type InvoicesListViewQueryResult = Apollo.QueryResult<InvoicesListViewQuery, InvoicesListViewQueryVariables>;
export const NewsListViewDocument = gql`
    query NewsListView($offset: Int!, $limit: Int!, $filter: String) {
  memberAreaNews(limit: $limit, offset: $offset, filter: $filter) {
    data {
      id
      title
      content
      category
      publishedDate
      createdDate
      isPrivate
      needsConfirmation
      status
    }
    totalRows
  }
}
    `;

/**
 * __useNewsListViewQuery__
 *
 * To run a query within a React component, call `useNewsListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsListViewQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNewsListViewQuery(baseOptions: Apollo.QueryHookOptions<NewsListViewQuery, NewsListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsListViewQuery, NewsListViewQueryVariables>(NewsListViewDocument, options);
      }
export function useNewsListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsListViewQuery, NewsListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsListViewQuery, NewsListViewQueryVariables>(NewsListViewDocument, options);
        }
export type NewsListViewQueryHookResult = ReturnType<typeof useNewsListViewQuery>;
export type NewsListViewLazyQueryHookResult = ReturnType<typeof useNewsListViewLazyQuery>;
export type NewsListViewQueryResult = Apollo.QueryResult<NewsListViewQuery, NewsListViewQueryVariables>;
export const PaymentMethodsViewDocument = gql`
    query PaymentMethodsView {
  getGiftCards {
    id
    code
    active
    amount
    currency {
      code
      sign
    }
    usedBy
    type
  }
  me {
    currency {
      code
    }
    paymentSources {
      id
      hasExpired
      info {
        ... on PaymentSourceShopCredit {
          available
          currency {
            sign
            code
          }
        }
        ... on PaymentSourceScrCredit {
          available
          currency {
            sign
            code
          }
        }
        ... on PaymentSourceCreditCard {
          brand
          type
          expYear
          expMonth
          last4
        }
      }
    }
  }
}
    `;

/**
 * __usePaymentMethodsViewQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsViewQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodsViewQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodsViewQuery, PaymentMethodsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsViewQuery, PaymentMethodsViewQueryVariables>(PaymentMethodsViewDocument, options);
      }
export function usePaymentMethodsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsViewQuery, PaymentMethodsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsViewQuery, PaymentMethodsViewQueryVariables>(PaymentMethodsViewDocument, options);
        }
export type PaymentMethodsViewQueryHookResult = ReturnType<typeof usePaymentMethodsViewQuery>;
export type PaymentMethodsViewLazyQueryHookResult = ReturnType<typeof usePaymentMethodsViewLazyQuery>;
export type PaymentMethodsViewQueryResult = Apollo.QueryResult<PaymentMethodsViewQuery, PaymentMethodsViewQueryVariables>;
export const PaymentMethodsViewRedeemGiftCardDocument = gql`
    mutation PaymentMethodsViewRedeemGiftCard($cardCode: String!) {
  redeemGiftCard(cardCode: $cardCode) {
    code
    amount
    currency {
      code
      sign
    }
  }
}
    `;

/**
 * __usePaymentMethodsViewRedeemGiftCardMutation__
 *
 * To run a mutation, you first call `usePaymentMethodsViewRedeemGiftCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsViewRedeemGiftCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentMethodsViewRedeemGiftCardMutation, { data, loading, error }] = usePaymentMethodsViewRedeemGiftCardMutation({
 *   variables: {
 *      cardCode: // value for 'cardCode'
 *   },
 * });
 */
export function usePaymentMethodsViewRedeemGiftCardMutation(baseOptions?: Apollo.MutationHookOptions<PaymentMethodsViewRedeemGiftCardMutation, PaymentMethodsViewRedeemGiftCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentMethodsViewRedeemGiftCardMutation, PaymentMethodsViewRedeemGiftCardMutationVariables>(PaymentMethodsViewRedeemGiftCardDocument, options);
      }
export type PaymentMethodsViewRedeemGiftCardMutationHookResult = ReturnType<typeof usePaymentMethodsViewRedeemGiftCardMutation>;
export type PaymentMethodsViewRedeemGiftCardMutationResult = Apollo.MutationResult<PaymentMethodsViewRedeemGiftCardMutation>;
export type PaymentMethodsViewRedeemGiftCardMutationOptions = Apollo.BaseMutationOptions<PaymentMethodsViewRedeemGiftCardMutation, PaymentMethodsViewRedeemGiftCardMutationVariables>;
export const ArrangePaymentSourcesDocument = gql`
    mutation ArrangePaymentSources($paymentSourcesIds: [String!]!) {
  arrangePaymentSources(paymentSourcesIds: $paymentSourcesIds) {
    id
    hasExpired
    info {
      __typename
    }
  }
}
    `;

/**
 * __useArrangePaymentSourcesMutation__
 *
 * To run a mutation, you first call `useArrangePaymentSourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArrangePaymentSourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arrangePaymentSourcesMutation, { data, loading, error }] = useArrangePaymentSourcesMutation({
 *   variables: {
 *      paymentSourcesIds: // value for 'paymentSourcesIds'
 *   },
 * });
 */
export function useArrangePaymentSourcesMutation(baseOptions?: Apollo.MutationHookOptions<ArrangePaymentSourcesMutation, ArrangePaymentSourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArrangePaymentSourcesMutation, ArrangePaymentSourcesMutationVariables>(ArrangePaymentSourcesDocument, options);
      }
export type ArrangePaymentSourcesMutationHookResult = ReturnType<typeof useArrangePaymentSourcesMutation>;
export type ArrangePaymentSourcesMutationResult = Apollo.MutationResult<ArrangePaymentSourcesMutation>;
export type ArrangePaymentSourcesMutationOptions = Apollo.BaseMutationOptions<ArrangePaymentSourcesMutation, ArrangePaymentSourcesMutationVariables>;
export const RemovePaymentSourceDocument = gql`
    mutation RemovePaymentSource($paymentSourceId: String!) {
  removePaymentSource(paymentSourceId: $paymentSourceId) {
    id
  }
}
    `;

/**
 * __useRemovePaymentSourceMutation__
 *
 * To run a mutation, you first call `useRemovePaymentSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentSourceMutation, { data, loading, error }] = useRemovePaymentSourceMutation({
 *   variables: {
 *      paymentSourceId: // value for 'paymentSourceId'
 *   },
 * });
 */
export function useRemovePaymentSourceMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentSourceMutation, RemovePaymentSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePaymentSourceMutation, RemovePaymentSourceMutationVariables>(RemovePaymentSourceDocument, options);
      }
export type RemovePaymentSourceMutationHookResult = ReturnType<typeof useRemovePaymentSourceMutation>;
export type RemovePaymentSourceMutationResult = Apollo.MutationResult<RemovePaymentSourceMutation>;
export type RemovePaymentSourceMutationOptions = Apollo.BaseMutationOptions<RemovePaymentSourceMutation, RemovePaymentSourceMutationVariables>;
export const ProfileViewDocument = gql`
    query ProfileView {
  me {
    currency {
      code
    }
  }
  viewer {
    firstName
    lastName
    phone
    email
    address
    city
    state
    postcode
    country
    countryCode
  }
  country {
    countries {
      id
      code
    }
  }
}
    `;

/**
 * __useProfileViewQuery__
 *
 * To run a query within a React component, call `useProfileViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileViewQuery(baseOptions?: Apollo.QueryHookOptions<ProfileViewQuery, ProfileViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileViewQuery, ProfileViewQueryVariables>(ProfileViewDocument, options);
      }
export function useProfileViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileViewQuery, ProfileViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileViewQuery, ProfileViewQueryVariables>(ProfileViewDocument, options);
        }
export type ProfileViewQueryHookResult = ReturnType<typeof useProfileViewQuery>;
export type ProfileViewLazyQueryHookResult = ReturnType<typeof useProfileViewLazyQuery>;
export type ProfileViewQueryResult = Apollo.QueryResult<ProfileViewQuery, ProfileViewQueryVariables>;
export const ProfileViewChangeUserInfoDocument = gql`
    mutation ProfileViewChangeUserInfo($secretPassword: String!, $address: String, $city: String, $state: String, $postcode: String, $phone: String) {
  user {
    update(
      data: {secretPassword: $secretPassword, address: $address, city: $city, state: $state, postcode: $postcode, phone: $phone}
    ) {
      success
      result {
        errors {
          parameter
          message
        }
      }
    }
  }
}
    `;

/**
 * __useProfileViewChangeUserInfoMutation__
 *
 * To run a mutation, you first call `useProfileViewChangeUserInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileViewChangeUserInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileViewChangeUserInfoMutation, { data, loading, error }] = useProfileViewChangeUserInfoMutation({
 *   variables: {
 *      secretPassword: // value for 'secretPassword'
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postcode: // value for 'postcode'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useProfileViewChangeUserInfoMutation(baseOptions?: Apollo.MutationHookOptions<ProfileViewChangeUserInfoMutation, ProfileViewChangeUserInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileViewChangeUserInfoMutation, ProfileViewChangeUserInfoMutationVariables>(ProfileViewChangeUserInfoDocument, options);
      }
export type ProfileViewChangeUserInfoMutationHookResult = ReturnType<typeof useProfileViewChangeUserInfoMutation>;
export type ProfileViewChangeUserInfoMutationResult = Apollo.MutationResult<ProfileViewChangeUserInfoMutation>;
export type ProfileViewChangeUserInfoMutationOptions = Apollo.BaseMutationOptions<ProfileViewChangeUserInfoMutation, ProfileViewChangeUserInfoMutationVariables>;
export const ProfileViewChangePasswordDocument = gql`
    mutation ProfileViewChangePassword($data: PasswordInput!) {
  user {
    changePassword(data: $data) {
      success
      result {
        message {
          message
        }
      }
    }
  }
}
    `;

/**
 * __useProfileViewChangePasswordMutation__
 *
 * To run a mutation, you first call `useProfileViewChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileViewChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileViewChangePasswordMutation, { data, loading, error }] = useProfileViewChangePasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProfileViewChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ProfileViewChangePasswordMutation, ProfileViewChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileViewChangePasswordMutation, ProfileViewChangePasswordMutationVariables>(ProfileViewChangePasswordDocument, options);
      }
export type ProfileViewChangePasswordMutationHookResult = ReturnType<typeof useProfileViewChangePasswordMutation>;
export type ProfileViewChangePasswordMutationResult = Apollo.MutationResult<ProfileViewChangePasswordMutation>;
export type ProfileViewChangePasswordMutationOptions = Apollo.BaseMutationOptions<ProfileViewChangePasswordMutation, ProfileViewChangePasswordMutationVariables>;
export const ForgottenConfirmationPasswordDocument = gql`
    mutation ForgottenConfirmationPassword {
  forgottenConfirmationPassword {
    result {
      type
    }
  }
}
    `;

/**
 * __useForgottenConfirmationPasswordMutation__
 *
 * To run a mutation, you first call `useForgottenConfirmationPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgottenConfirmationPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgottenConfirmationPasswordMutation, { data, loading, error }] = useForgottenConfirmationPasswordMutation({
 *   variables: {
 *   },
 * });
 */
export function useForgottenConfirmationPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgottenConfirmationPasswordMutation, ForgottenConfirmationPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgottenConfirmationPasswordMutation, ForgottenConfirmationPasswordMutationVariables>(ForgottenConfirmationPasswordDocument, options);
      }
export type ForgottenConfirmationPasswordMutationHookResult = ReturnType<typeof useForgottenConfirmationPasswordMutation>;
export type ForgottenConfirmationPasswordMutationResult = Apollo.MutationResult<ForgottenConfirmationPasswordMutation>;
export type ForgottenConfirmationPasswordMutationOptions = Apollo.BaseMutationOptions<ForgottenConfirmationPasswordMutation, ForgottenConfirmationPasswordMutationVariables>;
export const ChangeConfirmationPasswordDocument = gql`
    mutation ChangeConfirmationPassword($data: ForgottenPasswordInput!) {
  changeConfirmationPassword(data: $data) {
    success
    result {
      type
    }
  }
}
    `;

/**
 * __useChangeConfirmationPasswordMutation__
 *
 * To run a mutation, you first call `useChangeConfirmationPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeConfirmationPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeConfirmationPasswordMutation, { data, loading, error }] = useChangeConfirmationPasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChangeConfirmationPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeConfirmationPasswordMutation, ChangeConfirmationPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeConfirmationPasswordMutation, ChangeConfirmationPasswordMutationVariables>(ChangeConfirmationPasswordDocument, options);
      }
export type ChangeConfirmationPasswordMutationHookResult = ReturnType<typeof useChangeConfirmationPasswordMutation>;
export type ChangeConfirmationPasswordMutationResult = Apollo.MutationResult<ChangeConfirmationPasswordMutation>;
export type ChangeConfirmationPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeConfirmationPasswordMutation, ChangeConfirmationPasswordMutationVariables>;
export const SubscriptionsListViewDocument = gql`
    query SubscriptionsListView {
  me {
    serviceSubscriptions {
      id
      isLegacy
      productCodes
      periodCode
      dateStart
      dateEnd
      billingDate
      status
      isDiscontinuable
      isLegacy
      upgradeOffers {
        id
        products {
          code
          name
        }
        period {
          code
          name
        }
        fullPrice
        discount
        discountedPrice
        currency {
          code
          sign
        }
        labelText
      }
      products {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useSubscriptionsListViewQuery__
 *
 * To run a query within a React component, call `useSubscriptionsListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsListViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsListViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionsListViewQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionsListViewQuery, SubscriptionsListViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionsListViewQuery, SubscriptionsListViewQueryVariables>(SubscriptionsListViewDocument, options);
      }
export function useSubscriptionsListViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionsListViewQuery, SubscriptionsListViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionsListViewQuery, SubscriptionsListViewQueryVariables>(SubscriptionsListViewDocument, options);
        }
export type SubscriptionsListViewQueryHookResult = ReturnType<typeof useSubscriptionsListViewQuery>;
export type SubscriptionsListViewLazyQueryHookResult = ReturnType<typeof useSubscriptionsListViewLazyQuery>;
export type SubscriptionsListViewQueryResult = Apollo.QueryResult<SubscriptionsListViewQuery, SubscriptionsListViewQueryVariables>;
export const DiscontinueServiceSubscriptionDocument = gql`
    mutation DiscontinueServiceSubscription($subscriptionId: String!) {
  discontinueServiceSubscription(subscriptionId: $subscriptionId)
}
    `;

/**
 * __useDiscontinueServiceSubscriptionMutation__
 *
 * To run a mutation, you first call `useDiscontinueServiceSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscontinueServiceSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discontinueServiceSubscriptionMutation, { data, loading, error }] = useDiscontinueServiceSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useDiscontinueServiceSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<DiscontinueServiceSubscriptionMutation, DiscontinueServiceSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DiscontinueServiceSubscriptionMutation, DiscontinueServiceSubscriptionMutationVariables>(DiscontinueServiceSubscriptionDocument, options);
      }
export type DiscontinueServiceSubscriptionMutationHookResult = ReturnType<typeof useDiscontinueServiceSubscriptionMutation>;
export type DiscontinueServiceSubscriptionMutationResult = Apollo.MutationResult<DiscontinueServiceSubscriptionMutation>;
export type DiscontinueServiceSubscriptionMutationOptions = Apollo.BaseMutationOptions<DiscontinueServiceSubscriptionMutation, DiscontinueServiceSubscriptionMutationVariables>;
export const ContinueServiceSubscriptionDocument = gql`
    mutation ContinueServiceSubscription($subscriptionId: String!) {
  continueServiceSubscription(subscriptionId: $subscriptionId)
}
    `;

/**
 * __useContinueServiceSubscriptionMutation__
 *
 * To run a mutation, you first call `useContinueServiceSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueServiceSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueServiceSubscriptionMutation, { data, loading, error }] = useContinueServiceSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useContinueServiceSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ContinueServiceSubscriptionMutation, ContinueServiceSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContinueServiceSubscriptionMutation, ContinueServiceSubscriptionMutationVariables>(ContinueServiceSubscriptionDocument, options);
      }
export type ContinueServiceSubscriptionMutationHookResult = ReturnType<typeof useContinueServiceSubscriptionMutation>;
export type ContinueServiceSubscriptionMutationResult = Apollo.MutationResult<ContinueServiceSubscriptionMutation>;
export type ContinueServiceSubscriptionMutationOptions = Apollo.BaseMutationOptions<ContinueServiceSubscriptionMutation, ContinueServiceSubscriptionMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($subscriptionId: Int!) {
  cancelSubscription(subscriptionId: $subscriptionId)
}
    `;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const UpgradeServiceSubscriptionDocument = gql`
    mutation UpgradeServiceSubscription($subscriptionId: String!, $offerId: String!, $paymentMethod: PaymentMethod!) {
  upgradeServiceSubscription(subscriptionId: $subscriptionId, offerId: $offerId) {
    ...EditSubscriptionUpgradeOfferParts
  }
}
    ${EditSubscriptionUpgradeOfferPartsFragmentDoc}`;

/**
 * __useUpgradeServiceSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeServiceSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeServiceSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeServiceSubscriptionMutation, { data, loading, error }] = useUpgradeServiceSubscriptionMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      offerId: // value for 'offerId'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useUpgradeServiceSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeServiceSubscriptionMutation, UpgradeServiceSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeServiceSubscriptionMutation, UpgradeServiceSubscriptionMutationVariables>(UpgradeServiceSubscriptionDocument, options);
      }
export type UpgradeServiceSubscriptionMutationHookResult = ReturnType<typeof useUpgradeServiceSubscriptionMutation>;
export type UpgradeServiceSubscriptionMutationResult = Apollo.MutationResult<UpgradeServiceSubscriptionMutation>;
export type UpgradeServiceSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpgradeServiceSubscriptionMutation, UpgradeServiceSubscriptionMutationVariables>;
export const EditSubscriptionUpgradeOfferDocument = gql`
    query EditSubscriptionUpgradeOffer($id: String!, $paymentMethod: PaymentMethod!) {
  me {
    serviceSubscriptionUpgrade(upgradeId: $id) {
      ...EditSubscriptionUpgradeOfferParts
    }
  }
}
    ${EditSubscriptionUpgradeOfferPartsFragmentDoc}`;

/**
 * __useEditSubscriptionUpgradeOfferQuery__
 *
 * To run a query within a React component, call `useEditSubscriptionUpgradeOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSubscriptionUpgradeOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSubscriptionUpgradeOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useEditSubscriptionUpgradeOfferQuery(baseOptions: Apollo.QueryHookOptions<EditSubscriptionUpgradeOfferQuery, EditSubscriptionUpgradeOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditSubscriptionUpgradeOfferQuery, EditSubscriptionUpgradeOfferQueryVariables>(EditSubscriptionUpgradeOfferDocument, options);
      }
export function useEditSubscriptionUpgradeOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditSubscriptionUpgradeOfferQuery, EditSubscriptionUpgradeOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditSubscriptionUpgradeOfferQuery, EditSubscriptionUpgradeOfferQueryVariables>(EditSubscriptionUpgradeOfferDocument, options);
        }
export type EditSubscriptionUpgradeOfferQueryHookResult = ReturnType<typeof useEditSubscriptionUpgradeOfferQuery>;
export type EditSubscriptionUpgradeOfferLazyQueryHookResult = ReturnType<typeof useEditSubscriptionUpgradeOfferLazyQuery>;
export type EditSubscriptionUpgradeOfferQueryResult = Apollo.QueryResult<EditSubscriptionUpgradeOfferQuery, EditSubscriptionUpgradeOfferQueryVariables>;
export const BusinessTrainingViewDocument = gql`
    query BusinessTrainingView {
  me {
    activeServiceProductCodes
    info {
      isAffiliate
    }
  }
}
    `;

/**
 * __useBusinessTrainingViewQuery__
 *
 * To run a query within a React component, call `useBusinessTrainingViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessTrainingViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessTrainingViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessTrainingViewQuery(baseOptions?: Apollo.QueryHookOptions<BusinessTrainingViewQuery, BusinessTrainingViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessTrainingViewQuery, BusinessTrainingViewQueryVariables>(BusinessTrainingViewDocument, options);
      }
export function useBusinessTrainingViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessTrainingViewQuery, BusinessTrainingViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessTrainingViewQuery, BusinessTrainingViewQueryVariables>(BusinessTrainingViewDocument, options);
        }
export type BusinessTrainingViewQueryHookResult = ReturnType<typeof useBusinessTrainingViewQuery>;
export type BusinessTrainingViewLazyQueryHookResult = ReturnType<typeof useBusinessTrainingViewLazyQuery>;
export type BusinessTrainingViewQueryResult = Apollo.QueryResult<BusinessTrainingViewQuery, BusinessTrainingViewQueryVariables>;
export const BusinessTrainingMenuViewDocument = gql`
    query BusinessTrainingMenuView {
  me {
    currency {
      code
    }
  }
}
    `;

/**
 * __useBusinessTrainingMenuViewQuery__
 *
 * To run a query within a React component, call `useBusinessTrainingMenuViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessTrainingMenuViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessTrainingMenuViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessTrainingMenuViewQuery(baseOptions?: Apollo.QueryHookOptions<BusinessTrainingMenuViewQuery, BusinessTrainingMenuViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessTrainingMenuViewQuery, BusinessTrainingMenuViewQueryVariables>(BusinessTrainingMenuViewDocument, options);
      }
export function useBusinessTrainingMenuViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessTrainingMenuViewQuery, BusinessTrainingMenuViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessTrainingMenuViewQuery, BusinessTrainingMenuViewQueryVariables>(BusinessTrainingMenuViewDocument, options);
        }
export type BusinessTrainingMenuViewQueryHookResult = ReturnType<typeof useBusinessTrainingMenuViewQuery>;
export type BusinessTrainingMenuViewLazyQueryHookResult = ReturnType<typeof useBusinessTrainingMenuViewLazyQuery>;
export type BusinessTrainingMenuViewQueryResult = Apollo.QueryResult<BusinessTrainingMenuViewQuery, BusinessTrainingMenuViewQueryVariables>;
export const BankCodeSectionDocument = gql`
    query BankCodeSection {
  me {
    codebreakerAccess {
      kickStarterUrl
    }
  }
}
    `;

/**
 * __useBankCodeSectionQuery__
 *
 * To run a query within a React component, call `useBankCodeSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankCodeSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankCodeSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankCodeSectionQuery(baseOptions?: Apollo.QueryHookOptions<BankCodeSectionQuery, BankCodeSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankCodeSectionQuery, BankCodeSectionQueryVariables>(BankCodeSectionDocument, options);
      }
export function useBankCodeSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankCodeSectionQuery, BankCodeSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankCodeSectionQuery, BankCodeSectionQueryVariables>(BankCodeSectionDocument, options);
        }
export type BankCodeSectionQueryHookResult = ReturnType<typeof useBankCodeSectionQuery>;
export type BankCodeSectionLazyQueryHookResult = ReturnType<typeof useBankCodeSectionLazyQuery>;
export type BankCodeSectionQueryResult = Apollo.QueryResult<BankCodeSectionQuery, BankCodeSectionQueryVariables>;
export const ChapterViewDocument = gql`
    query ChapterView {
  me {
    currency {
      code
    }
  }
}
    `;

/**
 * __useChapterViewQuery__
 *
 * To run a query within a React component, call `useChapterViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useChapterViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChapterViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useChapterViewQuery(baseOptions?: Apollo.QueryHookOptions<ChapterViewQuery, ChapterViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChapterViewQuery, ChapterViewQueryVariables>(ChapterViewDocument, options);
      }
export function useChapterViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChapterViewQuery, ChapterViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChapterViewQuery, ChapterViewQueryVariables>(ChapterViewDocument, options);
        }
export type ChapterViewQueryHookResult = ReturnType<typeof useChapterViewQuery>;
export type ChapterViewLazyQueryHookResult = ReturnType<typeof useChapterViewLazyQuery>;
export type ChapterViewQueryResult = Apollo.QueryResult<ChapterViewQuery, ChapterViewQueryVariables>;
export const CartUpSellViewDocument = gql`
    query CartUpSellView($paymentMethod: PaymentMethod!) {
  me {
    activeServiceProductCodes
    personalServiceOffers {
      __typename
      ... on ServiceSubscriptionUpgrade {
        id
        difference
        differenceTotal(method: $paymentMethod)
        differenceFee(method: $paymentMethod)
        differenceTax(method: $paymentMethod)
        currency {
          code
        }
        offer {
          ...CartUpSellViewOfferFragment
        }
      }
      ... on ServiceCart {
        id
        totalPrice(method: $paymentMethod)
        totalPriceWithoutTax(method: $paymentMethod)
        totalDiscount(method: $paymentMethod)
        totalFee(method: $paymentMethod)
        totalTax(method: $paymentMethod)
        maybeCurrency: currency {
          code
        }
        offers {
          ...CartUpSellViewOfferFragment
        }
      }
    }
  }
}
    ${CartUpSellViewOfferFragmentFragmentDoc}`;

/**
 * __useCartUpSellViewQuery__
 *
 * To run a query within a React component, call `useCartUpSellViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartUpSellViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartUpSellViewQuery({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useCartUpSellViewQuery(baseOptions: Apollo.QueryHookOptions<CartUpSellViewQuery, CartUpSellViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartUpSellViewQuery, CartUpSellViewQueryVariables>(CartUpSellViewDocument, options);
      }
export function useCartUpSellViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartUpSellViewQuery, CartUpSellViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartUpSellViewQuery, CartUpSellViewQueryVariables>(CartUpSellViewDocument, options);
        }
export type CartUpSellViewQueryHookResult = ReturnType<typeof useCartUpSellViewQuery>;
export type CartUpSellViewLazyQueryHookResult = ReturnType<typeof useCartUpSellViewLazyQuery>;
export type CartUpSellViewQueryResult = Apollo.QueryResult<CartUpSellViewQuery, CartUpSellViewQueryVariables>;
export const CartUpSellViewRejectPersonalOffersDocument = gql`
    mutation CartUpSellViewRejectPersonalOffers {
  rejectPersonalOffers
}
    `;

/**
 * __useCartUpSellViewRejectPersonalOffersMutation__
 *
 * To run a mutation, you first call `useCartUpSellViewRejectPersonalOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartUpSellViewRejectPersonalOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartUpSellViewRejectPersonalOffersMutation, { data, loading, error }] = useCartUpSellViewRejectPersonalOffersMutation({
 *   variables: {
 *   },
 * });
 */
export function useCartUpSellViewRejectPersonalOffersMutation(baseOptions?: Apollo.MutationHookOptions<CartUpSellViewRejectPersonalOffersMutation, CartUpSellViewRejectPersonalOffersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartUpSellViewRejectPersonalOffersMutation, CartUpSellViewRejectPersonalOffersMutationVariables>(CartUpSellViewRejectPersonalOffersDocument, options);
      }
export type CartUpSellViewRejectPersonalOffersMutationHookResult = ReturnType<typeof useCartUpSellViewRejectPersonalOffersMutation>;
export type CartUpSellViewRejectPersonalOffersMutationResult = Apollo.MutationResult<CartUpSellViewRejectPersonalOffersMutation>;
export type CartUpSellViewRejectPersonalOffersMutationOptions = Apollo.BaseMutationOptions<CartUpSellViewRejectPersonalOffersMutation, CartUpSellViewRejectPersonalOffersMutationVariables>;
export const CartViewDocument = gql`
    query CartView($periodCode: ServicePeriodCode!, $paymentMethod: PaymentMethod!) {
  me {
    serviceCart {
      id
      totalPrice(method: $paymentMethod)
      comboDiscount(method: $paymentMethod)
      totalFee(method: $paymentMethod)
      totalTax(method: $paymentMethod)
      totalShipping
      totalScr
      taxCountryId
      finalizationHash
      currency {
        code
      }
      discountApplied {
        ...CartViewDiscountParts
      }
      items {
        id
        period {
          code
          name
        }
        quantity
        product {
          code
          name
          label
          offers {
            id
            discountedPrice
            discountedPriceNext
            fullPrice
            fullPriceNext
            maxScrAmount
            labelText
            period {
              code
            }
            currency {
              code
            }
          }
          isQuantifiable
        }
      }
    }
    serviceOfferRecommendations {
      id
      availability
      upgradableSubscriptions {
        id
      }
      fullPrice
      fullPriceNext
      discountedPrice
      discountedPriceNext
      currency {
        code
      }
      products {
        name
        code
      }
      period {
        code
      }
    }
  }
  viewer {
    id
    isActive
    shopCreditBalance
  }
  forex: serviceOffer(periodCode: $periodCode, productCodes: [FOREX]) {
    id
    fullPrice
    discountedPrice
    currency {
      code
    }
  }
  bankFull: serviceOffer(periodCode: $periodCode, productCodes: [BANK_FULL]) {
    id
    fullPrice
    discountedPrice
    currency {
      code
    }
  }
}
    ${CartViewDiscountPartsFragmentDoc}`;

/**
 * __useCartViewQuery__
 *
 * To run a query within a React component, call `useCartViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartViewQuery({
 *   variables: {
 *      periodCode: // value for 'periodCode'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useCartViewQuery(baseOptions: Apollo.QueryHookOptions<CartViewQuery, CartViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartViewQuery, CartViewQueryVariables>(CartViewDocument, options);
      }
export function useCartViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartViewQuery, CartViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartViewQuery, CartViewQueryVariables>(CartViewDocument, options);
        }
export type CartViewQueryHookResult = ReturnType<typeof useCartViewQuery>;
export type CartViewLazyQueryHookResult = ReturnType<typeof useCartViewLazyQuery>;
export type CartViewQueryResult = Apollo.QueryResult<CartViewQuery, CartViewQueryVariables>;
export const CartViewRemoveItemDocument = gql`
    mutation CartViewRemoveItem($productCode: ServiceProductCode!) {
  removeServiceCartItem(productCode: $productCode)
}
    `;

/**
 * __useCartViewRemoveItemMutation__
 *
 * To run a mutation, you first call `useCartViewRemoveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartViewRemoveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartViewRemoveItemMutation, { data, loading, error }] = useCartViewRemoveItemMutation({
 *   variables: {
 *      productCode: // value for 'productCode'
 *   },
 * });
 */
export function useCartViewRemoveItemMutation(baseOptions?: Apollo.MutationHookOptions<CartViewRemoveItemMutation, CartViewRemoveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartViewRemoveItemMutation, CartViewRemoveItemMutationVariables>(CartViewRemoveItemDocument, options);
      }
export type CartViewRemoveItemMutationHookResult = ReturnType<typeof useCartViewRemoveItemMutation>;
export type CartViewRemoveItemMutationResult = Apollo.MutationResult<CartViewRemoveItemMutation>;
export type CartViewRemoveItemMutationOptions = Apollo.BaseMutationOptions<CartViewRemoveItemMutation, CartViewRemoveItemMutationVariables>;
export const CartViewUpdateItemPeriodDocument = gql`
    mutation CartViewUpdateItemPeriod($productCode: ServiceProductCode!, $periodCode: ServicePeriodCode!) {
  updateServiceCartItemPeriod(productCode: $productCode, periodCode: $periodCode)
}
    `;

/**
 * __useCartViewUpdateItemPeriodMutation__
 *
 * To run a mutation, you first call `useCartViewUpdateItemPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartViewUpdateItemPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartViewUpdateItemPeriodMutation, { data, loading, error }] = useCartViewUpdateItemPeriodMutation({
 *   variables: {
 *      productCode: // value for 'productCode'
 *      periodCode: // value for 'periodCode'
 *   },
 * });
 */
export function useCartViewUpdateItemPeriodMutation(baseOptions?: Apollo.MutationHookOptions<CartViewUpdateItemPeriodMutation, CartViewUpdateItemPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartViewUpdateItemPeriodMutation, CartViewUpdateItemPeriodMutationVariables>(CartViewUpdateItemPeriodDocument, options);
      }
export type CartViewUpdateItemPeriodMutationHookResult = ReturnType<typeof useCartViewUpdateItemPeriodMutation>;
export type CartViewUpdateItemPeriodMutationResult = Apollo.MutationResult<CartViewUpdateItemPeriodMutation>;
export type CartViewUpdateItemPeriodMutationOptions = Apollo.BaseMutationOptions<CartViewUpdateItemPeriodMutation, CartViewUpdateItemPeriodMutationVariables>;
export const CartViewFinalizeCartDocument = gql`
    mutation CartViewFinalizeCart($finalizationHash: String!, $paymentMethod: PaymentMethod!) {
  finalizeCart(finalizationHash: $finalizationHash) {
    id
    totalPrice(method: $paymentMethod)
    currency {
      code
    }
  }
}
    `;

/**
 * __useCartViewFinalizeCartMutation__
 *
 * To run a mutation, you first call `useCartViewFinalizeCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartViewFinalizeCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartViewFinalizeCartMutation, { data, loading, error }] = useCartViewFinalizeCartMutation({
 *   variables: {
 *      finalizationHash: // value for 'finalizationHash'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useCartViewFinalizeCartMutation(baseOptions?: Apollo.MutationHookOptions<CartViewFinalizeCartMutation, CartViewFinalizeCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartViewFinalizeCartMutation, CartViewFinalizeCartMutationVariables>(CartViewFinalizeCartDocument, options);
      }
export type CartViewFinalizeCartMutationHookResult = ReturnType<typeof useCartViewFinalizeCartMutation>;
export type CartViewFinalizeCartMutationResult = Apollo.MutationResult<CartViewFinalizeCartMutation>;
export type CartViewFinalizeCartMutationOptions = Apollo.BaseMutationOptions<CartViewFinalizeCartMutation, CartViewFinalizeCartMutationVariables>;
export const CartViewCloneCartDocument = gql`
    mutation CartViewCloneCart($cartId: String!) {
  cloneInactiveServiceCart(cartId: $cartId) {
    id
  }
}
    `;

/**
 * __useCartViewCloneCartMutation__
 *
 * To run a mutation, you first call `useCartViewCloneCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartViewCloneCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartViewCloneCartMutation, { data, loading, error }] = useCartViewCloneCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCartViewCloneCartMutation(baseOptions?: Apollo.MutationHookOptions<CartViewCloneCartMutation, CartViewCloneCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartViewCloneCartMutation, CartViewCloneCartMutationVariables>(CartViewCloneCartDocument, options);
      }
export type CartViewCloneCartMutationHookResult = ReturnType<typeof useCartViewCloneCartMutation>;
export type CartViewCloneCartMutationResult = Apollo.MutationResult<CartViewCloneCartMutation>;
export type CartViewCloneCartMutationOptions = Apollo.BaseMutationOptions<CartViewCloneCartMutation, CartViewCloneCartMutationVariables>;
export const UpdateServiceCartItemQuantityDocument = gql`
    mutation UpdateServiceCartItemQuantity($productCode: ServiceProductCode!, $quantity: Int!) {
  updateServiceCartItemQuantity(productCode: $productCode, quantity: $quantity)
}
    `;

/**
 * __useUpdateServiceCartItemQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateServiceCartItemQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceCartItemQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceCartItemQuantityMutation, { data, loading, error }] = useUpdateServiceCartItemQuantityMutation({
 *   variables: {
 *      productCode: // value for 'productCode'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateServiceCartItemQuantityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceCartItemQuantityMutation, UpdateServiceCartItemQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceCartItemQuantityMutation, UpdateServiceCartItemQuantityMutationVariables>(UpdateServiceCartItemQuantityDocument, options);
      }
export type UpdateServiceCartItemQuantityMutationHookResult = ReturnType<typeof useUpdateServiceCartItemQuantityMutation>;
export type UpdateServiceCartItemQuantityMutationResult = Apollo.MutationResult<UpdateServiceCartItemQuantityMutation>;
export type UpdateServiceCartItemQuantityMutationOptions = Apollo.BaseMutationOptions<UpdateServiceCartItemQuantityMutation, UpdateServiceCartItemQuantityMutationVariables>;
export const CartViewApplyServiceCartDiscountCodeDocument = gql`
    mutation CartViewApplyServiceCartDiscountCode($code: String!) {
  applyServiceCartDiscountCode(code: $code) {
    ...CartViewDiscountParts
  }
}
    ${CartViewDiscountPartsFragmentDoc}`;

/**
 * __useCartViewApplyServiceCartDiscountCodeMutation__
 *
 * To run a mutation, you first call `useCartViewApplyServiceCartDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartViewApplyServiceCartDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartViewApplyServiceCartDiscountCodeMutation, { data, loading, error }] = useCartViewApplyServiceCartDiscountCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCartViewApplyServiceCartDiscountCodeMutation(baseOptions?: Apollo.MutationHookOptions<CartViewApplyServiceCartDiscountCodeMutation, CartViewApplyServiceCartDiscountCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartViewApplyServiceCartDiscountCodeMutation, CartViewApplyServiceCartDiscountCodeMutationVariables>(CartViewApplyServiceCartDiscountCodeDocument, options);
      }
export type CartViewApplyServiceCartDiscountCodeMutationHookResult = ReturnType<typeof useCartViewApplyServiceCartDiscountCodeMutation>;
export type CartViewApplyServiceCartDiscountCodeMutationResult = Apollo.MutationResult<CartViewApplyServiceCartDiscountCodeMutation>;
export type CartViewApplyServiceCartDiscountCodeMutationOptions = Apollo.BaseMutationOptions<CartViewApplyServiceCartDiscountCodeMutation, CartViewApplyServiceCartDiscountCodeMutationVariables>;
export const CartViewClearServiceCartDiscountCodeDocument = gql`
    mutation CartViewClearServiceCartDiscountCode {
  clearServiceCartDiscountCode
}
    `;

/**
 * __useCartViewClearServiceCartDiscountCodeMutation__
 *
 * To run a mutation, you first call `useCartViewClearServiceCartDiscountCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartViewClearServiceCartDiscountCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartViewClearServiceCartDiscountCodeMutation, { data, loading, error }] = useCartViewClearServiceCartDiscountCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCartViewClearServiceCartDiscountCodeMutation(baseOptions?: Apollo.MutationHookOptions<CartViewClearServiceCartDiscountCodeMutation, CartViewClearServiceCartDiscountCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartViewClearServiceCartDiscountCodeMutation, CartViewClearServiceCartDiscountCodeMutationVariables>(CartViewClearServiceCartDiscountCodeDocument, options);
      }
export type CartViewClearServiceCartDiscountCodeMutationHookResult = ReturnType<typeof useCartViewClearServiceCartDiscountCodeMutation>;
export type CartViewClearServiceCartDiscountCodeMutationResult = Apollo.MutationResult<CartViewClearServiceCartDiscountCodeMutation>;
export type CartViewClearServiceCartDiscountCodeMutationOptions = Apollo.BaseMutationOptions<CartViewClearServiceCartDiscountCodeMutation, CartViewClearServiceCartDiscountCodeMutationVariables>;
export const ContactViewDocument = gql`
    query ContactView {
  me {
    currency {
      code
    }
  }
}
    `;

/**
 * __useContactViewQuery__
 *
 * To run a query within a React component, call `useContactViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactViewQuery(baseOptions?: Apollo.QueryHookOptions<ContactViewQuery, ContactViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactViewQuery, ContactViewQueryVariables>(ContactViewDocument, options);
      }
export function useContactViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactViewQuery, ContactViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactViewQuery, ContactViewQueryVariables>(ContactViewDocument, options);
        }
export type ContactViewQueryHookResult = ReturnType<typeof useContactViewQuery>;
export type ContactViewLazyQueryHookResult = ReturnType<typeof useContactViewLazyQuery>;
export type ContactViewQueryResult = Apollo.QueryResult<ContactViewQuery, ContactViewQueryVariables>;
export const ActivateEmailByHashDocument = gql`
    mutation ActivateEmailByHash($hash: String!) {
  activateEmailByHash(hash: $hash)
}
    `;

/**
 * __useActivateEmailByHashMutation__
 *
 * To run a mutation, you first call `useActivateEmailByHashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateEmailByHashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateEmailByHashMutation, { data, loading, error }] = useActivateEmailByHashMutation({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useActivateEmailByHashMutation(baseOptions?: Apollo.MutationHookOptions<ActivateEmailByHashMutation, ActivateEmailByHashMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateEmailByHashMutation, ActivateEmailByHashMutationVariables>(ActivateEmailByHashDocument, options);
      }
export type ActivateEmailByHashMutationHookResult = ReturnType<typeof useActivateEmailByHashMutation>;
export type ActivateEmailByHashMutationResult = Apollo.MutationResult<ActivateEmailByHashMutation>;
export type ActivateEmailByHashMutationOptions = Apollo.BaseMutationOptions<ActivateEmailByHashMutation, ActivateEmailByHashMutationVariables>;
export const CreateEmailChangeDocument = gql`
    mutation CreateEmailChange($email: String!, $repeatEmail: String!, $password: String!) {
  createEmailChange(email: $email, repeatEmail: $repeatEmail, password: $password)
}
    `;

/**
 * __useCreateEmailChangeMutation__
 *
 * To run a mutation, you first call `useCreateEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailChangeMutation, { data, loading, error }] = useCreateEmailChangeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      repeatEmail: // value for 'repeatEmail'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateEmailChangeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailChangeMutation, CreateEmailChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailChangeMutation, CreateEmailChangeMutationVariables>(CreateEmailChangeDocument, options);
      }
export type CreateEmailChangeMutationHookResult = ReturnType<typeof useCreateEmailChangeMutation>;
export type CreateEmailChangeMutationResult = Apollo.MutationResult<CreateEmailChangeMutation>;
export type CreateEmailChangeMutationOptions = Apollo.BaseMutationOptions<CreateEmailChangeMutation, CreateEmailChangeMutationVariables>;
export const ForgottenLoginMutationDocument = gql`
    mutation ForgottenLoginMutation($data: ForgottenLoginInput!) {
  forgottenLogin(data: $data) {
    result {
      type
    }
  }
}
    `;

/**
 * __useForgottenLoginMutationMutation__
 *
 * To run a mutation, you first call `useForgottenLoginMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgottenLoginMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgottenLoginMutationMutation, { data, loading, error }] = useForgottenLoginMutationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useForgottenLoginMutationMutation(baseOptions?: Apollo.MutationHookOptions<ForgottenLoginMutationMutation, ForgottenLoginMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgottenLoginMutationMutation, ForgottenLoginMutationMutationVariables>(ForgottenLoginMutationDocument, options);
      }
export type ForgottenLoginMutationMutationHookResult = ReturnType<typeof useForgottenLoginMutationMutation>;
export type ForgottenLoginMutationMutationResult = Apollo.MutationResult<ForgottenLoginMutationMutation>;
export type ForgottenLoginMutationMutationOptions = Apollo.BaseMutationOptions<ForgottenLoginMutationMutation, ForgottenLoginMutationMutationVariables>;
export const GiftCardViewDocument = gql`
    query GiftCardView {
  viewer {
    verifyStatus
  }
  me {
    currency {
      code
    }
    giftCardLimits {
      minimum {
        amount
      }
      maximum {
        amount
      }
    }
  }
}
    `;

/**
 * __useGiftCardViewQuery__
 *
 * To run a query within a React component, call `useGiftCardViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGiftCardViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGiftCardViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGiftCardViewQuery(baseOptions?: Apollo.QueryHookOptions<GiftCardViewQuery, GiftCardViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GiftCardViewQuery, GiftCardViewQueryVariables>(GiftCardViewDocument, options);
      }
export function useGiftCardViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GiftCardViewQuery, GiftCardViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GiftCardViewQuery, GiftCardViewQueryVariables>(GiftCardViewDocument, options);
        }
export type GiftCardViewQueryHookResult = ReturnType<typeof useGiftCardViewQuery>;
export type GiftCardViewLazyQueryHookResult = ReturnType<typeof useGiftCardViewLazyQuery>;
export type GiftCardViewQueryResult = Apollo.QueryResult<GiftCardViewQuery, GiftCardViewQueryVariables>;
export const HomeViewDocument = gql`
    query HomeView {
  awentures: serviceOffer(periodCode: TWELVE_MONTHS, productCodes: [AWENTURES]) {
    ...HomeViewOfferParts
  }
  awentureService: services(productCodes: [AWENTURES]) {
    code
    name
    offers {
      id
      availability
      currency {
        code
      }
      fullPrice
      discountedPrice
    }
  }
  me {
    codebreakerAccess {
      bankBasicUrl
      bankFullUrl
    }
    currency {
      code
    }
    hunterSystemsAccess {
      url
      accessUrl
      description
    }
    theiaAccess
    awenturesAccess
    consents {
      code
      isForAffiliates
      isForCustomers
      required
      granted
    }
  }
}
    ${HomeViewOfferPartsFragmentDoc}`;

/**
 * __useHomeViewQuery__
 *
 * To run a query within a React component, call `useHomeViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeViewQuery(baseOptions?: Apollo.QueryHookOptions<HomeViewQuery, HomeViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeViewQuery, HomeViewQueryVariables>(HomeViewDocument, options);
      }
export function useHomeViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeViewQuery, HomeViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeViewQuery, HomeViewQueryVariables>(HomeViewDocument, options);
        }
export type HomeViewQueryHookResult = ReturnType<typeof useHomeViewQuery>;
export type HomeViewLazyQueryHookResult = ReturnType<typeof useHomeViewLazyQuery>;
export type HomeViewQueryResult = Apollo.QueryResult<HomeViewQuery, HomeViewQueryVariables>;
export const LoginViewLoginMutationDocument = gql`
    mutation LoginViewLoginMutation($credentials: CredentialsInput) {
  login(credentials: $credentials) {
    result {
      type
    }
  }
}
    `;

/**
 * __useLoginViewLoginMutationMutation__
 *
 * To run a mutation, you first call `useLoginViewLoginMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginViewLoginMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginViewLoginMutationMutation, { data, loading, error }] = useLoginViewLoginMutationMutation({
 *   variables: {
 *      credentials: // value for 'credentials'
 *   },
 * });
 */
export function useLoginViewLoginMutationMutation(baseOptions?: Apollo.MutationHookOptions<LoginViewLoginMutationMutation, LoginViewLoginMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginViewLoginMutationMutation, LoginViewLoginMutationMutationVariables>(LoginViewLoginMutationDocument, options);
      }
export type LoginViewLoginMutationMutationHookResult = ReturnType<typeof useLoginViewLoginMutationMutation>;
export type LoginViewLoginMutationMutationResult = Apollo.MutationResult<LoginViewLoginMutationMutation>;
export type LoginViewLoginMutationMutationOptions = Apollo.BaseMutationOptions<LoginViewLoginMutationMutation, LoginViewLoginMutationMutationVariables>;
export const LogoutViewLogoutMutationDocument = gql`
    mutation LogoutViewLogoutMutation {
  logout
}
    `;

/**
 * __useLogoutViewLogoutMutationMutation__
 *
 * To run a mutation, you first call `useLogoutViewLogoutMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutViewLogoutMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutViewLogoutMutationMutation, { data, loading, error }] = useLogoutViewLogoutMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutViewLogoutMutationMutation(baseOptions?: Apollo.MutationHookOptions<LogoutViewLogoutMutationMutation, LogoutViewLogoutMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutViewLogoutMutationMutation, LogoutViewLogoutMutationMutationVariables>(LogoutViewLogoutMutationDocument, options);
      }
export type LogoutViewLogoutMutationMutationHookResult = ReturnType<typeof useLogoutViewLogoutMutationMutation>;
export type LogoutViewLogoutMutationMutationResult = Apollo.MutationResult<LogoutViewLogoutMutationMutation>;
export type LogoutViewLogoutMutationMutationOptions = Apollo.BaseMutationOptions<LogoutViewLogoutMutationMutation, LogoutViewLogoutMutationMutationVariables>;
export const RegisterLooreUserDocument = gql`
    mutation RegisterLooreUser($email: String!, $password: String!, $firstName: String!, $lastName: String!, $dateOfBirth: String!, $countryId: Int!, $state: String, $city: String, $postcode: String, $address: String, $termsAndConditions: Boolean!, $username: String!) {
  registerLooreUser(
    email: $email
    password: $password
    firstName: $firstName
    lastName: $lastName
    countryId: $countryId
    state: $state
    city: $city
    postcode: $postcode
    address: $address
    dateOfBirth: $dateOfBirth
    username: $username
    termsAndConditions: $termsAndConditions
  )
}
    `;

/**
 * __useRegisterLooreUserMutation__
 *
 * To run a mutation, you first call `useRegisterLooreUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterLooreUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerLooreUserMutation, { data, loading, error }] = useRegisterLooreUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      countryId: // value for 'countryId'
 *      state: // value for 'state'
 *      city: // value for 'city'
 *      postcode: // value for 'postcode'
 *      address: // value for 'address'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useRegisterLooreUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterLooreUserMutation, RegisterLooreUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterLooreUserMutation, RegisterLooreUserMutationVariables>(RegisterLooreUserDocument, options);
      }
export type RegisterLooreUserMutationHookResult = ReturnType<typeof useRegisterLooreUserMutation>;
export type RegisterLooreUserMutationResult = Apollo.MutationResult<RegisterLooreUserMutation>;
export type RegisterLooreUserMutationOptions = Apollo.BaseMutationOptions<RegisterLooreUserMutation, RegisterLooreUserMutationVariables>;
export const ProductAwenturesViewDocument = gql`
    query ProductAwenturesView($productCodes: [ServiceProductCode!]!) {
  services(productCodes: $productCodes) {
    code
    name
    offers {
      id
      availability
      upgradableSubscriptions {
        id
      }
      currency {
        code
      }
      fullPrice
      discountedPrice
      fullPriceNext
      period {
        code
      }
    }
  }
}
    `;

/**
 * __useProductAwenturesViewQuery__
 *
 * To run a query within a React component, call `useProductAwenturesViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAwenturesViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAwenturesViewQuery({
 *   variables: {
 *      productCodes: // value for 'productCodes'
 *   },
 * });
 */
export function useProductAwenturesViewQuery(baseOptions: Apollo.QueryHookOptions<ProductAwenturesViewQuery, ProductAwenturesViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductAwenturesViewQuery, ProductAwenturesViewQueryVariables>(ProductAwenturesViewDocument, options);
      }
export function useProductAwenturesViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductAwenturesViewQuery, ProductAwenturesViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductAwenturesViewQuery, ProductAwenturesViewQueryVariables>(ProductAwenturesViewDocument, options);
        }
export type ProductAwenturesViewQueryHookResult = ReturnType<typeof useProductAwenturesViewQuery>;
export type ProductAwenturesViewLazyQueryHookResult = ReturnType<typeof useProductAwenturesViewLazyQuery>;
export type ProductAwenturesViewQueryResult = Apollo.QueryResult<ProductAwenturesViewQuery, ProductAwenturesViewQueryVariables>;
export const BankLandingViewQueriesDocument = gql`
    query BankLandingViewQueries {
  bankBasic: service(productCode: BANK_BASIC) {
    code
    offers {
      id
      availability
      upgradableSubscriptions {
        id
      }
      fullPrice
      fullPriceNext
      discountedPrice
      discountedPriceNext
      currency {
        code
      }
      period {
        code
      }
    }
  }
  bankFull: service(productCode: BANK_FULL) {
    code
    offers {
      id
      availability
      upgradableSubscriptions {
        id
      }
      fullPrice
      fullPriceNext
      discountedPrice
      discountedPriceNext
      currency {
        code
      }
      period {
        code
      }
    }
  }
  forex: services(productCodes: [FOREX]) {
    code
    offers {
      id
      availability
    }
  }
}
    `;

/**
 * __useBankLandingViewQueriesQuery__
 *
 * To run a query within a React component, call `useBankLandingViewQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankLandingViewQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankLandingViewQueriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankLandingViewQueriesQuery(baseOptions?: Apollo.QueryHookOptions<BankLandingViewQueriesQuery, BankLandingViewQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankLandingViewQueriesQuery, BankLandingViewQueriesQueryVariables>(BankLandingViewQueriesDocument, options);
      }
export function useBankLandingViewQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankLandingViewQueriesQuery, BankLandingViewQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankLandingViewQueriesQuery, BankLandingViewQueriesQueryVariables>(BankLandingViewQueriesDocument, options);
        }
export type BankLandingViewQueriesQueryHookResult = ReturnType<typeof useBankLandingViewQueriesQuery>;
export type BankLandingViewQueriesLazyQueryHookResult = ReturnType<typeof useBankLandingViewQueriesLazyQuery>;
export type BankLandingViewQueriesQueryResult = Apollo.QueryResult<BankLandingViewQueriesQuery, BankLandingViewQueriesQueryVariables>;
export const ProductBancusViewDocument = gql`
    query ProductBancusView($productCodes: [ServiceProductCode!]!) {
  services(productCodes: $productCodes) {
    code
    name
    offers {
      id
      availability
      upgradableSubscriptions {
        id
      }
      currency {
        code
      }
      fullPrice
      discountedPrice
      fullPriceNext
      period {
        code
      }
    }
  }
}
    `;

/**
 * __useProductBancusViewQuery__
 *
 * To run a query within a React component, call `useProductBancusViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBancusViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBancusViewQuery({
 *   variables: {
 *      productCodes: // value for 'productCodes'
 *   },
 * });
 */
export function useProductBancusViewQuery(baseOptions: Apollo.QueryHookOptions<ProductBancusViewQuery, ProductBancusViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductBancusViewQuery, ProductBancusViewQueryVariables>(ProductBancusViewDocument, options);
      }
export function useProductBancusViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductBancusViewQuery, ProductBancusViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductBancusViewQuery, ProductBancusViewQueryVariables>(ProductBancusViewDocument, options);
        }
export type ProductBancusViewQueryHookResult = ReturnType<typeof useProductBancusViewQuery>;
export type ProductBancusViewLazyQueryHookResult = ReturnType<typeof useProductBancusViewLazyQuery>;
export type ProductBancusViewQueryResult = Apollo.QueryResult<ProductBancusViewQuery, ProductBancusViewQueryVariables>;
export const ForexLandingViewQueriesDocument = gql`
    query ForexLandingViewQueries {
  forex: service(productCode: FOREX) {
    ...ForexLandingViewOfferParts
  }
  forexPro: service(productCode: FOREX_PRO) {
    ...ForexLandingViewOfferParts
  }
  bank: services(productCodes: [BANK_BASIC, BANK_FULL]) {
    code
    offers {
      id
      availability
    }
  }
  me {
    forexInsidersAccess
  }
}
    ${ForexLandingViewOfferPartsFragmentDoc}`;

/**
 * __useForexLandingViewQueriesQuery__
 *
 * To run a query within a React component, call `useForexLandingViewQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useForexLandingViewQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForexLandingViewQueriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useForexLandingViewQueriesQuery(baseOptions?: Apollo.QueryHookOptions<ForexLandingViewQueriesQuery, ForexLandingViewQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ForexLandingViewQueriesQuery, ForexLandingViewQueriesQueryVariables>(ForexLandingViewQueriesDocument, options);
      }
export function useForexLandingViewQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ForexLandingViewQueriesQuery, ForexLandingViewQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ForexLandingViewQueriesQuery, ForexLandingViewQueriesQueryVariables>(ForexLandingViewQueriesDocument, options);
        }
export type ForexLandingViewQueriesQueryHookResult = ReturnType<typeof useForexLandingViewQueriesQuery>;
export type ForexLandingViewQueriesLazyQueryHookResult = ReturnType<typeof useForexLandingViewQueriesLazyQuery>;
export type ForexLandingViewQueriesQueryResult = Apollo.QueryResult<ForexLandingViewQueriesQuery, ForexLandingViewQueriesQueryVariables>;
export const ForexResultsDocument = gql`
    query ForexResults {
  forexStats {
    lastMonthWinRate
    lastMonthBestReturnOfInvestment
    lastYearBestReturnOfInvestment
    updated
  }
}
    `;

/**
 * __useForexResultsQuery__
 *
 * To run a query within a React component, call `useForexResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useForexResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useForexResultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useForexResultsQuery(baseOptions?: Apollo.QueryHookOptions<ForexResultsQuery, ForexResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ForexResultsQuery, ForexResultsQueryVariables>(ForexResultsDocument, options);
      }
export function useForexResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ForexResultsQuery, ForexResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ForexResultsQuery, ForexResultsQueryVariables>(ForexResultsDocument, options);
        }
export type ForexResultsQueryHookResult = ReturnType<typeof useForexResultsQuery>;
export type ForexResultsLazyQueryHookResult = ReturnType<typeof useForexResultsLazyQuery>;
export type ForexResultsQueryResult = Apollo.QueryResult<ForexResultsQuery, ForexResultsQueryVariables>;
export const ProductHunterSystemsViewDocument = gql`
    query ProductHunterSystemsView($productCodes: [ServiceProductCode!]!) {
  services(productCodes: $productCodes) {
    code
    name
    offers {
      id
      availability
      upgradableSubscriptions {
        id
      }
      currency {
        code
      }
      fullPrice
      discountedPrice
      fullPriceNext
      period {
        code
      }
    }
  }
}
    `;

/**
 * __useProductHunterSystemsViewQuery__
 *
 * To run a query within a React component, call `useProductHunterSystemsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductHunterSystemsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductHunterSystemsViewQuery({
 *   variables: {
 *      productCodes: // value for 'productCodes'
 *   },
 * });
 */
export function useProductHunterSystemsViewQuery(baseOptions: Apollo.QueryHookOptions<ProductHunterSystemsViewQuery, ProductHunterSystemsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductHunterSystemsViewQuery, ProductHunterSystemsViewQueryVariables>(ProductHunterSystemsViewDocument, options);
      }
export function useProductHunterSystemsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductHunterSystemsViewQuery, ProductHunterSystemsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductHunterSystemsViewQuery, ProductHunterSystemsViewQueryVariables>(ProductHunterSystemsViewDocument, options);
        }
export type ProductHunterSystemsViewQueryHookResult = ReturnType<typeof useProductHunterSystemsViewQuery>;
export type ProductHunterSystemsViewLazyQueryHookResult = ReturnType<typeof useProductHunterSystemsViewLazyQuery>;
export type ProductHunterSystemsViewQueryResult = Apollo.QueryResult<ProductHunterSystemsViewQuery, ProductHunterSystemsViewQueryVariables>;
export const ProductMemborsAccessViewDocument = gql`
    query ProductMemborsAccessView {
  me {
    membershipAccess
  }
  services(productCodes: [MEMBERSHIP_BASIC, MEMBERSHIP_PRO]) {
    code
    isActive
  }
}
    `;

/**
 * __useProductMemborsAccessViewQuery__
 *
 * To run a query within a React component, call `useProductMemborsAccessViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMemborsAccessViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMemborsAccessViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductMemborsAccessViewQuery(baseOptions?: Apollo.QueryHookOptions<ProductMemborsAccessViewQuery, ProductMemborsAccessViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMemborsAccessViewQuery, ProductMemborsAccessViewQueryVariables>(ProductMemborsAccessViewDocument, options);
      }
export function useProductMemborsAccessViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMemborsAccessViewQuery, ProductMemborsAccessViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMemborsAccessViewQuery, ProductMemborsAccessViewQueryVariables>(ProductMemborsAccessViewDocument, options);
        }
export type ProductMemborsAccessViewQueryHookResult = ReturnType<typeof useProductMemborsAccessViewQuery>;
export type ProductMemborsAccessViewLazyQueryHookResult = ReturnType<typeof useProductMemborsAccessViewLazyQuery>;
export type ProductMemborsAccessViewQueryResult = Apollo.QueryResult<ProductMemborsAccessViewQuery, ProductMemborsAccessViewQueryVariables>;
export const ProductMemborsViewDocument = gql`
    query ProductMemborsView($productCodes: [ServiceProductCode!]!) {
  services(productCodes: $productCodes) {
    code
    name
    offers {
      id
      availability
      upgradableSubscriptions {
        id
      }
      currency {
        code
      }
      fullPrice
      discountedPrice
      fullPriceNext
      period {
        code
      }
    }
  }
}
    `;

/**
 * __useProductMemborsViewQuery__
 *
 * To run a query within a React component, call `useProductMemborsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMemborsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMemborsViewQuery({
 *   variables: {
 *      productCodes: // value for 'productCodes'
 *   },
 * });
 */
export function useProductMemborsViewQuery(baseOptions: Apollo.QueryHookOptions<ProductMemborsViewQuery, ProductMemborsViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMemborsViewQuery, ProductMemborsViewQueryVariables>(ProductMemborsViewDocument, options);
      }
export function useProductMemborsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMemborsViewQuery, ProductMemborsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMemborsViewQuery, ProductMemborsViewQueryVariables>(ProductMemborsViewDocument, options);
        }
export type ProductMemborsViewQueryHookResult = ReturnType<typeof useProductMemborsViewQuery>;
export type ProductMemborsViewLazyQueryHookResult = ReturnType<typeof useProductMemborsViewLazyQuery>;
export type ProductMemborsViewQueryResult = Apollo.QueryResult<ProductMemborsViewQuery, ProductMemborsViewQueryVariables>;
export const TheViewLandingViewQueriesDocument = gql`
    query TheViewLandingViewQueries($productCodes: [ServiceProductCode!]!) {
  services(productCodes: $productCodes) {
    code
    name
    offers {
      id
      availability
      currency {
        code
      }
      fullPrice
      discountedPrice
    }
  }
}
    `;

/**
 * __useTheViewLandingViewQueriesQuery__
 *
 * To run a query within a React component, call `useTheViewLandingViewQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTheViewLandingViewQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTheViewLandingViewQueriesQuery({
 *   variables: {
 *      productCodes: // value for 'productCodes'
 *   },
 * });
 */
export function useTheViewLandingViewQueriesQuery(baseOptions: Apollo.QueryHookOptions<TheViewLandingViewQueriesQuery, TheViewLandingViewQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TheViewLandingViewQueriesQuery, TheViewLandingViewQueriesQueryVariables>(TheViewLandingViewQueriesDocument, options);
      }
export function useTheViewLandingViewQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TheViewLandingViewQueriesQuery, TheViewLandingViewQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TheViewLandingViewQueriesQuery, TheViewLandingViewQueriesQueryVariables>(TheViewLandingViewQueriesDocument, options);
        }
export type TheViewLandingViewQueriesQueryHookResult = ReturnType<typeof useTheViewLandingViewQueriesQuery>;
export type TheViewLandingViewQueriesLazyQueryHookResult = ReturnType<typeof useTheViewLandingViewQueriesLazyQuery>;
export type TheViewLandingViewQueriesQueryResult = Apollo.QueryResult<TheViewLandingViewQueriesQuery, TheViewLandingViewQueriesQueryVariables>;
export const RegisterShopUserDocument = gql`
    mutation RegisterShopUser($email: String!, $password: String!, $affiliateId: String!, $firstName: String!, $lastName: String!, $dateOfBirth: String!, $countryId: Int!, $state: String, $city: String, $postcode: String, $address: String, $phone: String!, $termsAndConditions: Boolean!) {
  registerShopUser(
    email: $email
    password: $password
    affiliateId: $affiliateId
    firstName: $firstName
    lastName: $lastName
    countryId: $countryId
    state: $state
    city: $city
    postcode: $postcode
    address: $address
    dateOfBirth: $dateOfBirth
    phone: $phone
    termsAndConditions: $termsAndConditions
  )
}
    `;

/**
 * __useRegisterShopUserMutation__
 *
 * To run a mutation, you first call `useRegisterShopUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterShopUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerShopUserMutation, { data, loading, error }] = useRegisterShopUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      affiliateId: // value for 'affiliateId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      countryId: // value for 'countryId'
 *      state: // value for 'state'
 *      city: // value for 'city'
 *      postcode: // value for 'postcode'
 *      address: // value for 'address'
 *      phone: // value for 'phone'
 *      termsAndConditions: // value for 'termsAndConditions'
 *   },
 * });
 */
export function useRegisterShopUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterShopUserMutation, RegisterShopUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterShopUserMutation, RegisterShopUserMutationVariables>(RegisterShopUserDocument, options);
      }
export type RegisterShopUserMutationHookResult = ReturnType<typeof useRegisterShopUserMutation>;
export type RegisterShopUserMutationResult = Apollo.MutationResult<RegisterShopUserMutation>;
export type RegisterShopUserMutationOptions = Apollo.BaseMutationOptions<RegisterShopUserMutation, RegisterShopUserMutationVariables>;
export const ChangeForgottenPasswordDocument = gql`
    mutation ChangeForgottenPassword($data: ForgottenPasswordInput!) {
  changeForgottenPassword(data: $data) {
    success
    result {
      type
    }
  }
}
    `;

/**
 * __useChangeForgottenPasswordMutation__
 *
 * To run a mutation, you first call `useChangeForgottenPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeForgottenPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeForgottenPasswordMutation, { data, loading, error }] = useChangeForgottenPasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useChangeForgottenPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeForgottenPasswordMutation, ChangeForgottenPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeForgottenPasswordMutation, ChangeForgottenPasswordMutationVariables>(ChangeForgottenPasswordDocument, options);
      }
export type ChangeForgottenPasswordMutationHookResult = ReturnType<typeof useChangeForgottenPasswordMutation>;
export type ChangeForgottenPasswordMutationResult = Apollo.MutationResult<ChangeForgottenPasswordMutation>;
export type ChangeForgottenPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeForgottenPasswordMutation, ChangeForgottenPasswordMutationVariables>;
export const SfFeeViewDocument = gql`
    query SfFeeView($productCode: ServiceProductCode!) {
  me {
    currency {
      code
    }
  }
  sfFee: serviceOffer(periodCode: TWELVE_MONTHS, productCodes: [$productCode]) {
    availability
    upgradableSubscriptions {
      id
    }
    fullPrice
    discountedPrice
    currency {
      sign
      code
    }
  }
}
    `;

/**
 * __useSfFeeViewQuery__
 *
 * To run a query within a React component, call `useSfFeeViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSfFeeViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSfFeeViewQuery({
 *   variables: {
 *      productCode: // value for 'productCode'
 *   },
 * });
 */
export function useSfFeeViewQuery(baseOptions: Apollo.QueryHookOptions<SfFeeViewQuery, SfFeeViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SfFeeViewQuery, SfFeeViewQueryVariables>(SfFeeViewDocument, options);
      }
export function useSfFeeViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SfFeeViewQuery, SfFeeViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SfFeeViewQuery, SfFeeViewQueryVariables>(SfFeeViewDocument, options);
        }
export type SfFeeViewQueryHookResult = ReturnType<typeof useSfFeeViewQuery>;
export type SfFeeViewLazyQueryHookResult = ReturnType<typeof useSfFeeViewLazyQuery>;
export type SfFeeViewQueryResult = Apollo.QueryResult<SfFeeViewQuery, SfFeeViewQueryVariables>;
export const ValidateDagPackageMutationDocument = gql`
    mutation ValidateDagPackageMutation($activationCode: String!) {
  validateDagPackage(activationCode: $activationCode) {
    price
    baseDags
    baseDagsThreeYears
    escrow {
      one
      two
      three
    }
  }
}
    `;

/**
 * __useValidateDagPackageMutationMutation__
 *
 * To run a mutation, you first call `useValidateDagPackageMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDagPackageMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDagPackageMutationMutation, { data, loading, error }] = useValidateDagPackageMutationMutation({
 *   variables: {
 *      activationCode: // value for 'activationCode'
 *   },
 * });
 */
export function useValidateDagPackageMutationMutation(baseOptions?: Apollo.MutationHookOptions<ValidateDagPackageMutationMutation, ValidateDagPackageMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateDagPackageMutationMutation, ValidateDagPackageMutationMutationVariables>(ValidateDagPackageMutationDocument, options);
      }
export type ValidateDagPackageMutationMutationHookResult = ReturnType<typeof useValidateDagPackageMutationMutation>;
export type ValidateDagPackageMutationMutationResult = Apollo.MutationResult<ValidateDagPackageMutationMutation>;
export type ValidateDagPackageMutationMutationOptions = Apollo.BaseMutationOptions<ValidateDagPackageMutationMutation, ValidateDagPackageMutationMutationVariables>;
export const DoesUsernameExistDocument = gql`
    mutation DoesUsernameExist($username: String!) {
  doesUsernameExist(username: $username)
}
    `;

/**
 * __useDoesUsernameExistMutation__
 *
 * To run a mutation, you first call `useDoesUsernameExistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoesUsernameExistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doesUsernameExistMutation, { data, loading, error }] = useDoesUsernameExistMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useDoesUsernameExistMutation(baseOptions?: Apollo.MutationHookOptions<DoesUsernameExistMutation, DoesUsernameExistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoesUsernameExistMutation, DoesUsernameExistMutationVariables>(DoesUsernameExistDocument, options);
      }
export type DoesUsernameExistMutationHookResult = ReturnType<typeof useDoesUsernameExistMutation>;
export type DoesUsernameExistMutationResult = Apollo.MutationResult<DoesUsernameExistMutation>;
export type DoesUsernameExistMutationOptions = Apollo.BaseMutationOptions<DoesUsernameExistMutation, DoesUsernameExistMutationVariables>;
export const DoesEmailExistDocument = gql`
    mutation DoesEmailExist($email: String!) {
  doesEmailExist(email: $email)
}
    `;

/**
 * __useDoesEmailExistMutation__
 *
 * To run a mutation, you first call `useDoesEmailExistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoesEmailExistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doesEmailExistMutation, { data, loading, error }] = useDoesEmailExistMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDoesEmailExistMutation(baseOptions?: Apollo.MutationHookOptions<DoesEmailExistMutation, DoesEmailExistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoesEmailExistMutation, DoesEmailExistMutationVariables>(DoesEmailExistDocument, options);
      }
export type DoesEmailExistMutationHookResult = ReturnType<typeof useDoesEmailExistMutation>;
export type DoesEmailExistMutationResult = Apollo.MutationResult<DoesEmailExistMutation>;
export type DoesEmailExistMutationOptions = Apollo.BaseMutationOptions<DoesEmailExistMutation, DoesEmailExistMutationVariables>;
export const RegisterInvitedUserDocument = gql`
    mutation RegisterInvitedUser($username: String!, $email: String!, $password: String!, $affiliateId: String!, $firstName: String!, $lastName: String!, $dateOfBirth: String!, $countryId: Int!, $termsAndConditions: Boolean!, $escrowTime: Int, $activationCode: String) {
  registerInvitedUser(
    username: $username
    email: $email
    password: $password
    affiliateId: $affiliateId
    firstName: $firstName
    lastName: $lastName
    countryId: $countryId
    dateOfBirth: $dateOfBirth
    termsAndConditions: $termsAndConditions
    escrowTime: $escrowTime
    activationCode: $activationCode
  )
}
    `;

/**
 * __useRegisterInvitedUserMutation__
 *
 * To run a mutation, you first call `useRegisterInvitedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterInvitedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerInvitedUserMutation, { data, loading, error }] = useRegisterInvitedUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      affiliateId: // value for 'affiliateId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      countryId: // value for 'countryId'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      escrowTime: // value for 'escrowTime'
 *      activationCode: // value for 'activationCode'
 *   },
 * });
 */
export function useRegisterInvitedUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterInvitedUserMutation, RegisterInvitedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterInvitedUserMutation, RegisterInvitedUserMutationVariables>(RegisterInvitedUserDocument, options);
      }
export type RegisterInvitedUserMutationHookResult = ReturnType<typeof useRegisterInvitedUserMutation>;
export type RegisterInvitedUserMutationResult = Apollo.MutationResult<RegisterInvitedUserMutation>;
export type RegisterInvitedUserMutationOptions = Apollo.BaseMutationOptions<RegisterInvitedUserMutation, RegisterInvitedUserMutationVariables>;
export const ValidateAffiliateMutationDocument = gql`
    mutation ValidateAffiliateMutation($affiliateId: String!) {
  validateAffiliate(affiliateId: $affiliateId) {
    user {
      firstName
      lastName
    }
    result {
      ...validationResultInfo
    }
  }
}
    ${ValidationResultInfoFragmentDoc}`;

/**
 * __useValidateAffiliateMutationMutation__
 *
 * To run a mutation, you first call `useValidateAffiliateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAffiliateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAffiliateMutationMutation, { data, loading, error }] = useValidateAffiliateMutationMutation({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *   },
 * });
 */
export function useValidateAffiliateMutationMutation(baseOptions?: Apollo.MutationHookOptions<ValidateAffiliateMutationMutation, ValidateAffiliateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateAffiliateMutationMutation, ValidateAffiliateMutationMutationVariables>(ValidateAffiliateMutationDocument, options);
      }
export type ValidateAffiliateMutationMutationHookResult = ReturnType<typeof useValidateAffiliateMutationMutation>;
export type ValidateAffiliateMutationMutationResult = Apollo.MutationResult<ValidateAffiliateMutationMutation>;
export type ValidateAffiliateMutationMutationOptions = Apollo.BaseMutationOptions<ValidateAffiliateMutationMutation, ValidateAffiliateMutationMutationVariables>;